export const PolicyRegistry = {
    contractName: 'PolicyRegistry',
    abi: [
        {
            constant: true,
            inputs: [
                {
                    name: '',
                    type: 'bytes32'
                }
            ],
            name: 'registry',
            outputs: [
                {
                    name: 'carrier',
                    type: 'address'
                },
                {
                    name: 'insured',
                    type: 'address'
                },
                {
                    name: 'orderHash',
                    type: 'bytes32'
                },
                {
                    name: 'coverage',
                    type: 'uint256'
                },
                {
                    name: 'premium',
                    type: 'uint256'
                },
                {
                    name: 'issuanceBlockTimestamp',
                    type: 'uint256'
                }
            ],
            payable: false,
            stateMutability: 'view',
            type: 'function'
        },
        {
            constant: true,
            inputs: [],
            name: 'policyCount',
            outputs: [
                {
                    name: '',
                    type: 'uint256'
                }
            ],
            payable: false,
            stateMutability: 'view',
            type: 'function'
        },
        {
            constant: true,
            inputs: [],
            name: 'NULL_ISSUANCE_HASH',
            outputs: [
                {
                    name: '',
                    type: 'bytes32'
                }
            ],
            payable: false,
            stateMutability: 'view',
            type: 'function'
        },
        {
            anonymous: false,
            inputs: [
                {
                    indexed: true,
                    name: '_orderHash',
                    type: 'bytes32'
                },
                {
                    indexed: true,
                    name: '_carrier',
                    type: 'address'
                },
                {
                    indexed: true,
                    name: '_insured',
                    type: 'address'
                }
            ],
            name: 'LogPolicyOrderFilled',
            type: 'event'
        },
        {
            anonymous: false,
            inputs: [
                {
                    indexed: true,
                    name: '_errorId',
                    type: 'uint8'
                },
                {
                    indexed: true,
                    name: '_orderHash',
                    type: 'bytes32'
                }
            ],
            name: 'LogError',
            type: 'event'
        },
        {
            constant: false,
            inputs: [
                {
                    name: '_carrier',
                    type: 'address'
                },
                {
                    name: '_orderHash',
                    type: 'bytes32'
                },
                {
                    name: '_quoteHash',
                    type: 'bytes32'
                },
                {
                    name: '_coverage',
                    type: 'uint256'
                },
                {
                    name: '_premium',
                    type: 'uint256'
                },
                {
                    name: '_expirationTimestampInSec',
                    type: 'uint256'
                },
                {
                    name: '_carrierSignatureV',
                    type: 'uint8'
                },
                {
                    name: '_carrierSignatureR',
                    type: 'bytes32'
                },
                {
                    name: '_carrierSignatureS',
                    type: 'bytes32'
                }
            ],
            name: 'fillPolicyOrder',
            outputs: [
                {
                    name: '',
                    type: 'bytes32'
                }
            ],
            payable: false,
            stateMutability: 'nonpayable',
            type: 'function'
        },
        {
            constant: false,
            inputs: [
                {
                    name: '_orderHash',
                    type: 'bytes32'
                }
            ],
            name: 'getPolicyEntry',
            outputs: [
                {
                    name: '',
                    type: 'address'
                },
                {
                    name: '',
                    type: 'address'
                },
                {
                    name: '',
                    type: 'bytes32'
                },
                {
                    name: '',
                    type: 'uint256'
                },
                {
                    name: '',
                    type: 'uint256'
                },
                {
                    name: '',
                    type: 'uint256'
                }
            ],
            payable: false,
            stateMutability: 'nonpayable',
            type: 'function'
        }
    ],
    bytecode:
        '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',
    deployedBytecode:
        '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',
    sourceMap:
        '88:4090:1:-;;;343:1;317:27;;88:4090;8:9:-1;5:2;;;30:1;27;20:12;5:2;88:4090:1;;;;;;;',
    deployedSourceMap:
        '88:4090:1:-;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;2303:521;;8:9:-1;5:2;;;30:1;27;20:12;5:2;2303:521:1;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;355:42;;8:9:-1;5:2;;;30:1;27;20:12;5:2;355:42:1;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;908:1389;;8:9:-1;5:2;;;30:1;27;20:12;5:2;908:1389:1;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;317:27;;8:9:-1;5:2;;;30:1;27;20:12;5:2;317:27:1;;;;;;;;;;;;;;;;;;;;;;;256:55;;8:9:-1;5:2;;;30:1;27;20:12;5:2;256:55:1;;;;;;;;;;;;;;;;;;;;;;;;;;;;;2303:521;2406:7;2427;2448;2469:4;2487;2505;2534:17;2554:8;:20;2563:10;2554:20;;;;;;;;;;;;;;;;;2534:40;;2605:11;:19;;;;;;;;;;;;2638:11;:19;;;;;;;;;;;;2671:11;:21;;;2706:11;:20;;;2740:11;:19;;;2773:11;:34;;;2584:233;;;;;;;;;;;;2303:521;;;;;;;;:::o;355:42::-;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;:::o;908:1389::-;1246:7;1786:18;;:::i;:::-;1403:86;1439:25;1478:10;1403:22;:86::i;:::-;1402:87;:322;;;;1506:218;1551:10;1579;1607:8;1633:18;1669;1705;1506:27;:218::i;:::-;1505:219;1402:322;1398:378;;;309:1;301:10;;1740:25;;;;1398:378;1807:159;;;;;;;;;1826:8;1807:159;;;;;;1848:10;1807:159;;;;;;1872:10;1807:159;;;;;;;1896:9;1807:159;;;;1919:8;1807:159;;;;1941:15;1807:159;;;1786:180;;2157:5;2134:8;:20;2143:10;2134:20;;;;;;;;;;;;;;;;;:28;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;2172:11;;:13;;;;;;;;;;;;;2243:10;2200:54;;2233:8;2200:54;;2221:10;2200:54;;;;;;;;;;;;;2280:10;2273:17;;908:1389;;;;;;;;;;;;;:::o;317:27::-;;;;:::o;256:55::-;309:1;301:10;;256:55;:::o;3464:337::-;3602:4;3653:15;3626:24;:42;3622:152;;;3727:9;3689:48;;;3704:20;3698:27;;;;;;;;3689:48;;;;;;;;;;;;3758:5;3751:12;;;;3622:152;3790:4;3783:11;;3464:337;;;;;:::o;2861:597::-;3120:4;3146:163;3176:7;3197:9;3220:17;3251;3282;3146:16;:163::i;:::-;3145:164;3141:289;;;3383:9;3330:63;;;3345:35;3339:42;;;;;;;;3330:63;;;;;;;;;;;;3414:5;3407:12;;;;3141:289;3447:4;3440:11;;2861:597;;;;;;;;;:::o;3807:369::-;3987:11;4040:129;4109:4;4063:51;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;4128:1;4143;4158;4040:129;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;8:9:-1;5:2;;;45:16;42:1;39;24:38;77:16;74:1;67:27;5:2;4040:129:1;;;;;;;;4030:139;;:6;:139;;;4023:146;;3807:369;;;;;;;:::o;88:4090::-;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;:::o',
    source:
        'pragma solidity ^ 0.4.18;\n\nimport "openzeppelin-solidity/contracts/math/SafeMath.sol";\n\ncontract PolicyRegistry {\n    using SafeMath for uint;\n\n    enum Errors {\n        POLICY_ISSUED,\n        ORDER_EXPIRED,\n        ORDER_INVALID_NON_CONSENSUAL\n    }\n\n    bytes32 constant public NULL_ISSUANCE_HASH = bytes32(0);\n    uint public policyCount = 0;\n    \n    mapping (bytes32 => Entry) public registry;\n\n    event LogPolicyOrderFilled(\n        bytes32 indexed _orderHash,\n        address indexed _carrier,\n        address indexed _insured\n    );\n\n    event LogError(\n        uint8 indexed _errorId,\n        bytes32 indexed _orderHash\n    );\n\n    struct Entry {\n        address carrier;\n        address insured;\n        bytes32 orderHash;\n        uint coverage;\n        uint premium;\n        uint issuanceBlockTimestamp;\n    }\n\n    /**\n     * Fills a given policy order if it is valid and consensual.\n     */\n    function fillPolicyOrder(\n        address _carrier,\n        bytes32 _orderHash,\n        bytes32 _quoteHash,\n        uint _coverage,\n        uint _premium,\n        uint _expirationTimestampInSec,\n        uint8 _carrierSignatureV,\n        bytes32 _carrierSignatureR,\n        bytes32 _carrierSignatureS\n    )\n        public\n        returns (bytes32)\n    {\n        // TODO: Needs to compare params hash to quoteHash otherwise signature is useless\n        // Check policy order is valid\n        if (!assertPolicyOrderValid(\n            _expirationTimestampInSec,\n            _orderHash) ||\n            !assertPolicyOrderConsensual(\n                _orderHash,\n                _quoteHash,\n                _carrier,\n                _carrierSignatureV,\n                _carrierSignatureR,\n                _carrierSignatureS)) {\n            return NULL_ISSUANCE_HASH;\n        }\n\n        Entry memory entry = Entry(\n            _carrier,\n            msg.sender,\n            _orderHash,\n            _coverage,\n            _premium,\n            block.timestamp\n        );\n\n        // Should we create a separate issuanceHash?\n        // The benefit being that the issuaneHash would be based on the \n        // Entry not the Order\n        registry[_orderHash] = entry;\n        policyCount++;\n        emit LogPolicyOrderFilled(_orderHash, _carrier, msg.sender);\n        \n        return _orderHash;\n    }\n\n    function getPolicyEntry(\n        bytes32 _orderHash\n    )\n        public\n        returns (\n            address,\n            address,\n            bytes32,\n            uint,\n            uint,\n            uint\n        )\n    {\n        Entry policyEntry = registry[_orderHash];\n        return (\n            policyEntry.carrier,\n            policyEntry.insured,\n            policyEntry.orderHash,\n            policyEntry.coverage,\n            policyEntry.premium,\n            policyEntry.issuanceBlockTimestamp\n        );\n    }\n\n    /** Internal functions */\n\n    function assertPolicyOrderConsensual(\n        bytes32 orderHash,\n        bytes32 quoteHash,\n        address carrier,\n        uint8 carrierSignatureV,\n        bytes32 carrierSignatureR,\n        bytes32 carrierSignatureS\n    )\n        internal\n        returns (bool)\n    {\n\n        if (!isValidSignature(\n            carrier,\n            quoteHash,\n            carrierSignatureV,\n            carrierSignatureR,\n            carrierSignatureS\n        )) {\n            emit LogError(uint8(Errors.ORDER_INVALID_NON_CONSENSUAL), orderHash);\n            return false;\n        }\n\n        return true;\n    }\n\n    function assertPolicyOrderValid(\n        uint expirationTimestampInSec,\n        bytes32 orderHash\n    )\n        internal\n        returns (bool)\n    {\n        if (expirationTimestampInSec < block.timestamp) {\n            emit LogError(uint8(Errors.ORDER_EXPIRED), orderHash);\n            return false;\n        }\n        return true;\n    }\n\n    function isValidSignature(\n        address signer,\n        bytes32 hash,\n        uint8 v,\n        bytes32 r,\n        bytes32 s\n    )\n        internal\n        pure\n        returns (bool _valid)\n    {\n        \n        return signer == ecrecover(\n            keccak256("\\x19Ethereum Signed Message:\\n32", hash),\n            v,\n            r,\n            s\n        );\n    }\n}',
    sourcePath:
        '/Users/tyndall/Documents/Projects/asekuro-relayer-frontend/contracts/PolicyRegistry.sol',
    ast: {
        absolutePath:
            '/Users/tyndall/Documents/Projects/asekuro-relayer-frontend/contracts/PolicyRegistry.sol',
        exportedSymbols: {
            PolicyRegistry: [314]
        },
        id: 315,
        nodeType: 'SourceUnit',
        nodes: [
            {
                id: 58,
                literals: ['solidity', '^', '0.4', '.18'],
                nodeType: 'PragmaDirective',
                src: '0:25:1'
            },
            {
                absolutePath: 'openzeppelin-solidity/contracts/math/SafeMath.sol',
                file: 'openzeppelin-solidity/contracts/math/SafeMath.sol',
                id: 59,
                nodeType: 'ImportDirective',
                scope: 315,
                sourceUnit: 409,
                src: '27:59:1',
                symbolAliases: [],
                unitAlias: ''
            },
            {
                baseContracts: [],
                contractDependencies: [],
                contractKind: 'contract',
                documentation: null,
                fullyImplemented: true,
                id: 314,
                linearizedBaseContracts: [314],
                name: 'PolicyRegistry',
                nodeType: 'ContractDefinition',
                nodes: [
                    {
                        id: 62,
                        libraryName: {
                            contractScope: null,
                            id: 60,
                            name: 'SafeMath',
                            nodeType: 'UserDefinedTypeName',
                            referencedDeclaration: 408,
                            src: '124:8:1',
                            typeDescriptions: {
                                typeIdentifier: 't_contract$_SafeMath_$408',
                                typeString: 'library SafeMath'
                            }
                        },
                        nodeType: 'UsingForDirective',
                        src: '118:24:1',
                        typeName: {
                            id: 61,
                            name: 'uint',
                            nodeType: 'ElementaryTypeName',
                            src: '137:4:1',
                            typeDescriptions: {
                                typeIdentifier: 't_uint256',
                                typeString: 'uint256'
                            }
                        }
                    },
                    {
                        canonicalName: 'PolicyRegistry.Errors',
                        id: 66,
                        members: [
                            {
                                id: 63,
                                name: 'POLICY_ISSUED',
                                nodeType: 'EnumValue',
                                src: '170:13:1'
                            },
                            {
                                id: 64,
                                name: 'ORDER_EXPIRED',
                                nodeType: 'EnumValue',
                                src: '193:13:1'
                            },
                            {
                                id: 65,
                                name: 'ORDER_INVALID_NON_CONSENSUAL',
                                nodeType: 'EnumValue',
                                src: '216:28:1'
                            }
                        ],
                        name: 'Errors',
                        nodeType: 'EnumDefinition',
                        src: '148:102:1'
                    },
                    {
                        constant: true,
                        id: 71,
                        name: 'NULL_ISSUANCE_HASH',
                        nodeType: 'VariableDeclaration',
                        scope: 314,
                        src: '256:55:1',
                        stateVariable: true,
                        storageLocation: 'default',
                        typeDescriptions: {
                            typeIdentifier: 't_bytes32',
                            typeString: 'bytes32'
                        },
                        typeName: {
                            id: 67,
                            name: 'bytes32',
                            nodeType: 'ElementaryTypeName',
                            src: '256:7:1',
                            typeDescriptions: {
                                typeIdentifier: 't_bytes32',
                                typeString: 'bytes32'
                            }
                        },
                        value: {
                            argumentTypes: null,
                            arguments: [
                                {
                                    argumentTypes: null,
                                    hexValue: '30',
                                    id: 69,
                                    isConstant: false,
                                    isLValue: false,
                                    isPure: true,
                                    kind: 'number',
                                    lValueRequested: false,
                                    nodeType: 'Literal',
                                    src: '309:1:1',
                                    subdenomination: null,
                                    typeDescriptions: {
                                        typeIdentifier: 't_rational_0_by_1',
                                        typeString: 'int_const 0'
                                    },
                                    value: '0'
                                }
                            ],
                            expression: {
                                argumentTypes: [
                                    {
                                        typeIdentifier: 't_rational_0_by_1',
                                        typeString: 'int_const 0'
                                    }
                                ],
                                id: 68,
                                isConstant: false,
                                isLValue: false,
                                isPure: true,
                                lValueRequested: false,
                                nodeType: 'ElementaryTypeNameExpression',
                                src: '301:7:1',
                                typeDescriptions: {
                                    typeIdentifier: 't_type$_t_bytes32_$',
                                    typeString: 'type(bytes32)'
                                },
                                typeName: 'bytes32'
                            },
                            id: 70,
                            isConstant: false,
                            isLValue: false,
                            isPure: true,
                            kind: 'typeConversion',
                            lValueRequested: false,
                            names: [],
                            nodeType: 'FunctionCall',
                            src: '301:10:1',
                            typeDescriptions: {
                                typeIdentifier: 't_bytes32',
                                typeString: 'bytes32'
                            }
                        },
                        visibility: 'public'
                    },
                    {
                        constant: false,
                        id: 74,
                        name: 'policyCount',
                        nodeType: 'VariableDeclaration',
                        scope: 314,
                        src: '317:27:1',
                        stateVariable: true,
                        storageLocation: 'default',
                        typeDescriptions: {
                            typeIdentifier: 't_uint256',
                            typeString: 'uint256'
                        },
                        typeName: {
                            id: 72,
                            name: 'uint',
                            nodeType: 'ElementaryTypeName',
                            src: '317:4:1',
                            typeDescriptions: {
                                typeIdentifier: 't_uint256',
                                typeString: 'uint256'
                            }
                        },
                        value: {
                            argumentTypes: null,
                            hexValue: '30',
                            id: 73,
                            isConstant: false,
                            isLValue: false,
                            isPure: true,
                            kind: 'number',
                            lValueRequested: false,
                            nodeType: 'Literal',
                            src: '343:1:1',
                            subdenomination: null,
                            typeDescriptions: {
                                typeIdentifier: 't_rational_0_by_1',
                                typeString: 'int_const 0'
                            },
                            value: '0'
                        },
                        visibility: 'public'
                    },
                    {
                        constant: false,
                        id: 78,
                        name: 'registry',
                        nodeType: 'VariableDeclaration',
                        scope: 314,
                        src: '355:42:1',
                        stateVariable: true,
                        storageLocation: 'default',
                        typeDescriptions: {
                            typeIdentifier: 't_mapping$_t_bytes32_$_t_struct$_Entry_$105_storage_$',
                            typeString: 'mapping(bytes32 => struct PolicyRegistry.Entry)'
                        },
                        typeName: {
                            id: 77,
                            keyType: {
                                id: 75,
                                name: 'bytes32',
                                nodeType: 'ElementaryTypeName',
                                src: '364:7:1',
                                typeDescriptions: {
                                    typeIdentifier: 't_bytes32',
                                    typeString: 'bytes32'
                                }
                            },
                            nodeType: 'Mapping',
                            src: '355:26:1',
                            typeDescriptions: {
                                typeIdentifier:
                                    't_mapping$_t_bytes32_$_t_struct$_Entry_$105_storage_$',
                                typeString: 'mapping(bytes32 => struct PolicyRegistry.Entry)'
                            },
                            valueType: {
                                contractScope: null,
                                id: 76,
                                name: 'Entry',
                                nodeType: 'UserDefinedTypeName',
                                referencedDeclaration: 105,
                                src: '375:5:1',
                                typeDescriptions: {
                                    typeIdentifier: 't_struct$_Entry_$105_storage_ptr',
                                    typeString: 'struct PolicyRegistry.Entry'
                                }
                            }
                        },
                        value: null,
                        visibility: 'public'
                    },
                    {
                        anonymous: false,
                        documentation: null,
                        id: 86,
                        name: 'LogPolicyOrderFilled',
                        nodeType: 'EventDefinition',
                        parameters: {
                            id: 85,
                            nodeType: 'ParameterList',
                            parameters: [
                                {
                                    constant: false,
                                    id: 80,
                                    indexed: true,
                                    name: '_orderHash',
                                    nodeType: 'VariableDeclaration',
                                    scope: 86,
                                    src: '440:26:1',
                                    stateVariable: false,
                                    storageLocation: 'default',
                                    typeDescriptions: {
                                        typeIdentifier: 't_bytes32',
                                        typeString: 'bytes32'
                                    },
                                    typeName: {
                                        id: 79,
                                        name: 'bytes32',
                                        nodeType: 'ElementaryTypeName',
                                        src: '440:7:1',
                                        typeDescriptions: {
                                            typeIdentifier: 't_bytes32',
                                            typeString: 'bytes32'
                                        }
                                    },
                                    value: null,
                                    visibility: 'internal'
                                },
                                {
                                    constant: false,
                                    id: 82,
                                    indexed: true,
                                    name: '_carrier',
                                    nodeType: 'VariableDeclaration',
                                    scope: 86,
                                    src: '476:24:1',
                                    stateVariable: false,
                                    storageLocation: 'default',
                                    typeDescriptions: {
                                        typeIdentifier: 't_address',
                                        typeString: 'address'
                                    },
                                    typeName: {
                                        id: 81,
                                        name: 'address',
                                        nodeType: 'ElementaryTypeName',
                                        src: '476:7:1',
                                        typeDescriptions: {
                                            typeIdentifier: 't_address',
                                            typeString: 'address'
                                        }
                                    },
                                    value: null,
                                    visibility: 'internal'
                                },
                                {
                                    constant: false,
                                    id: 84,
                                    indexed: true,
                                    name: '_insured',
                                    nodeType: 'VariableDeclaration',
                                    scope: 86,
                                    src: '510:24:1',
                                    stateVariable: false,
                                    storageLocation: 'default',
                                    typeDescriptions: {
                                        typeIdentifier: 't_address',
                                        typeString: 'address'
                                    },
                                    typeName: {
                                        id: 83,
                                        name: 'address',
                                        nodeType: 'ElementaryTypeName',
                                        src: '510:7:1',
                                        typeDescriptions: {
                                            typeIdentifier: 't_address',
                                            typeString: 'address'
                                        }
                                    },
                                    value: null,
                                    visibility: 'internal'
                                }
                            ],
                            src: '430:110:1'
                        },
                        src: '404:137:1'
                    },
                    {
                        anonymous: false,
                        documentation: null,
                        id: 92,
                        name: 'LogError',
                        nodeType: 'EventDefinition',
                        parameters: {
                            id: 91,
                            nodeType: 'ParameterList',
                            parameters: [
                                {
                                    constant: false,
                                    id: 88,
                                    indexed: true,
                                    name: '_errorId',
                                    nodeType: 'VariableDeclaration',
                                    scope: 92,
                                    src: '571:22:1',
                                    stateVariable: false,
                                    storageLocation: 'default',
                                    typeDescriptions: {
                                        typeIdentifier: 't_uint8',
                                        typeString: 'uint8'
                                    },
                                    typeName: {
                                        id: 87,
                                        name: 'uint8',
                                        nodeType: 'ElementaryTypeName',
                                        src: '571:5:1',
                                        typeDescriptions: {
                                            typeIdentifier: 't_uint8',
                                            typeString: 'uint8'
                                        }
                                    },
                                    value: null,
                                    visibility: 'internal'
                                },
                                {
                                    constant: false,
                                    id: 90,
                                    indexed: true,
                                    name: '_orderHash',
                                    nodeType: 'VariableDeclaration',
                                    scope: 92,
                                    src: '603:26:1',
                                    stateVariable: false,
                                    storageLocation: 'default',
                                    typeDescriptions: {
                                        typeIdentifier: 't_bytes32',
                                        typeString: 'bytes32'
                                    },
                                    typeName: {
                                        id: 89,
                                        name: 'bytes32',
                                        nodeType: 'ElementaryTypeName',
                                        src: '603:7:1',
                                        typeDescriptions: {
                                            typeIdentifier: 't_bytes32',
                                            typeString: 'bytes32'
                                        }
                                    },
                                    value: null,
                                    visibility: 'internal'
                                }
                            ],
                            src: '561:74:1'
                        },
                        src: '547:89:1'
                    },
                    {
                        canonicalName: 'PolicyRegistry.Entry',
                        id: 105,
                        members: [
                            {
                                constant: false,
                                id: 94,
                                name: 'carrier',
                                nodeType: 'VariableDeclaration',
                                scope: 105,
                                src: '665:15:1',
                                stateVariable: false,
                                storageLocation: 'default',
                                typeDescriptions: {
                                    typeIdentifier: 't_address',
                                    typeString: 'address'
                                },
                                typeName: {
                                    id: 93,
                                    name: 'address',
                                    nodeType: 'ElementaryTypeName',
                                    src: '665:7:1',
                                    typeDescriptions: {
                                        typeIdentifier: 't_address',
                                        typeString: 'address'
                                    }
                                },
                                value: null,
                                visibility: 'internal'
                            },
                            {
                                constant: false,
                                id: 96,
                                name: 'insured',
                                nodeType: 'VariableDeclaration',
                                scope: 105,
                                src: '690:15:1',
                                stateVariable: false,
                                storageLocation: 'default',
                                typeDescriptions: {
                                    typeIdentifier: 't_address',
                                    typeString: 'address'
                                },
                                typeName: {
                                    id: 95,
                                    name: 'address',
                                    nodeType: 'ElementaryTypeName',
                                    src: '690:7:1',
                                    typeDescriptions: {
                                        typeIdentifier: 't_address',
                                        typeString: 'address'
                                    }
                                },
                                value: null,
                                visibility: 'internal'
                            },
                            {
                                constant: false,
                                id: 98,
                                name: 'orderHash',
                                nodeType: 'VariableDeclaration',
                                scope: 105,
                                src: '715:17:1',
                                stateVariable: false,
                                storageLocation: 'default',
                                typeDescriptions: {
                                    typeIdentifier: 't_bytes32',
                                    typeString: 'bytes32'
                                },
                                typeName: {
                                    id: 97,
                                    name: 'bytes32',
                                    nodeType: 'ElementaryTypeName',
                                    src: '715:7:1',
                                    typeDescriptions: {
                                        typeIdentifier: 't_bytes32',
                                        typeString: 'bytes32'
                                    }
                                },
                                value: null,
                                visibility: 'internal'
                            },
                            {
                                constant: false,
                                id: 100,
                                name: 'coverage',
                                nodeType: 'VariableDeclaration',
                                scope: 105,
                                src: '742:13:1',
                                stateVariable: false,
                                storageLocation: 'default',
                                typeDescriptions: {
                                    typeIdentifier: 't_uint256',
                                    typeString: 'uint256'
                                },
                                typeName: {
                                    id: 99,
                                    name: 'uint',
                                    nodeType: 'ElementaryTypeName',
                                    src: '742:4:1',
                                    typeDescriptions: {
                                        typeIdentifier: 't_uint256',
                                        typeString: 'uint256'
                                    }
                                },
                                value: null,
                                visibility: 'internal'
                            },
                            {
                                constant: false,
                                id: 102,
                                name: 'premium',
                                nodeType: 'VariableDeclaration',
                                scope: 105,
                                src: '765:12:1',
                                stateVariable: false,
                                storageLocation: 'default',
                                typeDescriptions: {
                                    typeIdentifier: 't_uint256',
                                    typeString: 'uint256'
                                },
                                typeName: {
                                    id: 101,
                                    name: 'uint',
                                    nodeType: 'ElementaryTypeName',
                                    src: '765:4:1',
                                    typeDescriptions: {
                                        typeIdentifier: 't_uint256',
                                        typeString: 'uint256'
                                    }
                                },
                                value: null,
                                visibility: 'internal'
                            },
                            {
                                constant: false,
                                id: 104,
                                name: 'issuanceBlockTimestamp',
                                nodeType: 'VariableDeclaration',
                                scope: 105,
                                src: '787:27:1',
                                stateVariable: false,
                                storageLocation: 'default',
                                typeDescriptions: {
                                    typeIdentifier: 't_uint256',
                                    typeString: 'uint256'
                                },
                                typeName: {
                                    id: 103,
                                    name: 'uint',
                                    nodeType: 'ElementaryTypeName',
                                    src: '787:4:1',
                                    typeDescriptions: {
                                        typeIdentifier: 't_uint256',
                                        typeString: 'uint256'
                                    }
                                },
                                value: null,
                                visibility: 'internal'
                            }
                        ],
                        name: 'Entry',
                        nodeType: 'StructDefinition',
                        scope: 314,
                        src: '642:179:1',
                        visibility: 'public'
                    },
                    {
                        body: {
                            id: 178,
                            nodeType: 'Block',
                            src: '1259:1038:1',
                            statements: [
                                {
                                    condition: {
                                        argumentTypes: null,
                                        commonType: {
                                            typeIdentifier: 't_bool',
                                            typeString: 'bool'
                                        },
                                        id: 142,
                                        isConstant: false,
                                        isLValue: false,
                                        isPure: false,
                                        lValueRequested: false,
                                        leftExpression: {
                                            argumentTypes: null,
                                            id: 132,
                                            isConstant: false,
                                            isLValue: false,
                                            isPure: false,
                                            lValueRequested: false,
                                            nodeType: 'UnaryOperation',
                                            operator: '!',
                                            prefix: true,
                                            src: '1402:87:1',
                                            subExpression: {
                                                argumentTypes: null,
                                                arguments: [
                                                    {
                                                        argumentTypes: null,
                                                        id: 129,
                                                        name: '_expirationTimestampInSec',
                                                        nodeType: 'Identifier',
                                                        overloadedDeclarations: [],
                                                        referencedDeclaration: 117,
                                                        src: '1439:25:1',
                                                        typeDescriptions: {
                                                            typeIdentifier: 't_uint256',
                                                            typeString: 'uint256'
                                                        }
                                                    },
                                                    {
                                                        argumentTypes: null,
                                                        id: 130,
                                                        name: '_orderHash',
                                                        nodeType: 'Identifier',
                                                        overloadedDeclarations: [],
                                                        referencedDeclaration: 109,
                                                        src: '1478:10:1',
                                                        typeDescriptions: {
                                                            typeIdentifier: 't_bytes32',
                                                            typeString: 'bytes32'
                                                        }
                                                    }
                                                ],
                                                expression: {
                                                    argumentTypes: [
                                                        {
                                                            typeIdentifier: 't_uint256',
                                                            typeString: 'uint256'
                                                        },
                                                        {
                                                            typeIdentifier: 't_bytes32',
                                                            typeString: 'bytes32'
                                                        }
                                                    ],
                                                    id: 128,
                                                    name: 'assertPolicyOrderValid',
                                                    nodeType: 'Identifier',
                                                    overloadedDeclarations: [],
                                                    referencedDeclaration: 285,
                                                    src: '1403:22:1',
                                                    typeDescriptions: {
                                                        typeIdentifier:
                                                            't_function_internal_nonpayable$_t_uint256_$_t_bytes32_$returns$_t_bool_$',
                                                        typeString:
                                                            'function (uint256,bytes32) returns (bool)'
                                                    }
                                                },
                                                id: 131,
                                                isConstant: false,
                                                isLValue: false,
                                                isPure: false,
                                                kind: 'functionCall',
                                                lValueRequested: false,
                                                names: [],
                                                nodeType: 'FunctionCall',
                                                src: '1403:86:1',
                                                typeDescriptions: {
                                                    typeIdentifier: 't_bool',
                                                    typeString: 'bool'
                                                }
                                            },
                                            typeDescriptions: {
                                                typeIdentifier: 't_bool',
                                                typeString: 'bool'
                                            }
                                        },
                                        nodeType: 'BinaryOperation',
                                        operator: '||',
                                        rightExpression: {
                                            argumentTypes: null,
                                            id: 141,
                                            isConstant: false,
                                            isLValue: false,
                                            isPure: false,
                                            lValueRequested: false,
                                            nodeType: 'UnaryOperation',
                                            operator: '!',
                                            prefix: true,
                                            src: '1505:219:1',
                                            subExpression: {
                                                argumentTypes: null,
                                                arguments: [
                                                    {
                                                        argumentTypes: null,
                                                        id: 134,
                                                        name: '_orderHash',
                                                        nodeType: 'Identifier',
                                                        overloadedDeclarations: [],
                                                        referencedDeclaration: 109,
                                                        src: '1551:10:1',
                                                        typeDescriptions: {
                                                            typeIdentifier: 't_bytes32',
                                                            typeString: 'bytes32'
                                                        }
                                                    },
                                                    {
                                                        argumentTypes: null,
                                                        id: 135,
                                                        name: '_quoteHash',
                                                        nodeType: 'Identifier',
                                                        overloadedDeclarations: [],
                                                        referencedDeclaration: 111,
                                                        src: '1579:10:1',
                                                        typeDescriptions: {
                                                            typeIdentifier: 't_bytes32',
                                                            typeString: 'bytes32'
                                                        }
                                                    },
                                                    {
                                                        argumentTypes: null,
                                                        id: 136,
                                                        name: '_carrier',
                                                        nodeType: 'Identifier',
                                                        overloadedDeclarations: [],
                                                        referencedDeclaration: 107,
                                                        src: '1607:8:1',
                                                        typeDescriptions: {
                                                            typeIdentifier: 't_address',
                                                            typeString: 'address'
                                                        }
                                                    },
                                                    {
                                                        argumentTypes: null,
                                                        id: 137,
                                                        name: '_carrierSignatureV',
                                                        nodeType: 'Identifier',
                                                        overloadedDeclarations: [],
                                                        referencedDeclaration: 119,
                                                        src: '1633:18:1',
                                                        typeDescriptions: {
                                                            typeIdentifier: 't_uint8',
                                                            typeString: 'uint8'
                                                        }
                                                    },
                                                    {
                                                        argumentTypes: null,
                                                        id: 138,
                                                        name: '_carrierSignatureR',
                                                        nodeType: 'Identifier',
                                                        overloadedDeclarations: [],
                                                        referencedDeclaration: 121,
                                                        src: '1669:18:1',
                                                        typeDescriptions: {
                                                            typeIdentifier: 't_bytes32',
                                                            typeString: 'bytes32'
                                                        }
                                                    },
                                                    {
                                                        argumentTypes: null,
                                                        id: 139,
                                                        name: '_carrierSignatureS',
                                                        nodeType: 'Identifier',
                                                        overloadedDeclarations: [],
                                                        referencedDeclaration: 123,
                                                        src: '1705:18:1',
                                                        typeDescriptions: {
                                                            typeIdentifier: 't_bytes32',
                                                            typeString: 'bytes32'
                                                        }
                                                    }
                                                ],
                                                expression: {
                                                    argumentTypes: [
                                                        {
                                                            typeIdentifier: 't_bytes32',
                                                            typeString: 'bytes32'
                                                        },
                                                        {
                                                            typeIdentifier: 't_bytes32',
                                                            typeString: 'bytes32'
                                                        },
                                                        {
                                                            typeIdentifier: 't_address',
                                                            typeString: 'address'
                                                        },
                                                        {
                                                            typeIdentifier: 't_uint8',
                                                            typeString: 'uint8'
                                                        },
                                                        {
                                                            typeIdentifier: 't_bytes32',
                                                            typeString: 'bytes32'
                                                        },
                                                        {
                                                            typeIdentifier: 't_bytes32',
                                                            typeString: 'bytes32'
                                                        }
                                                    ],
                                                    id: 133,
                                                    name: 'assertPolicyOrderConsensual',
                                                    nodeType: 'Identifier',
                                                    overloadedDeclarations: [],
                                                    referencedDeclaration: 257,
                                                    src: '1506:27:1',
                                                    typeDescriptions: {
                                                        typeIdentifier:
                                                            't_function_internal_nonpayable$_t_bytes32_$_t_bytes32_$_t_address_$_t_uint8_$_t_bytes32_$_t_bytes32_$returns$_t_bool_$',
                                                        typeString:
                                                            'function (bytes32,bytes32,address,uint8,bytes32,bytes32) returns (bool)'
                                                    }
                                                },
                                                id: 140,
                                                isConstant: false,
                                                isLValue: false,
                                                isPure: false,
                                                kind: 'functionCall',
                                                lValueRequested: false,
                                                names: [],
                                                nodeType: 'FunctionCall',
                                                src: '1506:218:1',
                                                typeDescriptions: {
                                                    typeIdentifier: 't_bool',
                                                    typeString: 'bool'
                                                }
                                            },
                                            typeDescriptions: {
                                                typeIdentifier: 't_bool',
                                                typeString: 'bool'
                                            }
                                        },
                                        src: '1402:322:1',
                                        typeDescriptions: {
                                            typeIdentifier: 't_bool',
                                            typeString: 'bool'
                                        }
                                    },
                                    falseBody: null,
                                    id: 146,
                                    nodeType: 'IfStatement',
                                    src: '1398:378:1',
                                    trueBody: {
                                        id: 145,
                                        nodeType: 'Block',
                                        src: '1726:50:1',
                                        statements: [
                                            {
                                                expression: {
                                                    argumentTypes: null,
                                                    id: 143,
                                                    name: 'NULL_ISSUANCE_HASH',
                                                    nodeType: 'Identifier',
                                                    overloadedDeclarations: [],
                                                    referencedDeclaration: 71,
                                                    src: '1747:18:1',
                                                    typeDescriptions: {
                                                        typeIdentifier: 't_bytes32',
                                                        typeString: 'bytes32'
                                                    }
                                                },
                                                functionReturnParameters: 127,
                                                id: 144,
                                                nodeType: 'Return',
                                                src: '1740:25:1'
                                            }
                                        ]
                                    }
                                },
                                {
                                    assignments: [148],
                                    declarations: [
                                        {
                                            constant: false,
                                            id: 148,
                                            name: 'entry',
                                            nodeType: 'VariableDeclaration',
                                            scope: 179,
                                            src: '1786:18:1',
                                            stateVariable: false,
                                            storageLocation: 'memory',
                                            typeDescriptions: {
                                                typeIdentifier: 't_struct$_Entry_$105_memory_ptr',
                                                typeString: 'struct PolicyRegistry.Entry'
                                            },
                                            typeName: {
                                                contractScope: null,
                                                id: 147,
                                                name: 'Entry',
                                                nodeType: 'UserDefinedTypeName',
                                                referencedDeclaration: 105,
                                                src: '1786:5:1',
                                                typeDescriptions: {
                                                    typeIdentifier:
                                                        't_struct$_Entry_$105_storage_ptr',
                                                    typeString: 'struct PolicyRegistry.Entry'
                                                }
                                            },
                                            value: null,
                                            visibility: 'internal'
                                        }
                                    ],
                                    id: 159,
                                    initialValue: {
                                        argumentTypes: null,
                                        arguments: [
                                            {
                                                argumentTypes: null,
                                                id: 150,
                                                name: '_carrier',
                                                nodeType: 'Identifier',
                                                overloadedDeclarations: [],
                                                referencedDeclaration: 107,
                                                src: '1826:8:1',
                                                typeDescriptions: {
                                                    typeIdentifier: 't_address',
                                                    typeString: 'address'
                                                }
                                            },
                                            {
                                                argumentTypes: null,
                                                expression: {
                                                    argumentTypes: null,
                                                    id: 151,
                                                    name: 'msg',
                                                    nodeType: 'Identifier',
                                                    overloadedDeclarations: [],
                                                    referencedDeclaration: 423,
                                                    src: '1848:3:1',
                                                    typeDescriptions: {
                                                        typeIdentifier: 't_magic_message',
                                                        typeString: 'msg'
                                                    }
                                                },
                                                id: 152,
                                                isConstant: false,
                                                isLValue: false,
                                                isPure: false,
                                                lValueRequested: false,
                                                memberName: 'sender',
                                                nodeType: 'MemberAccess',
                                                referencedDeclaration: null,
                                                src: '1848:10:1',
                                                typeDescriptions: {
                                                    typeIdentifier: 't_address',
                                                    typeString: 'address'
                                                }
                                            },
                                            {
                                                argumentTypes: null,
                                                id: 153,
                                                name: '_orderHash',
                                                nodeType: 'Identifier',
                                                overloadedDeclarations: [],
                                                referencedDeclaration: 109,
                                                src: '1872:10:1',
                                                typeDescriptions: {
                                                    typeIdentifier: 't_bytes32',
                                                    typeString: 'bytes32'
                                                }
                                            },
                                            {
                                                argumentTypes: null,
                                                id: 154,
                                                name: '_coverage',
                                                nodeType: 'Identifier',
                                                overloadedDeclarations: [],
                                                referencedDeclaration: 113,
                                                src: '1896:9:1',
                                                typeDescriptions: {
                                                    typeIdentifier: 't_uint256',
                                                    typeString: 'uint256'
                                                }
                                            },
                                            {
                                                argumentTypes: null,
                                                id: 155,
                                                name: '_premium',
                                                nodeType: 'Identifier',
                                                overloadedDeclarations: [],
                                                referencedDeclaration: 115,
                                                src: '1919:8:1',
                                                typeDescriptions: {
                                                    typeIdentifier: 't_uint256',
                                                    typeString: 'uint256'
                                                }
                                            },
                                            {
                                                argumentTypes: null,
                                                expression: {
                                                    argumentTypes: null,
                                                    id: 156,
                                                    name: 'block',
                                                    nodeType: 'Identifier',
                                                    overloadedDeclarations: [],
                                                    referencedDeclaration: 413,
                                                    src: '1941:5:1',
                                                    typeDescriptions: {
                                                        typeIdentifier: 't_magic_block',
                                                        typeString: 'block'
                                                    }
                                                },
                                                id: 157,
                                                isConstant: false,
                                                isLValue: false,
                                                isPure: false,
                                                lValueRequested: false,
                                                memberName: 'timestamp',
                                                nodeType: 'MemberAccess',
                                                referencedDeclaration: null,
                                                src: '1941:15:1',
                                                typeDescriptions: {
                                                    typeIdentifier: 't_uint256',
                                                    typeString: 'uint256'
                                                }
                                            }
                                        ],
                                        expression: {
                                            argumentTypes: [
                                                {
                                                    typeIdentifier: 't_address',
                                                    typeString: 'address'
                                                },
                                                {
                                                    typeIdentifier: 't_address',
                                                    typeString: 'address'
                                                },
                                                {
                                                    typeIdentifier: 't_bytes32',
                                                    typeString: 'bytes32'
                                                },
                                                {
                                                    typeIdentifier: 't_uint256',
                                                    typeString: 'uint256'
                                                },
                                                {
                                                    typeIdentifier: 't_uint256',
                                                    typeString: 'uint256'
                                                },
                                                {
                                                    typeIdentifier: 't_uint256',
                                                    typeString: 'uint256'
                                                }
                                            ],
                                            id: 149,
                                            name: 'Entry',
                                            nodeType: 'Identifier',
                                            overloadedDeclarations: [],
                                            referencedDeclaration: 105,
                                            src: '1807:5:1',
                                            typeDescriptions: {
                                                typeIdentifier:
                                                    't_type$_t_struct$_Entry_$105_storage_ptr_$',
                                                typeString:
                                                    'type(struct PolicyRegistry.Entry storage pointer)'
                                            }
                                        },
                                        id: 158,
                                        isConstant: false,
                                        isLValue: false,
                                        isPure: false,
                                        kind: 'structConstructorCall',
                                        lValueRequested: false,
                                        names: [],
                                        nodeType: 'FunctionCall',
                                        src: '1807:159:1',
                                        typeDescriptions: {
                                            typeIdentifier: 't_struct$_Entry_$105_memory',
                                            typeString: 'struct PolicyRegistry.Entry memory'
                                        }
                                    },
                                    nodeType: 'VariableDeclarationStatement',
                                    src: '1786:180:1'
                                },
                                {
                                    expression: {
                                        argumentTypes: null,
                                        id: 164,
                                        isConstant: false,
                                        isLValue: false,
                                        isPure: false,
                                        lValueRequested: false,
                                        leftHandSide: {
                                            argumentTypes: null,
                                            baseExpression: {
                                                argumentTypes: null,
                                                id: 160,
                                                name: 'registry',
                                                nodeType: 'Identifier',
                                                overloadedDeclarations: [],
                                                referencedDeclaration: 78,
                                                src: '2134:8:1',
                                                typeDescriptions: {
                                                    typeIdentifier:
                                                        't_mapping$_t_bytes32_$_t_struct$_Entry_$105_storage_$',
                                                    typeString:
                                                        'mapping(bytes32 => struct PolicyRegistry.Entry storage ref)'
                                                }
                                            },
                                            id: 162,
                                            indexExpression: {
                                                argumentTypes: null,
                                                id: 161,
                                                name: '_orderHash',
                                                nodeType: 'Identifier',
                                                overloadedDeclarations: [],
                                                referencedDeclaration: 109,
                                                src: '2143:10:1',
                                                typeDescriptions: {
                                                    typeIdentifier: 't_bytes32',
                                                    typeString: 'bytes32'
                                                }
                                            },
                                            isConstant: false,
                                            isLValue: true,
                                            isPure: false,
                                            lValueRequested: true,
                                            nodeType: 'IndexAccess',
                                            src: '2134:20:1',
                                            typeDescriptions: {
                                                typeIdentifier: 't_struct$_Entry_$105_storage',
                                                typeString:
                                                    'struct PolicyRegistry.Entry storage ref'
                                            }
                                        },
                                        nodeType: 'Assignment',
                                        operator: '=',
                                        rightHandSide: {
                                            argumentTypes: null,
                                            id: 163,
                                            name: 'entry',
                                            nodeType: 'Identifier',
                                            overloadedDeclarations: [],
                                            referencedDeclaration: 148,
                                            src: '2157:5:1',
                                            typeDescriptions: {
                                                typeIdentifier: 't_struct$_Entry_$105_memory_ptr',
                                                typeString: 'struct PolicyRegistry.Entry memory'
                                            }
                                        },
                                        src: '2134:28:1',
                                        typeDescriptions: {
                                            typeIdentifier: 't_struct$_Entry_$105_storage',
                                            typeString: 'struct PolicyRegistry.Entry storage ref'
                                        }
                                    },
                                    id: 165,
                                    nodeType: 'ExpressionStatement',
                                    src: '2134:28:1'
                                },
                                {
                                    expression: {
                                        argumentTypes: null,
                                        id: 167,
                                        isConstant: false,
                                        isLValue: false,
                                        isPure: false,
                                        lValueRequested: false,
                                        nodeType: 'UnaryOperation',
                                        operator: '++',
                                        prefix: false,
                                        src: '2172:13:1',
                                        subExpression: {
                                            argumentTypes: null,
                                            id: 166,
                                            name: 'policyCount',
                                            nodeType: 'Identifier',
                                            overloadedDeclarations: [],
                                            referencedDeclaration: 74,
                                            src: '2172:11:1',
                                            typeDescriptions: {
                                                typeIdentifier: 't_uint256',
                                                typeString: 'uint256'
                                            }
                                        },
                                        typeDescriptions: {
                                            typeIdentifier: 't_uint256',
                                            typeString: 'uint256'
                                        }
                                    },
                                    id: 168,
                                    nodeType: 'ExpressionStatement',
                                    src: '2172:13:1'
                                },
                                {
                                    eventCall: {
                                        argumentTypes: null,
                                        arguments: [
                                            {
                                                argumentTypes: null,
                                                id: 170,
                                                name: '_orderHash',
                                                nodeType: 'Identifier',
                                                overloadedDeclarations: [],
                                                referencedDeclaration: 109,
                                                src: '2221:10:1',
                                                typeDescriptions: {
                                                    typeIdentifier: 't_bytes32',
                                                    typeString: 'bytes32'
                                                }
                                            },
                                            {
                                                argumentTypes: null,
                                                id: 171,
                                                name: '_carrier',
                                                nodeType: 'Identifier',
                                                overloadedDeclarations: [],
                                                referencedDeclaration: 107,
                                                src: '2233:8:1',
                                                typeDescriptions: {
                                                    typeIdentifier: 't_address',
                                                    typeString: 'address'
                                                }
                                            },
                                            {
                                                argumentTypes: null,
                                                expression: {
                                                    argumentTypes: null,
                                                    id: 172,
                                                    name: 'msg',
                                                    nodeType: 'Identifier',
                                                    overloadedDeclarations: [],
                                                    referencedDeclaration: 423,
                                                    src: '2243:3:1',
                                                    typeDescriptions: {
                                                        typeIdentifier: 't_magic_message',
                                                        typeString: 'msg'
                                                    }
                                                },
                                                id: 173,
                                                isConstant: false,
                                                isLValue: false,
                                                isPure: false,
                                                lValueRequested: false,
                                                memberName: 'sender',
                                                nodeType: 'MemberAccess',
                                                referencedDeclaration: null,
                                                src: '2243:10:1',
                                                typeDescriptions: {
                                                    typeIdentifier: 't_address',
                                                    typeString: 'address'
                                                }
                                            }
                                        ],
                                        expression: {
                                            argumentTypes: [
                                                {
                                                    typeIdentifier: 't_bytes32',
                                                    typeString: 'bytes32'
                                                },
                                                {
                                                    typeIdentifier: 't_address',
                                                    typeString: 'address'
                                                },
                                                {
                                                    typeIdentifier: 't_address',
                                                    typeString: 'address'
                                                }
                                            ],
                                            id: 169,
                                            name: 'LogPolicyOrderFilled',
                                            nodeType: 'Identifier',
                                            overloadedDeclarations: [],
                                            referencedDeclaration: 86,
                                            src: '2200:20:1',
                                            typeDescriptions: {
                                                typeIdentifier:
                                                    't_function_event_nonpayable$_t_bytes32_$_t_address_$_t_address_$returns$__$',
                                                typeString: 'function (bytes32,address,address)'
                                            }
                                        },
                                        id: 174,
                                        isConstant: false,
                                        isLValue: false,
                                        isPure: false,
                                        kind: 'functionCall',
                                        lValueRequested: false,
                                        names: [],
                                        nodeType: 'FunctionCall',
                                        src: '2200:54:1',
                                        typeDescriptions: {
                                            typeIdentifier: 't_tuple$__$',
                                            typeString: 'tuple()'
                                        }
                                    },
                                    id: 175,
                                    nodeType: 'EmitStatement',
                                    src: '2195:59:1'
                                },
                                {
                                    expression: {
                                        argumentTypes: null,
                                        id: 176,
                                        name: '_orderHash',
                                        nodeType: 'Identifier',
                                        overloadedDeclarations: [],
                                        referencedDeclaration: 109,
                                        src: '2280:10:1',
                                        typeDescriptions: {
                                            typeIdentifier: 't_bytes32',
                                            typeString: 'bytes32'
                                        }
                                    },
                                    functionReturnParameters: 127,
                                    id: 177,
                                    nodeType: 'Return',
                                    src: '2273:17:1'
                                }
                            ]
                        },
                        documentation: 'Fills a given policy order if it is valid and consensual.',
                        id: 179,
                        implemented: true,
                        isConstructor: false,
                        isDeclaredConst: false,
                        modifiers: [],
                        name: 'fillPolicyOrder',
                        nodeType: 'FunctionDefinition',
                        parameters: {
                            id: 124,
                            nodeType: 'ParameterList',
                            parameters: [
                                {
                                    constant: false,
                                    id: 107,
                                    name: '_carrier',
                                    nodeType: 'VariableDeclaration',
                                    scope: 179,
                                    src: '942:16:1',
                                    stateVariable: false,
                                    storageLocation: 'default',
                                    typeDescriptions: {
                                        typeIdentifier: 't_address',
                                        typeString: 'address'
                                    },
                                    typeName: {
                                        id: 106,
                                        name: 'address',
                                        nodeType: 'ElementaryTypeName',
                                        src: '942:7:1',
                                        typeDescriptions: {
                                            typeIdentifier: 't_address',
                                            typeString: 'address'
                                        }
                                    },
                                    value: null,
                                    visibility: 'internal'
                                },
                                {
                                    constant: false,
                                    id: 109,
                                    name: '_orderHash',
                                    nodeType: 'VariableDeclaration',
                                    scope: 179,
                                    src: '968:18:1',
                                    stateVariable: false,
                                    storageLocation: 'default',
                                    typeDescriptions: {
                                        typeIdentifier: 't_bytes32',
                                        typeString: 'bytes32'
                                    },
                                    typeName: {
                                        id: 108,
                                        name: 'bytes32',
                                        nodeType: 'ElementaryTypeName',
                                        src: '968:7:1',
                                        typeDescriptions: {
                                            typeIdentifier: 't_bytes32',
                                            typeString: 'bytes32'
                                        }
                                    },
                                    value: null,
                                    visibility: 'internal'
                                },
                                {
                                    constant: false,
                                    id: 111,
                                    name: '_quoteHash',
                                    nodeType: 'VariableDeclaration',
                                    scope: 179,
                                    src: '996:18:1',
                                    stateVariable: false,
                                    storageLocation: 'default',
                                    typeDescriptions: {
                                        typeIdentifier: 't_bytes32',
                                        typeString: 'bytes32'
                                    },
                                    typeName: {
                                        id: 110,
                                        name: 'bytes32',
                                        nodeType: 'ElementaryTypeName',
                                        src: '996:7:1',
                                        typeDescriptions: {
                                            typeIdentifier: 't_bytes32',
                                            typeString: 'bytes32'
                                        }
                                    },
                                    value: null,
                                    visibility: 'internal'
                                },
                                {
                                    constant: false,
                                    id: 113,
                                    name: '_coverage',
                                    nodeType: 'VariableDeclaration',
                                    scope: 179,
                                    src: '1024:14:1',
                                    stateVariable: false,
                                    storageLocation: 'default',
                                    typeDescriptions: {
                                        typeIdentifier: 't_uint256',
                                        typeString: 'uint256'
                                    },
                                    typeName: {
                                        id: 112,
                                        name: 'uint',
                                        nodeType: 'ElementaryTypeName',
                                        src: '1024:4:1',
                                        typeDescriptions: {
                                            typeIdentifier: 't_uint256',
                                            typeString: 'uint256'
                                        }
                                    },
                                    value: null,
                                    visibility: 'internal'
                                },
                                {
                                    constant: false,
                                    id: 115,
                                    name: '_premium',
                                    nodeType: 'VariableDeclaration',
                                    scope: 179,
                                    src: '1048:13:1',
                                    stateVariable: false,
                                    storageLocation: 'default',
                                    typeDescriptions: {
                                        typeIdentifier: 't_uint256',
                                        typeString: 'uint256'
                                    },
                                    typeName: {
                                        id: 114,
                                        name: 'uint',
                                        nodeType: 'ElementaryTypeName',
                                        src: '1048:4:1',
                                        typeDescriptions: {
                                            typeIdentifier: 't_uint256',
                                            typeString: 'uint256'
                                        }
                                    },
                                    value: null,
                                    visibility: 'internal'
                                },
                                {
                                    constant: false,
                                    id: 117,
                                    name: '_expirationTimestampInSec',
                                    nodeType: 'VariableDeclaration',
                                    scope: 179,
                                    src: '1071:30:1',
                                    stateVariable: false,
                                    storageLocation: 'default',
                                    typeDescriptions: {
                                        typeIdentifier: 't_uint256',
                                        typeString: 'uint256'
                                    },
                                    typeName: {
                                        id: 116,
                                        name: 'uint',
                                        nodeType: 'ElementaryTypeName',
                                        src: '1071:4:1',
                                        typeDescriptions: {
                                            typeIdentifier: 't_uint256',
                                            typeString: 'uint256'
                                        }
                                    },
                                    value: null,
                                    visibility: 'internal'
                                },
                                {
                                    constant: false,
                                    id: 119,
                                    name: '_carrierSignatureV',
                                    nodeType: 'VariableDeclaration',
                                    scope: 179,
                                    src: '1111:24:1',
                                    stateVariable: false,
                                    storageLocation: 'default',
                                    typeDescriptions: {
                                        typeIdentifier: 't_uint8',
                                        typeString: 'uint8'
                                    },
                                    typeName: {
                                        id: 118,
                                        name: 'uint8',
                                        nodeType: 'ElementaryTypeName',
                                        src: '1111:5:1',
                                        typeDescriptions: {
                                            typeIdentifier: 't_uint8',
                                            typeString: 'uint8'
                                        }
                                    },
                                    value: null,
                                    visibility: 'internal'
                                },
                                {
                                    constant: false,
                                    id: 121,
                                    name: '_carrierSignatureR',
                                    nodeType: 'VariableDeclaration',
                                    scope: 179,
                                    src: '1145:26:1',
                                    stateVariable: false,
                                    storageLocation: 'default',
                                    typeDescriptions: {
                                        typeIdentifier: 't_bytes32',
                                        typeString: 'bytes32'
                                    },
                                    typeName: {
                                        id: 120,
                                        name: 'bytes32',
                                        nodeType: 'ElementaryTypeName',
                                        src: '1145:7:1',
                                        typeDescriptions: {
                                            typeIdentifier: 't_bytes32',
                                            typeString: 'bytes32'
                                        }
                                    },
                                    value: null,
                                    visibility: 'internal'
                                },
                                {
                                    constant: false,
                                    id: 123,
                                    name: '_carrierSignatureS',
                                    nodeType: 'VariableDeclaration',
                                    scope: 179,
                                    src: '1181:26:1',
                                    stateVariable: false,
                                    storageLocation: 'default',
                                    typeDescriptions: {
                                        typeIdentifier: 't_bytes32',
                                        typeString: 'bytes32'
                                    },
                                    typeName: {
                                        id: 122,
                                        name: 'bytes32',
                                        nodeType: 'ElementaryTypeName',
                                        src: '1181:7:1',
                                        typeDescriptions: {
                                            typeIdentifier: 't_bytes32',
                                            typeString: 'bytes32'
                                        }
                                    },
                                    value: null,
                                    visibility: 'internal'
                                }
                            ],
                            src: '932:281:1'
                        },
                        payable: false,
                        returnParameters: {
                            id: 127,
                            nodeType: 'ParameterList',
                            parameters: [
                                {
                                    constant: false,
                                    id: 126,
                                    name: '',
                                    nodeType: 'VariableDeclaration',
                                    scope: 179,
                                    src: '1246:7:1',
                                    stateVariable: false,
                                    storageLocation: 'default',
                                    typeDescriptions: {
                                        typeIdentifier: 't_bytes32',
                                        typeString: 'bytes32'
                                    },
                                    typeName: {
                                        id: 125,
                                        name: 'bytes32',
                                        nodeType: 'ElementaryTypeName',
                                        src: '1246:7:1',
                                        typeDescriptions: {
                                            typeIdentifier: 't_bytes32',
                                            typeString: 'bytes32'
                                        }
                                    },
                                    value: null,
                                    visibility: 'internal'
                                }
                            ],
                            src: '1245:9:1'
                        },
                        scope: 314,
                        src: '908:1389:1',
                        stateMutability: 'nonpayable',
                        superFunction: null,
                        visibility: 'public'
                    },
                    {
                        body: {
                            id: 216,
                            nodeType: 'Block',
                            src: '2524:300:1',
                            statements: [
                                {
                                    assignments: [197],
                                    declarations: [
                                        {
                                            constant: false,
                                            id: 197,
                                            name: 'policyEntry',
                                            nodeType: 'VariableDeclaration',
                                            scope: 217,
                                            src: '2534:17:1',
                                            stateVariable: false,
                                            storageLocation: 'default',
                                            typeDescriptions: {
                                                typeIdentifier: 't_struct$_Entry_$105_storage_ptr',
                                                typeString: 'struct PolicyRegistry.Entry'
                                            },
                                            typeName: {
                                                contractScope: null,
                                                id: 196,
                                                name: 'Entry',
                                                nodeType: 'UserDefinedTypeName',
                                                referencedDeclaration: 105,
                                                src: '2534:5:1',
                                                typeDescriptions: {
                                                    typeIdentifier:
                                                        't_struct$_Entry_$105_storage_ptr',
                                                    typeString: 'struct PolicyRegistry.Entry'
                                                }
                                            },
                                            value: null,
                                            visibility: 'internal'
                                        }
                                    ],
                                    id: 201,
                                    initialValue: {
                                        argumentTypes: null,
                                        baseExpression: {
                                            argumentTypes: null,
                                            id: 198,
                                            name: 'registry',
                                            nodeType: 'Identifier',
                                            overloadedDeclarations: [],
                                            referencedDeclaration: 78,
                                            src: '2554:8:1',
                                            typeDescriptions: {
                                                typeIdentifier:
                                                    't_mapping$_t_bytes32_$_t_struct$_Entry_$105_storage_$',
                                                typeString:
                                                    'mapping(bytes32 => struct PolicyRegistry.Entry storage ref)'
                                            }
                                        },
                                        id: 200,
                                        indexExpression: {
                                            argumentTypes: null,
                                            id: 199,
                                            name: '_orderHash',
                                            nodeType: 'Identifier',
                                            overloadedDeclarations: [],
                                            referencedDeclaration: 181,
                                            src: '2563:10:1',
                                            typeDescriptions: {
                                                typeIdentifier: 't_bytes32',
                                                typeString: 'bytes32'
                                            }
                                        },
                                        isConstant: false,
                                        isLValue: true,
                                        isPure: false,
                                        lValueRequested: false,
                                        nodeType: 'IndexAccess',
                                        src: '2554:20:1',
                                        typeDescriptions: {
                                            typeIdentifier: 't_struct$_Entry_$105_storage',
                                            typeString: 'struct PolicyRegistry.Entry storage ref'
                                        }
                                    },
                                    nodeType: 'VariableDeclarationStatement',
                                    src: '2534:40:1'
                                },
                                {
                                    expression: {
                                        argumentTypes: null,
                                        components: [
                                            {
                                                argumentTypes: null,
                                                expression: {
                                                    argumentTypes: null,
                                                    id: 202,
                                                    name: 'policyEntry',
                                                    nodeType: 'Identifier',
                                                    overloadedDeclarations: [],
                                                    referencedDeclaration: 197,
                                                    src: '2605:11:1',
                                                    typeDescriptions: {
                                                        typeIdentifier:
                                                            't_struct$_Entry_$105_storage_ptr',
                                                        typeString:
                                                            'struct PolicyRegistry.Entry storage pointer'
                                                    }
                                                },
                                                id: 203,
                                                isConstant: false,
                                                isLValue: true,
                                                isPure: false,
                                                lValueRequested: false,
                                                memberName: 'carrier',
                                                nodeType: 'MemberAccess',
                                                referencedDeclaration: 94,
                                                src: '2605:19:1',
                                                typeDescriptions: {
                                                    typeIdentifier: 't_address',
                                                    typeString: 'address'
                                                }
                                            },
                                            {
                                                argumentTypes: null,
                                                expression: {
                                                    argumentTypes: null,
                                                    id: 204,
                                                    name: 'policyEntry',
                                                    nodeType: 'Identifier',
                                                    overloadedDeclarations: [],
                                                    referencedDeclaration: 197,
                                                    src: '2638:11:1',
                                                    typeDescriptions: {
                                                        typeIdentifier:
                                                            't_struct$_Entry_$105_storage_ptr',
                                                        typeString:
                                                            'struct PolicyRegistry.Entry storage pointer'
                                                    }
                                                },
                                                id: 205,
                                                isConstant: false,
                                                isLValue: true,
                                                isPure: false,
                                                lValueRequested: false,
                                                memberName: 'insured',
                                                nodeType: 'MemberAccess',
                                                referencedDeclaration: 96,
                                                src: '2638:19:1',
                                                typeDescriptions: {
                                                    typeIdentifier: 't_address',
                                                    typeString: 'address'
                                                }
                                            },
                                            {
                                                argumentTypes: null,
                                                expression: {
                                                    argumentTypes: null,
                                                    id: 206,
                                                    name: 'policyEntry',
                                                    nodeType: 'Identifier',
                                                    overloadedDeclarations: [],
                                                    referencedDeclaration: 197,
                                                    src: '2671:11:1',
                                                    typeDescriptions: {
                                                        typeIdentifier:
                                                            't_struct$_Entry_$105_storage_ptr',
                                                        typeString:
                                                            'struct PolicyRegistry.Entry storage pointer'
                                                    }
                                                },
                                                id: 207,
                                                isConstant: false,
                                                isLValue: true,
                                                isPure: false,
                                                lValueRequested: false,
                                                memberName: 'orderHash',
                                                nodeType: 'MemberAccess',
                                                referencedDeclaration: 98,
                                                src: '2671:21:1',
                                                typeDescriptions: {
                                                    typeIdentifier: 't_bytes32',
                                                    typeString: 'bytes32'
                                                }
                                            },
                                            {
                                                argumentTypes: null,
                                                expression: {
                                                    argumentTypes: null,
                                                    id: 208,
                                                    name: 'policyEntry',
                                                    nodeType: 'Identifier',
                                                    overloadedDeclarations: [],
                                                    referencedDeclaration: 197,
                                                    src: '2706:11:1',
                                                    typeDescriptions: {
                                                        typeIdentifier:
                                                            't_struct$_Entry_$105_storage_ptr',
                                                        typeString:
                                                            'struct PolicyRegistry.Entry storage pointer'
                                                    }
                                                },
                                                id: 209,
                                                isConstant: false,
                                                isLValue: true,
                                                isPure: false,
                                                lValueRequested: false,
                                                memberName: 'coverage',
                                                nodeType: 'MemberAccess',
                                                referencedDeclaration: 100,
                                                src: '2706:20:1',
                                                typeDescriptions: {
                                                    typeIdentifier: 't_uint256',
                                                    typeString: 'uint256'
                                                }
                                            },
                                            {
                                                argumentTypes: null,
                                                expression: {
                                                    argumentTypes: null,
                                                    id: 210,
                                                    name: 'policyEntry',
                                                    nodeType: 'Identifier',
                                                    overloadedDeclarations: [],
                                                    referencedDeclaration: 197,
                                                    src: '2740:11:1',
                                                    typeDescriptions: {
                                                        typeIdentifier:
                                                            't_struct$_Entry_$105_storage_ptr',
                                                        typeString:
                                                            'struct PolicyRegistry.Entry storage pointer'
                                                    }
                                                },
                                                id: 211,
                                                isConstant: false,
                                                isLValue: true,
                                                isPure: false,
                                                lValueRequested: false,
                                                memberName: 'premium',
                                                nodeType: 'MemberAccess',
                                                referencedDeclaration: 102,
                                                src: '2740:19:1',
                                                typeDescriptions: {
                                                    typeIdentifier: 't_uint256',
                                                    typeString: 'uint256'
                                                }
                                            },
                                            {
                                                argumentTypes: null,
                                                expression: {
                                                    argumentTypes: null,
                                                    id: 212,
                                                    name: 'policyEntry',
                                                    nodeType: 'Identifier',
                                                    overloadedDeclarations: [],
                                                    referencedDeclaration: 197,
                                                    src: '2773:11:1',
                                                    typeDescriptions: {
                                                        typeIdentifier:
                                                            't_struct$_Entry_$105_storage_ptr',
                                                        typeString:
                                                            'struct PolicyRegistry.Entry storage pointer'
                                                    }
                                                },
                                                id: 213,
                                                isConstant: false,
                                                isLValue: true,
                                                isPure: false,
                                                lValueRequested: false,
                                                memberName: 'issuanceBlockTimestamp',
                                                nodeType: 'MemberAccess',
                                                referencedDeclaration: 104,
                                                src: '2773:34:1',
                                                typeDescriptions: {
                                                    typeIdentifier: 't_uint256',
                                                    typeString: 'uint256'
                                                }
                                            }
                                        ],
                                        id: 214,
                                        isConstant: false,
                                        isInlineArray: false,
                                        isLValue: false,
                                        isPure: false,
                                        lValueRequested: false,
                                        nodeType: 'TupleExpression',
                                        src: '2591:226:1',
                                        typeDescriptions: {
                                            typeIdentifier:
                                                't_tuple$_t_address_$_t_address_$_t_bytes32_$_t_uint256_$_t_uint256_$_t_uint256_$',
                                            typeString:
                                                'tuple(address,address,bytes32,uint256,uint256,uint256)'
                                        }
                                    },
                                    functionReturnParameters: 195,
                                    id: 215,
                                    nodeType: 'Return',
                                    src: '2584:233:1'
                                }
                            ]
                        },
                        documentation: null,
                        id: 217,
                        implemented: true,
                        isConstructor: false,
                        isDeclaredConst: false,
                        modifiers: [],
                        name: 'getPolicyEntry',
                        nodeType: 'FunctionDefinition',
                        parameters: {
                            id: 182,
                            nodeType: 'ParameterList',
                            parameters: [
                                {
                                    constant: false,
                                    id: 181,
                                    name: '_orderHash',
                                    nodeType: 'VariableDeclaration',
                                    scope: 217,
                                    src: '2336:18:1',
                                    stateVariable: false,
                                    storageLocation: 'default',
                                    typeDescriptions: {
                                        typeIdentifier: 't_bytes32',
                                        typeString: 'bytes32'
                                    },
                                    typeName: {
                                        id: 180,
                                        name: 'bytes32',
                                        nodeType: 'ElementaryTypeName',
                                        src: '2336:7:1',
                                        typeDescriptions: {
                                            typeIdentifier: 't_bytes32',
                                            typeString: 'bytes32'
                                        }
                                    },
                                    value: null,
                                    visibility: 'internal'
                                }
                            ],
                            src: '2326:34:1'
                        },
                        payable: false,
                        returnParameters: {
                            id: 195,
                            nodeType: 'ParameterList',
                            parameters: [
                                {
                                    constant: false,
                                    id: 184,
                                    name: '',
                                    nodeType: 'VariableDeclaration',
                                    scope: 217,
                                    src: '2406:7:1',
                                    stateVariable: false,
                                    storageLocation: 'default',
                                    typeDescriptions: {
                                        typeIdentifier: 't_address',
                                        typeString: 'address'
                                    },
                                    typeName: {
                                        id: 183,
                                        name: 'address',
                                        nodeType: 'ElementaryTypeName',
                                        src: '2406:7:1',
                                        typeDescriptions: {
                                            typeIdentifier: 't_address',
                                            typeString: 'address'
                                        }
                                    },
                                    value: null,
                                    visibility: 'internal'
                                },
                                {
                                    constant: false,
                                    id: 186,
                                    name: '',
                                    nodeType: 'VariableDeclaration',
                                    scope: 217,
                                    src: '2427:7:1',
                                    stateVariable: false,
                                    storageLocation: 'default',
                                    typeDescriptions: {
                                        typeIdentifier: 't_address',
                                        typeString: 'address'
                                    },
                                    typeName: {
                                        id: 185,
                                        name: 'address',
                                        nodeType: 'ElementaryTypeName',
                                        src: '2427:7:1',
                                        typeDescriptions: {
                                            typeIdentifier: 't_address',
                                            typeString: 'address'
                                        }
                                    },
                                    value: null,
                                    visibility: 'internal'
                                },
                                {
                                    constant: false,
                                    id: 188,
                                    name: '',
                                    nodeType: 'VariableDeclaration',
                                    scope: 217,
                                    src: '2448:7:1',
                                    stateVariable: false,
                                    storageLocation: 'default',
                                    typeDescriptions: {
                                        typeIdentifier: 't_bytes32',
                                        typeString: 'bytes32'
                                    },
                                    typeName: {
                                        id: 187,
                                        name: 'bytes32',
                                        nodeType: 'ElementaryTypeName',
                                        src: '2448:7:1',
                                        typeDescriptions: {
                                            typeIdentifier: 't_bytes32',
                                            typeString: 'bytes32'
                                        }
                                    },
                                    value: null,
                                    visibility: 'internal'
                                },
                                {
                                    constant: false,
                                    id: 190,
                                    name: '',
                                    nodeType: 'VariableDeclaration',
                                    scope: 217,
                                    src: '2469:4:1',
                                    stateVariable: false,
                                    storageLocation: 'default',
                                    typeDescriptions: {
                                        typeIdentifier: 't_uint256',
                                        typeString: 'uint256'
                                    },
                                    typeName: {
                                        id: 189,
                                        name: 'uint',
                                        nodeType: 'ElementaryTypeName',
                                        src: '2469:4:1',
                                        typeDescriptions: {
                                            typeIdentifier: 't_uint256',
                                            typeString: 'uint256'
                                        }
                                    },
                                    value: null,
                                    visibility: 'internal'
                                },
                                {
                                    constant: false,
                                    id: 192,
                                    name: '',
                                    nodeType: 'VariableDeclaration',
                                    scope: 217,
                                    src: '2487:4:1',
                                    stateVariable: false,
                                    storageLocation: 'default',
                                    typeDescriptions: {
                                        typeIdentifier: 't_uint256',
                                        typeString: 'uint256'
                                    },
                                    typeName: {
                                        id: 191,
                                        name: 'uint',
                                        nodeType: 'ElementaryTypeName',
                                        src: '2487:4:1',
                                        typeDescriptions: {
                                            typeIdentifier: 't_uint256',
                                            typeString: 'uint256'
                                        }
                                    },
                                    value: null,
                                    visibility: 'internal'
                                },
                                {
                                    constant: false,
                                    id: 194,
                                    name: '',
                                    nodeType: 'VariableDeclaration',
                                    scope: 217,
                                    src: '2505:4:1',
                                    stateVariable: false,
                                    storageLocation: 'default',
                                    typeDescriptions: {
                                        typeIdentifier: 't_uint256',
                                        typeString: 'uint256'
                                    },
                                    typeName: {
                                        id: 193,
                                        name: 'uint',
                                        nodeType: 'ElementaryTypeName',
                                        src: '2505:4:1',
                                        typeDescriptions: {
                                            typeIdentifier: 't_uint256',
                                            typeString: 'uint256'
                                        }
                                    },
                                    value: null,
                                    visibility: 'internal'
                                }
                            ],
                            src: '2392:127:1'
                        },
                        scope: 314,
                        src: '2303:521:1',
                        stateMutability: 'nonpayable',
                        superFunction: null,
                        visibility: 'public'
                    },
                    {
                        body: {
                            id: 256,
                            nodeType: 'Block',
                            src: '3130:328:1',
                            statements: [
                                {
                                    condition: {
                                        argumentTypes: null,
                                        id: 241,
                                        isConstant: false,
                                        isLValue: false,
                                        isPure: false,
                                        lValueRequested: false,
                                        nodeType: 'UnaryOperation',
                                        operator: '!',
                                        prefix: true,
                                        src: '3145:164:1',
                                        subExpression: {
                                            argumentTypes: null,
                                            arguments: [
                                                {
                                                    argumentTypes: null,
                                                    id: 235,
                                                    name: 'carrier',
                                                    nodeType: 'Identifier',
                                                    overloadedDeclarations: [],
                                                    referencedDeclaration: 223,
                                                    src: '3176:7:1',
                                                    typeDescriptions: {
                                                        typeIdentifier: 't_address',
                                                        typeString: 'address'
                                                    }
                                                },
                                                {
                                                    argumentTypes: null,
                                                    id: 236,
                                                    name: 'quoteHash',
                                                    nodeType: 'Identifier',
                                                    overloadedDeclarations: [],
                                                    referencedDeclaration: 221,
                                                    src: '3197:9:1',
                                                    typeDescriptions: {
                                                        typeIdentifier: 't_bytes32',
                                                        typeString: 'bytes32'
                                                    }
                                                },
                                                {
                                                    argumentTypes: null,
                                                    id: 237,
                                                    name: 'carrierSignatureV',
                                                    nodeType: 'Identifier',
                                                    overloadedDeclarations: [],
                                                    referencedDeclaration: 225,
                                                    src: '3220:17:1',
                                                    typeDescriptions: {
                                                        typeIdentifier: 't_uint8',
                                                        typeString: 'uint8'
                                                    }
                                                },
                                                {
                                                    argumentTypes: null,
                                                    id: 238,
                                                    name: 'carrierSignatureR',
                                                    nodeType: 'Identifier',
                                                    overloadedDeclarations: [],
                                                    referencedDeclaration: 227,
                                                    src: '3251:17:1',
                                                    typeDescriptions: {
                                                        typeIdentifier: 't_bytes32',
                                                        typeString: 'bytes32'
                                                    }
                                                },
                                                {
                                                    argumentTypes: null,
                                                    id: 239,
                                                    name: 'carrierSignatureS',
                                                    nodeType: 'Identifier',
                                                    overloadedDeclarations: [],
                                                    referencedDeclaration: 229,
                                                    src: '3282:17:1',
                                                    typeDescriptions: {
                                                        typeIdentifier: 't_bytes32',
                                                        typeString: 'bytes32'
                                                    }
                                                }
                                            ],
                                            expression: {
                                                argumentTypes: [
                                                    {
                                                        typeIdentifier: 't_address',
                                                        typeString: 'address'
                                                    },
                                                    {
                                                        typeIdentifier: 't_bytes32',
                                                        typeString: 'bytes32'
                                                    },
                                                    {
                                                        typeIdentifier: 't_uint8',
                                                        typeString: 'uint8'
                                                    },
                                                    {
                                                        typeIdentifier: 't_bytes32',
                                                        typeString: 'bytes32'
                                                    },
                                                    {
                                                        typeIdentifier: 't_bytes32',
                                                        typeString: 'bytes32'
                                                    }
                                                ],
                                                id: 234,
                                                name: 'isValidSignature',
                                                nodeType: 'Identifier',
                                                overloadedDeclarations: [],
                                                referencedDeclaration: 313,
                                                src: '3146:16:1',
                                                typeDescriptions: {
                                                    typeIdentifier:
                                                        't_function_internal_pure$_t_address_$_t_bytes32_$_t_uint8_$_t_bytes32_$_t_bytes32_$returns$_t_bool_$',
                                                    typeString:
                                                        'function (address,bytes32,uint8,bytes32,bytes32) pure returns (bool)'
                                                }
                                            },
                                            id: 240,
                                            isConstant: false,
                                            isLValue: false,
                                            isPure: false,
                                            kind: 'functionCall',
                                            lValueRequested: false,
                                            names: [],
                                            nodeType: 'FunctionCall',
                                            src: '3146:163:1',
                                            typeDescriptions: {
                                                typeIdentifier: 't_bool',
                                                typeString: 'bool'
                                            }
                                        },
                                        typeDescriptions: {
                                            typeIdentifier: 't_bool',
                                            typeString: 'bool'
                                        }
                                    },
                                    falseBody: null,
                                    id: 253,
                                    nodeType: 'IfStatement',
                                    src: '3141:289:1',
                                    trueBody: {
                                        id: 252,
                                        nodeType: 'Block',
                                        src: '3311:119:1',
                                        statements: [
                                            {
                                                eventCall: {
                                                    argumentTypes: null,
                                                    arguments: [
                                                        {
                                                            argumentTypes: null,
                                                            arguments: [
                                                                {
                                                                    argumentTypes: null,
                                                                    expression: {
                                                                        argumentTypes: null,
                                                                        id: 244,
                                                                        name: 'Errors',
                                                                        nodeType: 'Identifier',
                                                                        overloadedDeclarations: [],
                                                                        referencedDeclaration: 66,
                                                                        src: '3345:6:1',
                                                                        typeDescriptions: {
                                                                            typeIdentifier:
                                                                                't_type$_t_enum$_Errors_$66_$',
                                                                            typeString:
                                                                                'type(enum PolicyRegistry.Errors)'
                                                                        }
                                                                    },
                                                                    id: 245,
                                                                    isConstant: false,
                                                                    isLValue: false,
                                                                    isPure: true,
                                                                    lValueRequested: false,
                                                                    memberName:
                                                                        'ORDER_INVALID_NON_CONSENSUAL',
                                                                    nodeType: 'MemberAccess',
                                                                    referencedDeclaration: null,
                                                                    src: '3345:35:1',
                                                                    typeDescriptions: {
                                                                        typeIdentifier:
                                                                            't_enum$_Errors_$66',
                                                                        typeString:
                                                                            'enum PolicyRegistry.Errors'
                                                                    }
                                                                }
                                                            ],
                                                            expression: {
                                                                argumentTypes: [
                                                                    {
                                                                        typeIdentifier:
                                                                            't_enum$_Errors_$66',
                                                                        typeString:
                                                                            'enum PolicyRegistry.Errors'
                                                                    }
                                                                ],
                                                                id: 243,
                                                                isConstant: false,
                                                                isLValue: false,
                                                                isPure: true,
                                                                lValueRequested: false,
                                                                nodeType:
                                                                    'ElementaryTypeNameExpression',
                                                                src: '3339:5:1',
                                                                typeDescriptions: {
                                                                    typeIdentifier:
                                                                        't_type$_t_uint8_$',
                                                                    typeString: 'type(uint8)'
                                                                },
                                                                typeName: 'uint8'
                                                            },
                                                            id: 246,
                                                            isConstant: false,
                                                            isLValue: false,
                                                            isPure: true,
                                                            kind: 'typeConversion',
                                                            lValueRequested: false,
                                                            names: [],
                                                            nodeType: 'FunctionCall',
                                                            src: '3339:42:1',
                                                            typeDescriptions: {
                                                                typeIdentifier: 't_uint8',
                                                                typeString: 'uint8'
                                                            }
                                                        },
                                                        {
                                                            argumentTypes: null,
                                                            id: 247,
                                                            name: 'orderHash',
                                                            nodeType: 'Identifier',
                                                            overloadedDeclarations: [],
                                                            referencedDeclaration: 219,
                                                            src: '3383:9:1',
                                                            typeDescriptions: {
                                                                typeIdentifier: 't_bytes32',
                                                                typeString: 'bytes32'
                                                            }
                                                        }
                                                    ],
                                                    expression: {
                                                        argumentTypes: [
                                                            {
                                                                typeIdentifier: 't_uint8',
                                                                typeString: 'uint8'
                                                            },
                                                            {
                                                                typeIdentifier: 't_bytes32',
                                                                typeString: 'bytes32'
                                                            }
                                                        ],
                                                        id: 242,
                                                        name: 'LogError',
                                                        nodeType: 'Identifier',
                                                        overloadedDeclarations: [],
                                                        referencedDeclaration: 92,
                                                        src: '3330:8:1',
                                                        typeDescriptions: {
                                                            typeIdentifier:
                                                                't_function_event_nonpayable$_t_uint8_$_t_bytes32_$returns$__$',
                                                            typeString: 'function (uint8,bytes32)'
                                                        }
                                                    },
                                                    id: 248,
                                                    isConstant: false,
                                                    isLValue: false,
                                                    isPure: false,
                                                    kind: 'functionCall',
                                                    lValueRequested: false,
                                                    names: [],
                                                    nodeType: 'FunctionCall',
                                                    src: '3330:63:1',
                                                    typeDescriptions: {
                                                        typeIdentifier: 't_tuple$__$',
                                                        typeString: 'tuple()'
                                                    }
                                                },
                                                id: 249,
                                                nodeType: 'EmitStatement',
                                                src: '3325:68:1'
                                            },
                                            {
                                                expression: {
                                                    argumentTypes: null,
                                                    hexValue: '66616c7365',
                                                    id: 250,
                                                    isConstant: false,
                                                    isLValue: false,
                                                    isPure: true,
                                                    kind: 'bool',
                                                    lValueRequested: false,
                                                    nodeType: 'Literal',
                                                    src: '3414:5:1',
                                                    subdenomination: null,
                                                    typeDescriptions: {
                                                        typeIdentifier: 't_bool',
                                                        typeString: 'bool'
                                                    },
                                                    value: 'false'
                                                },
                                                functionReturnParameters: 233,
                                                id: 251,
                                                nodeType: 'Return',
                                                src: '3407:12:1'
                                            }
                                        ]
                                    }
                                },
                                {
                                    expression: {
                                        argumentTypes: null,
                                        hexValue: '74727565',
                                        id: 254,
                                        isConstant: false,
                                        isLValue: false,
                                        isPure: true,
                                        kind: 'bool',
                                        lValueRequested: false,
                                        nodeType: 'Literal',
                                        src: '3447:4:1',
                                        subdenomination: null,
                                        typeDescriptions: {
                                            typeIdentifier: 't_bool',
                                            typeString: 'bool'
                                        },
                                        value: 'true'
                                    },
                                    functionReturnParameters: 233,
                                    id: 255,
                                    nodeType: 'Return',
                                    src: '3440:11:1'
                                }
                            ]
                        },
                        documentation: 'Internal functions ',
                        id: 257,
                        implemented: true,
                        isConstructor: false,
                        isDeclaredConst: false,
                        modifiers: [],
                        name: 'assertPolicyOrderConsensual',
                        nodeType: 'FunctionDefinition',
                        parameters: {
                            id: 230,
                            nodeType: 'ParameterList',
                            parameters: [
                                {
                                    constant: false,
                                    id: 219,
                                    name: 'orderHash',
                                    nodeType: 'VariableDeclaration',
                                    scope: 257,
                                    src: '2907:17:1',
                                    stateVariable: false,
                                    storageLocation: 'default',
                                    typeDescriptions: {
                                        typeIdentifier: 't_bytes32',
                                        typeString: 'bytes32'
                                    },
                                    typeName: {
                                        id: 218,
                                        name: 'bytes32',
                                        nodeType: 'ElementaryTypeName',
                                        src: '2907:7:1',
                                        typeDescriptions: {
                                            typeIdentifier: 't_bytes32',
                                            typeString: 'bytes32'
                                        }
                                    },
                                    value: null,
                                    visibility: 'internal'
                                },
                                {
                                    constant: false,
                                    id: 221,
                                    name: 'quoteHash',
                                    nodeType: 'VariableDeclaration',
                                    scope: 257,
                                    src: '2934:17:1',
                                    stateVariable: false,
                                    storageLocation: 'default',
                                    typeDescriptions: {
                                        typeIdentifier: 't_bytes32',
                                        typeString: 'bytes32'
                                    },
                                    typeName: {
                                        id: 220,
                                        name: 'bytes32',
                                        nodeType: 'ElementaryTypeName',
                                        src: '2934:7:1',
                                        typeDescriptions: {
                                            typeIdentifier: 't_bytes32',
                                            typeString: 'bytes32'
                                        }
                                    },
                                    value: null,
                                    visibility: 'internal'
                                },
                                {
                                    constant: false,
                                    id: 223,
                                    name: 'carrier',
                                    nodeType: 'VariableDeclaration',
                                    scope: 257,
                                    src: '2961:15:1',
                                    stateVariable: false,
                                    storageLocation: 'default',
                                    typeDescriptions: {
                                        typeIdentifier: 't_address',
                                        typeString: 'address'
                                    },
                                    typeName: {
                                        id: 222,
                                        name: 'address',
                                        nodeType: 'ElementaryTypeName',
                                        src: '2961:7:1',
                                        typeDescriptions: {
                                            typeIdentifier: 't_address',
                                            typeString: 'address'
                                        }
                                    },
                                    value: null,
                                    visibility: 'internal'
                                },
                                {
                                    constant: false,
                                    id: 225,
                                    name: 'carrierSignatureV',
                                    nodeType: 'VariableDeclaration',
                                    scope: 257,
                                    src: '2986:23:1',
                                    stateVariable: false,
                                    storageLocation: 'default',
                                    typeDescriptions: {
                                        typeIdentifier: 't_uint8',
                                        typeString: 'uint8'
                                    },
                                    typeName: {
                                        id: 224,
                                        name: 'uint8',
                                        nodeType: 'ElementaryTypeName',
                                        src: '2986:5:1',
                                        typeDescriptions: {
                                            typeIdentifier: 't_uint8',
                                            typeString: 'uint8'
                                        }
                                    },
                                    value: null,
                                    visibility: 'internal'
                                },
                                {
                                    constant: false,
                                    id: 227,
                                    name: 'carrierSignatureR',
                                    nodeType: 'VariableDeclaration',
                                    scope: 257,
                                    src: '3019:25:1',
                                    stateVariable: false,
                                    storageLocation: 'default',
                                    typeDescriptions: {
                                        typeIdentifier: 't_bytes32',
                                        typeString: 'bytes32'
                                    },
                                    typeName: {
                                        id: 226,
                                        name: 'bytes32',
                                        nodeType: 'ElementaryTypeName',
                                        src: '3019:7:1',
                                        typeDescriptions: {
                                            typeIdentifier: 't_bytes32',
                                            typeString: 'bytes32'
                                        }
                                    },
                                    value: null,
                                    visibility: 'internal'
                                },
                                {
                                    constant: false,
                                    id: 229,
                                    name: 'carrierSignatureS',
                                    nodeType: 'VariableDeclaration',
                                    scope: 257,
                                    src: '3054:25:1',
                                    stateVariable: false,
                                    storageLocation: 'default',
                                    typeDescriptions: {
                                        typeIdentifier: 't_bytes32',
                                        typeString: 'bytes32'
                                    },
                                    typeName: {
                                        id: 228,
                                        name: 'bytes32',
                                        nodeType: 'ElementaryTypeName',
                                        src: '3054:7:1',
                                        typeDescriptions: {
                                            typeIdentifier: 't_bytes32',
                                            typeString: 'bytes32'
                                        }
                                    },
                                    value: null,
                                    visibility: 'internal'
                                }
                            ],
                            src: '2897:188:1'
                        },
                        payable: false,
                        returnParameters: {
                            id: 233,
                            nodeType: 'ParameterList',
                            parameters: [
                                {
                                    constant: false,
                                    id: 232,
                                    name: '',
                                    nodeType: 'VariableDeclaration',
                                    scope: 257,
                                    src: '3120:4:1',
                                    stateVariable: false,
                                    storageLocation: 'default',
                                    typeDescriptions: {
                                        typeIdentifier: 't_bool',
                                        typeString: 'bool'
                                    },
                                    typeName: {
                                        id: 231,
                                        name: 'bool',
                                        nodeType: 'ElementaryTypeName',
                                        src: '3120:4:1',
                                        typeDescriptions: {
                                            typeIdentifier: 't_bool',
                                            typeString: 'bool'
                                        }
                                    },
                                    value: null,
                                    visibility: 'internal'
                                }
                            ],
                            src: '3119:6:1'
                        },
                        scope: 314,
                        src: '2861:597:1',
                        stateMutability: 'nonpayable',
                        superFunction: null,
                        visibility: 'internal'
                    },
                    {
                        body: {
                            id: 284,
                            nodeType: 'Block',
                            src: '3612:189:1',
                            statements: [
                                {
                                    condition: {
                                        argumentTypes: null,
                                        commonType: {
                                            typeIdentifier: 't_uint256',
                                            typeString: 'uint256'
                                        },
                                        id: 269,
                                        isConstant: false,
                                        isLValue: false,
                                        isPure: false,
                                        lValueRequested: false,
                                        leftExpression: {
                                            argumentTypes: null,
                                            id: 266,
                                            name: 'expirationTimestampInSec',
                                            nodeType: 'Identifier',
                                            overloadedDeclarations: [],
                                            referencedDeclaration: 259,
                                            src: '3626:24:1',
                                            typeDescriptions: {
                                                typeIdentifier: 't_uint256',
                                                typeString: 'uint256'
                                            }
                                        },
                                        nodeType: 'BinaryOperation',
                                        operator: '<',
                                        rightExpression: {
                                            argumentTypes: null,
                                            expression: {
                                                argumentTypes: null,
                                                id: 267,
                                                name: 'block',
                                                nodeType: 'Identifier',
                                                overloadedDeclarations: [],
                                                referencedDeclaration: 413,
                                                src: '3653:5:1',
                                                typeDescriptions: {
                                                    typeIdentifier: 't_magic_block',
                                                    typeString: 'block'
                                                }
                                            },
                                            id: 268,
                                            isConstant: false,
                                            isLValue: false,
                                            isPure: false,
                                            lValueRequested: false,
                                            memberName: 'timestamp',
                                            nodeType: 'MemberAccess',
                                            referencedDeclaration: null,
                                            src: '3653:15:1',
                                            typeDescriptions: {
                                                typeIdentifier: 't_uint256',
                                                typeString: 'uint256'
                                            }
                                        },
                                        src: '3626:42:1',
                                        typeDescriptions: {
                                            typeIdentifier: 't_bool',
                                            typeString: 'bool'
                                        }
                                    },
                                    falseBody: null,
                                    id: 281,
                                    nodeType: 'IfStatement',
                                    src: '3622:152:1',
                                    trueBody: {
                                        id: 280,
                                        nodeType: 'Block',
                                        src: '3670:104:1',
                                        statements: [
                                            {
                                                eventCall: {
                                                    argumentTypes: null,
                                                    arguments: [
                                                        {
                                                            argumentTypes: null,
                                                            arguments: [
                                                                {
                                                                    argumentTypes: null,
                                                                    expression: {
                                                                        argumentTypes: null,
                                                                        id: 272,
                                                                        name: 'Errors',
                                                                        nodeType: 'Identifier',
                                                                        overloadedDeclarations: [],
                                                                        referencedDeclaration: 66,
                                                                        src: '3704:6:1',
                                                                        typeDescriptions: {
                                                                            typeIdentifier:
                                                                                't_type$_t_enum$_Errors_$66_$',
                                                                            typeString:
                                                                                'type(enum PolicyRegistry.Errors)'
                                                                        }
                                                                    },
                                                                    id: 273,
                                                                    isConstant: false,
                                                                    isLValue: false,
                                                                    isPure: true,
                                                                    lValueRequested: false,
                                                                    memberName: 'ORDER_EXPIRED',
                                                                    nodeType: 'MemberAccess',
                                                                    referencedDeclaration: null,
                                                                    src: '3704:20:1',
                                                                    typeDescriptions: {
                                                                        typeIdentifier:
                                                                            't_enum$_Errors_$66',
                                                                        typeString:
                                                                            'enum PolicyRegistry.Errors'
                                                                    }
                                                                }
                                                            ],
                                                            expression: {
                                                                argumentTypes: [
                                                                    {
                                                                        typeIdentifier:
                                                                            't_enum$_Errors_$66',
                                                                        typeString:
                                                                            'enum PolicyRegistry.Errors'
                                                                    }
                                                                ],
                                                                id: 271,
                                                                isConstant: false,
                                                                isLValue: false,
                                                                isPure: true,
                                                                lValueRequested: false,
                                                                nodeType:
                                                                    'ElementaryTypeNameExpression',
                                                                src: '3698:5:1',
                                                                typeDescriptions: {
                                                                    typeIdentifier:
                                                                        't_type$_t_uint8_$',
                                                                    typeString: 'type(uint8)'
                                                                },
                                                                typeName: 'uint8'
                                                            },
                                                            id: 274,
                                                            isConstant: false,
                                                            isLValue: false,
                                                            isPure: true,
                                                            kind: 'typeConversion',
                                                            lValueRequested: false,
                                                            names: [],
                                                            nodeType: 'FunctionCall',
                                                            src: '3698:27:1',
                                                            typeDescriptions: {
                                                                typeIdentifier: 't_uint8',
                                                                typeString: 'uint8'
                                                            }
                                                        },
                                                        {
                                                            argumentTypes: null,
                                                            id: 275,
                                                            name: 'orderHash',
                                                            nodeType: 'Identifier',
                                                            overloadedDeclarations: [],
                                                            referencedDeclaration: 261,
                                                            src: '3727:9:1',
                                                            typeDescriptions: {
                                                                typeIdentifier: 't_bytes32',
                                                                typeString: 'bytes32'
                                                            }
                                                        }
                                                    ],
                                                    expression: {
                                                        argumentTypes: [
                                                            {
                                                                typeIdentifier: 't_uint8',
                                                                typeString: 'uint8'
                                                            },
                                                            {
                                                                typeIdentifier: 't_bytes32',
                                                                typeString: 'bytes32'
                                                            }
                                                        ],
                                                        id: 270,
                                                        name: 'LogError',
                                                        nodeType: 'Identifier',
                                                        overloadedDeclarations: [],
                                                        referencedDeclaration: 92,
                                                        src: '3689:8:1',
                                                        typeDescriptions: {
                                                            typeIdentifier:
                                                                't_function_event_nonpayable$_t_uint8_$_t_bytes32_$returns$__$',
                                                            typeString: 'function (uint8,bytes32)'
                                                        }
                                                    },
                                                    id: 276,
                                                    isConstant: false,
                                                    isLValue: false,
                                                    isPure: false,
                                                    kind: 'functionCall',
                                                    lValueRequested: false,
                                                    names: [],
                                                    nodeType: 'FunctionCall',
                                                    src: '3689:48:1',
                                                    typeDescriptions: {
                                                        typeIdentifier: 't_tuple$__$',
                                                        typeString: 'tuple()'
                                                    }
                                                },
                                                id: 277,
                                                nodeType: 'EmitStatement',
                                                src: '3684:53:1'
                                            },
                                            {
                                                expression: {
                                                    argumentTypes: null,
                                                    hexValue: '66616c7365',
                                                    id: 278,
                                                    isConstant: false,
                                                    isLValue: false,
                                                    isPure: true,
                                                    kind: 'bool',
                                                    lValueRequested: false,
                                                    nodeType: 'Literal',
                                                    src: '3758:5:1',
                                                    subdenomination: null,
                                                    typeDescriptions: {
                                                        typeIdentifier: 't_bool',
                                                        typeString: 'bool'
                                                    },
                                                    value: 'false'
                                                },
                                                functionReturnParameters: 265,
                                                id: 279,
                                                nodeType: 'Return',
                                                src: '3751:12:1'
                                            }
                                        ]
                                    }
                                },
                                {
                                    expression: {
                                        argumentTypes: null,
                                        hexValue: '74727565',
                                        id: 282,
                                        isConstant: false,
                                        isLValue: false,
                                        isPure: true,
                                        kind: 'bool',
                                        lValueRequested: false,
                                        nodeType: 'Literal',
                                        src: '3790:4:1',
                                        subdenomination: null,
                                        typeDescriptions: {
                                            typeIdentifier: 't_bool',
                                            typeString: 'bool'
                                        },
                                        value: 'true'
                                    },
                                    functionReturnParameters: 265,
                                    id: 283,
                                    nodeType: 'Return',
                                    src: '3783:11:1'
                                }
                            ]
                        },
                        documentation: null,
                        id: 285,
                        implemented: true,
                        isConstructor: false,
                        isDeclaredConst: false,
                        modifiers: [],
                        name: 'assertPolicyOrderValid',
                        nodeType: 'FunctionDefinition',
                        parameters: {
                            id: 262,
                            nodeType: 'ParameterList',
                            parameters: [
                                {
                                    constant: false,
                                    id: 259,
                                    name: 'expirationTimestampInSec',
                                    nodeType: 'VariableDeclaration',
                                    scope: 285,
                                    src: '3505:29:1',
                                    stateVariable: false,
                                    storageLocation: 'default',
                                    typeDescriptions: {
                                        typeIdentifier: 't_uint256',
                                        typeString: 'uint256'
                                    },
                                    typeName: {
                                        id: 258,
                                        name: 'uint',
                                        nodeType: 'ElementaryTypeName',
                                        src: '3505:4:1',
                                        typeDescriptions: {
                                            typeIdentifier: 't_uint256',
                                            typeString: 'uint256'
                                        }
                                    },
                                    value: null,
                                    visibility: 'internal'
                                },
                                {
                                    constant: false,
                                    id: 261,
                                    name: 'orderHash',
                                    nodeType: 'VariableDeclaration',
                                    scope: 285,
                                    src: '3544:17:1',
                                    stateVariable: false,
                                    storageLocation: 'default',
                                    typeDescriptions: {
                                        typeIdentifier: 't_bytes32',
                                        typeString: 'bytes32'
                                    },
                                    typeName: {
                                        id: 260,
                                        name: 'bytes32',
                                        nodeType: 'ElementaryTypeName',
                                        src: '3544:7:1',
                                        typeDescriptions: {
                                            typeIdentifier: 't_bytes32',
                                            typeString: 'bytes32'
                                        }
                                    },
                                    value: null,
                                    visibility: 'internal'
                                }
                            ],
                            src: '3495:72:1'
                        },
                        payable: false,
                        returnParameters: {
                            id: 265,
                            nodeType: 'ParameterList',
                            parameters: [
                                {
                                    constant: false,
                                    id: 264,
                                    name: '',
                                    nodeType: 'VariableDeclaration',
                                    scope: 285,
                                    src: '3602:4:1',
                                    stateVariable: false,
                                    storageLocation: 'default',
                                    typeDescriptions: {
                                        typeIdentifier: 't_bool',
                                        typeString: 'bool'
                                    },
                                    typeName: {
                                        id: 263,
                                        name: 'bool',
                                        nodeType: 'ElementaryTypeName',
                                        src: '3602:4:1',
                                        typeDescriptions: {
                                            typeIdentifier: 't_bool',
                                            typeString: 'bool'
                                        }
                                    },
                                    value: null,
                                    visibility: 'internal'
                                }
                            ],
                            src: '3601:6:1'
                        },
                        scope: 314,
                        src: '3464:337:1',
                        stateMutability: 'nonpayable',
                        superFunction: null,
                        visibility: 'internal'
                    },
                    {
                        body: {
                            id: 312,
                            nodeType: 'Block',
                            src: '4004:172:1',
                            statements: [
                                {
                                    expression: {
                                        argumentTypes: null,
                                        commonType: {
                                            typeIdentifier: 't_address',
                                            typeString: 'address'
                                        },
                                        id: 310,
                                        isConstant: false,
                                        isLValue: false,
                                        isPure: false,
                                        lValueRequested: false,
                                        leftExpression: {
                                            argumentTypes: null,
                                            id: 300,
                                            name: 'signer',
                                            nodeType: 'Identifier',
                                            overloadedDeclarations: [],
                                            referencedDeclaration: 287,
                                            src: '4030:6:1',
                                            typeDescriptions: {
                                                typeIdentifier: 't_address',
                                                typeString: 'address'
                                            }
                                        },
                                        nodeType: 'BinaryOperation',
                                        operator: '==',
                                        rightExpression: {
                                            argumentTypes: null,
                                            arguments: [
                                                {
                                                    argumentTypes: null,
                                                    arguments: [
                                                        {
                                                            argumentTypes: null,
                                                            hexValue:
                                                                '19457468657265756d205369676e6564204d6573736167653a0a3332',
                                                            id: 303,
                                                            isConstant: false,
                                                            isLValue: false,
                                                            isPure: true,
                                                            kind: 'string',
                                                            lValueRequested: false,
                                                            nodeType: 'Literal',
                                                            src: '4073:34:1',
                                                            subdenomination: null,
                                                            typeDescriptions: {
                                                                typeIdentifier:
                                                                    't_stringliteral_178a2411ab6fbc1ba11064408972259c558d0e82fd48b0aba3ad81d14f065e73',
                                                                typeString:
                                                                    'literal_string "\u0019Ethereum Signed Message:\n32"'
                                                            },
                                                            value:
                                                                '\u0019Ethereum Signed Message:\n32'
                                                        },
                                                        {
                                                            argumentTypes: null,
                                                            id: 304,
                                                            name: 'hash',
                                                            nodeType: 'Identifier',
                                                            overloadedDeclarations: [],
                                                            referencedDeclaration: 289,
                                                            src: '4109:4:1',
                                                            typeDescriptions: {
                                                                typeIdentifier: 't_bytes32',
                                                                typeString: 'bytes32'
                                                            }
                                                        }
                                                    ],
                                                    expression: {
                                                        argumentTypes: [
                                                            {
                                                                typeIdentifier:
                                                                    't_stringliteral_178a2411ab6fbc1ba11064408972259c558d0e82fd48b0aba3ad81d14f065e73',
                                                                typeString:
                                                                    'literal_string "\u0019Ethereum Signed Message:\n32"'
                                                            },
                                                            {
                                                                typeIdentifier: 't_bytes32',
                                                                typeString: 'bytes32'
                                                            }
                                                        ],
                                                        id: 302,
                                                        name: 'keccak256',
                                                        nodeType: 'Identifier',
                                                        overloadedDeclarations: [],
                                                        referencedDeclaration: 417,
                                                        src: '4063:9:1',
                                                        typeDescriptions: {
                                                            typeIdentifier:
                                                                't_function_sha3_pure$__$returns$_t_bytes32_$',
                                                            typeString:
                                                                'function () pure returns (bytes32)'
                                                        }
                                                    },
                                                    id: 305,
                                                    isConstant: false,
                                                    isLValue: false,
                                                    isPure: false,
                                                    kind: 'functionCall',
                                                    lValueRequested: false,
                                                    names: [],
                                                    nodeType: 'FunctionCall',
                                                    src: '4063:51:1',
                                                    typeDescriptions: {
                                                        typeIdentifier: 't_bytes32',
                                                        typeString: 'bytes32'
                                                    }
                                                },
                                                {
                                                    argumentTypes: null,
                                                    id: 306,
                                                    name: 'v',
                                                    nodeType: 'Identifier',
                                                    overloadedDeclarations: [],
                                                    referencedDeclaration: 291,
                                                    src: '4128:1:1',
                                                    typeDescriptions: {
                                                        typeIdentifier: 't_uint8',
                                                        typeString: 'uint8'
                                                    }
                                                },
                                                {
                                                    argumentTypes: null,
                                                    id: 307,
                                                    name: 'r',
                                                    nodeType: 'Identifier',
                                                    overloadedDeclarations: [],
                                                    referencedDeclaration: 293,
                                                    src: '4143:1:1',
                                                    typeDescriptions: {
                                                        typeIdentifier: 't_bytes32',
                                                        typeString: 'bytes32'
                                                    }
                                                },
                                                {
                                                    argumentTypes: null,
                                                    id: 308,
                                                    name: 's',
                                                    nodeType: 'Identifier',
                                                    overloadedDeclarations: [],
                                                    referencedDeclaration: 295,
                                                    src: '4158:1:1',
                                                    typeDescriptions: {
                                                        typeIdentifier: 't_bytes32',
                                                        typeString: 'bytes32'
                                                    }
                                                }
                                            ],
                                            expression: {
                                                argumentTypes: [
                                                    {
                                                        typeIdentifier: 't_bytes32',
                                                        typeString: 'bytes32'
                                                    },
                                                    {
                                                        typeIdentifier: 't_uint8',
                                                        typeString: 'uint8'
                                                    },
                                                    {
                                                        typeIdentifier: 't_bytes32',
                                                        typeString: 'bytes32'
                                                    },
                                                    {
                                                        typeIdentifier: 't_bytes32',
                                                        typeString: 'bytes32'
                                                    }
                                                ],
                                                id: 301,
                                                name: 'ecrecover',
                                                nodeType: 'Identifier',
                                                overloadedDeclarations: [],
                                                referencedDeclaration: 415,
                                                src: '4040:9:1',
                                                typeDescriptions: {
                                                    typeIdentifier:
                                                        't_function_ecrecover_pure$_t_bytes32_$_t_uint8_$_t_bytes32_$_t_bytes32_$returns$_t_address_$',
                                                    typeString:
                                                        'function (bytes32,uint8,bytes32,bytes32) pure returns (address)'
                                                }
                                            },
                                            id: 309,
                                            isConstant: false,
                                            isLValue: false,
                                            isPure: false,
                                            kind: 'functionCall',
                                            lValueRequested: false,
                                            names: [],
                                            nodeType: 'FunctionCall',
                                            src: '4040:129:1',
                                            typeDescriptions: {
                                                typeIdentifier: 't_address',
                                                typeString: 'address'
                                            }
                                        },
                                        src: '4030:139:1',
                                        typeDescriptions: {
                                            typeIdentifier: 't_bool',
                                            typeString: 'bool'
                                        }
                                    },
                                    functionReturnParameters: 299,
                                    id: 311,
                                    nodeType: 'Return',
                                    src: '4023:146:1'
                                }
                            ]
                        },
                        documentation: null,
                        id: 313,
                        implemented: true,
                        isConstructor: false,
                        isDeclaredConst: true,
                        modifiers: [],
                        name: 'isValidSignature',
                        nodeType: 'FunctionDefinition',
                        parameters: {
                            id: 296,
                            nodeType: 'ParameterList',
                            parameters: [
                                {
                                    constant: false,
                                    id: 287,
                                    name: 'signer',
                                    nodeType: 'VariableDeclaration',
                                    scope: 313,
                                    src: '3842:14:1',
                                    stateVariable: false,
                                    storageLocation: 'default',
                                    typeDescriptions: {
                                        typeIdentifier: 't_address',
                                        typeString: 'address'
                                    },
                                    typeName: {
                                        id: 286,
                                        name: 'address',
                                        nodeType: 'ElementaryTypeName',
                                        src: '3842:7:1',
                                        typeDescriptions: {
                                            typeIdentifier: 't_address',
                                            typeString: 'address'
                                        }
                                    },
                                    value: null,
                                    visibility: 'internal'
                                },
                                {
                                    constant: false,
                                    id: 289,
                                    name: 'hash',
                                    nodeType: 'VariableDeclaration',
                                    scope: 313,
                                    src: '3866:12:1',
                                    stateVariable: false,
                                    storageLocation: 'default',
                                    typeDescriptions: {
                                        typeIdentifier: 't_bytes32',
                                        typeString: 'bytes32'
                                    },
                                    typeName: {
                                        id: 288,
                                        name: 'bytes32',
                                        nodeType: 'ElementaryTypeName',
                                        src: '3866:7:1',
                                        typeDescriptions: {
                                            typeIdentifier: 't_bytes32',
                                            typeString: 'bytes32'
                                        }
                                    },
                                    value: null,
                                    visibility: 'internal'
                                },
                                {
                                    constant: false,
                                    id: 291,
                                    name: 'v',
                                    nodeType: 'VariableDeclaration',
                                    scope: 313,
                                    src: '3888:7:1',
                                    stateVariable: false,
                                    storageLocation: 'default',
                                    typeDescriptions: {
                                        typeIdentifier: 't_uint8',
                                        typeString: 'uint8'
                                    },
                                    typeName: {
                                        id: 290,
                                        name: 'uint8',
                                        nodeType: 'ElementaryTypeName',
                                        src: '3888:5:1',
                                        typeDescriptions: {
                                            typeIdentifier: 't_uint8',
                                            typeString: 'uint8'
                                        }
                                    },
                                    value: null,
                                    visibility: 'internal'
                                },
                                {
                                    constant: false,
                                    id: 293,
                                    name: 'r',
                                    nodeType: 'VariableDeclaration',
                                    scope: 313,
                                    src: '3905:9:1',
                                    stateVariable: false,
                                    storageLocation: 'default',
                                    typeDescriptions: {
                                        typeIdentifier: 't_bytes32',
                                        typeString: 'bytes32'
                                    },
                                    typeName: {
                                        id: 292,
                                        name: 'bytes32',
                                        nodeType: 'ElementaryTypeName',
                                        src: '3905:7:1',
                                        typeDescriptions: {
                                            typeIdentifier: 't_bytes32',
                                            typeString: 'bytes32'
                                        }
                                    },
                                    value: null,
                                    visibility: 'internal'
                                },
                                {
                                    constant: false,
                                    id: 295,
                                    name: 's',
                                    nodeType: 'VariableDeclaration',
                                    scope: 313,
                                    src: '3924:9:1',
                                    stateVariable: false,
                                    storageLocation: 'default',
                                    typeDescriptions: {
                                        typeIdentifier: 't_bytes32',
                                        typeString: 'bytes32'
                                    },
                                    typeName: {
                                        id: 294,
                                        name: 'bytes32',
                                        nodeType: 'ElementaryTypeName',
                                        src: '3924:7:1',
                                        typeDescriptions: {
                                            typeIdentifier: 't_bytes32',
                                            typeString: 'bytes32'
                                        }
                                    },
                                    value: null,
                                    visibility: 'internal'
                                }
                            ],
                            src: '3832:107:1'
                        },
                        payable: false,
                        returnParameters: {
                            id: 299,
                            nodeType: 'ParameterList',
                            parameters: [
                                {
                                    constant: false,
                                    id: 298,
                                    name: '_valid',
                                    nodeType: 'VariableDeclaration',
                                    scope: 313,
                                    src: '3987:11:1',
                                    stateVariable: false,
                                    storageLocation: 'default',
                                    typeDescriptions: {
                                        typeIdentifier: 't_bool',
                                        typeString: 'bool'
                                    },
                                    typeName: {
                                        id: 297,
                                        name: 'bool',
                                        nodeType: 'ElementaryTypeName',
                                        src: '3987:4:1',
                                        typeDescriptions: {
                                            typeIdentifier: 't_bool',
                                            typeString: 'bool'
                                        }
                                    },
                                    value: null,
                                    visibility: 'internal'
                                }
                            ],
                            src: '3986:13:1'
                        },
                        scope: 314,
                        src: '3807:369:1',
                        stateMutability: 'pure',
                        superFunction: null,
                        visibility: 'internal'
                    }
                ],
                scope: 315,
                src: '88:4090:1'
            }
        ],
        src: '0:4178:1'
    },
    legacyAST: {
        absolutePath:
            '/Users/tyndall/Documents/Projects/asekuro-relayer-frontend/contracts/PolicyRegistry.sol',
        exportedSymbols: {
            PolicyRegistry: [314]
        },
        id: 315,
        nodeType: 'SourceUnit',
        nodes: [
            {
                id: 58,
                literals: ['solidity', '^', '0.4', '.18'],
                nodeType: 'PragmaDirective',
                src: '0:25:1'
            },
            {
                absolutePath: 'openzeppelin-solidity/contracts/math/SafeMath.sol',
                file: 'openzeppelin-solidity/contracts/math/SafeMath.sol',
                id: 59,
                nodeType: 'ImportDirective',
                scope: 315,
                sourceUnit: 409,
                src: '27:59:1',
                symbolAliases: [],
                unitAlias: ''
            },
            {
                baseContracts: [],
                contractDependencies: [],
                contractKind: 'contract',
                documentation: null,
                fullyImplemented: true,
                id: 314,
                linearizedBaseContracts: [314],
                name: 'PolicyRegistry',
                nodeType: 'ContractDefinition',
                nodes: [
                    {
                        id: 62,
                        libraryName: {
                            contractScope: null,
                            id: 60,
                            name: 'SafeMath',
                            nodeType: 'UserDefinedTypeName',
                            referencedDeclaration: 408,
                            src: '124:8:1',
                            typeDescriptions: {
                                typeIdentifier: 't_contract$_SafeMath_$408',
                                typeString: 'library SafeMath'
                            }
                        },
                        nodeType: 'UsingForDirective',
                        src: '118:24:1',
                        typeName: {
                            id: 61,
                            name: 'uint',
                            nodeType: 'ElementaryTypeName',
                            src: '137:4:1',
                            typeDescriptions: {
                                typeIdentifier: 't_uint256',
                                typeString: 'uint256'
                            }
                        }
                    },
                    {
                        canonicalName: 'PolicyRegistry.Errors',
                        id: 66,
                        members: [
                            {
                                id: 63,
                                name: 'POLICY_ISSUED',
                                nodeType: 'EnumValue',
                                src: '170:13:1'
                            },
                            {
                                id: 64,
                                name: 'ORDER_EXPIRED',
                                nodeType: 'EnumValue',
                                src: '193:13:1'
                            },
                            {
                                id: 65,
                                name: 'ORDER_INVALID_NON_CONSENSUAL',
                                nodeType: 'EnumValue',
                                src: '216:28:1'
                            }
                        ],
                        name: 'Errors',
                        nodeType: 'EnumDefinition',
                        src: '148:102:1'
                    },
                    {
                        constant: true,
                        id: 71,
                        name: 'NULL_ISSUANCE_HASH',
                        nodeType: 'VariableDeclaration',
                        scope: 314,
                        src: '256:55:1',
                        stateVariable: true,
                        storageLocation: 'default',
                        typeDescriptions: {
                            typeIdentifier: 't_bytes32',
                            typeString: 'bytes32'
                        },
                        typeName: {
                            id: 67,
                            name: 'bytes32',
                            nodeType: 'ElementaryTypeName',
                            src: '256:7:1',
                            typeDescriptions: {
                                typeIdentifier: 't_bytes32',
                                typeString: 'bytes32'
                            }
                        },
                        value: {
                            argumentTypes: null,
                            arguments: [
                                {
                                    argumentTypes: null,
                                    hexValue: '30',
                                    id: 69,
                                    isConstant: false,
                                    isLValue: false,
                                    isPure: true,
                                    kind: 'number',
                                    lValueRequested: false,
                                    nodeType: 'Literal',
                                    src: '309:1:1',
                                    subdenomination: null,
                                    typeDescriptions: {
                                        typeIdentifier: 't_rational_0_by_1',
                                        typeString: 'int_const 0'
                                    },
                                    value: '0'
                                }
                            ],
                            expression: {
                                argumentTypes: [
                                    {
                                        typeIdentifier: 't_rational_0_by_1',
                                        typeString: 'int_const 0'
                                    }
                                ],
                                id: 68,
                                isConstant: false,
                                isLValue: false,
                                isPure: true,
                                lValueRequested: false,
                                nodeType: 'ElementaryTypeNameExpression',
                                src: '301:7:1',
                                typeDescriptions: {
                                    typeIdentifier: 't_type$_t_bytes32_$',
                                    typeString: 'type(bytes32)'
                                },
                                typeName: 'bytes32'
                            },
                            id: 70,
                            isConstant: false,
                            isLValue: false,
                            isPure: true,
                            kind: 'typeConversion',
                            lValueRequested: false,
                            names: [],
                            nodeType: 'FunctionCall',
                            src: '301:10:1',
                            typeDescriptions: {
                                typeIdentifier: 't_bytes32',
                                typeString: 'bytes32'
                            }
                        },
                        visibility: 'public'
                    },
                    {
                        constant: false,
                        id: 74,
                        name: 'policyCount',
                        nodeType: 'VariableDeclaration',
                        scope: 314,
                        src: '317:27:1',
                        stateVariable: true,
                        storageLocation: 'default',
                        typeDescriptions: {
                            typeIdentifier: 't_uint256',
                            typeString: 'uint256'
                        },
                        typeName: {
                            id: 72,
                            name: 'uint',
                            nodeType: 'ElementaryTypeName',
                            src: '317:4:1',
                            typeDescriptions: {
                                typeIdentifier: 't_uint256',
                                typeString: 'uint256'
                            }
                        },
                        value: {
                            argumentTypes: null,
                            hexValue: '30',
                            id: 73,
                            isConstant: false,
                            isLValue: false,
                            isPure: true,
                            kind: 'number',
                            lValueRequested: false,
                            nodeType: 'Literal',
                            src: '343:1:1',
                            subdenomination: null,
                            typeDescriptions: {
                                typeIdentifier: 't_rational_0_by_1',
                                typeString: 'int_const 0'
                            },
                            value: '0'
                        },
                        visibility: 'public'
                    },
                    {
                        constant: false,
                        id: 78,
                        name: 'registry',
                        nodeType: 'VariableDeclaration',
                        scope: 314,
                        src: '355:42:1',
                        stateVariable: true,
                        storageLocation: 'default',
                        typeDescriptions: {
                            typeIdentifier: 't_mapping$_t_bytes32_$_t_struct$_Entry_$105_storage_$',
                            typeString: 'mapping(bytes32 => struct PolicyRegistry.Entry)'
                        },
                        typeName: {
                            id: 77,
                            keyType: {
                                id: 75,
                                name: 'bytes32',
                                nodeType: 'ElementaryTypeName',
                                src: '364:7:1',
                                typeDescriptions: {
                                    typeIdentifier: 't_bytes32',
                                    typeString: 'bytes32'
                                }
                            },
                            nodeType: 'Mapping',
                            src: '355:26:1',
                            typeDescriptions: {
                                typeIdentifier:
                                    't_mapping$_t_bytes32_$_t_struct$_Entry_$105_storage_$',
                                typeString: 'mapping(bytes32 => struct PolicyRegistry.Entry)'
                            },
                            valueType: {
                                contractScope: null,
                                id: 76,
                                name: 'Entry',
                                nodeType: 'UserDefinedTypeName',
                                referencedDeclaration: 105,
                                src: '375:5:1',
                                typeDescriptions: {
                                    typeIdentifier: 't_struct$_Entry_$105_storage_ptr',
                                    typeString: 'struct PolicyRegistry.Entry'
                                }
                            }
                        },
                        value: null,
                        visibility: 'public'
                    },
                    {
                        anonymous: false,
                        documentation: null,
                        id: 86,
                        name: 'LogPolicyOrderFilled',
                        nodeType: 'EventDefinition',
                        parameters: {
                            id: 85,
                            nodeType: 'ParameterList',
                            parameters: [
                                {
                                    constant: false,
                                    id: 80,
                                    indexed: true,
                                    name: '_orderHash',
                                    nodeType: 'VariableDeclaration',
                                    scope: 86,
                                    src: '440:26:1',
                                    stateVariable: false,
                                    storageLocation: 'default',
                                    typeDescriptions: {
                                        typeIdentifier: 't_bytes32',
                                        typeString: 'bytes32'
                                    },
                                    typeName: {
                                        id: 79,
                                        name: 'bytes32',
                                        nodeType: 'ElementaryTypeName',
                                        src: '440:7:1',
                                        typeDescriptions: {
                                            typeIdentifier: 't_bytes32',
                                            typeString: 'bytes32'
                                        }
                                    },
                                    value: null,
                                    visibility: 'internal'
                                },
                                {
                                    constant: false,
                                    id: 82,
                                    indexed: true,
                                    name: '_carrier',
                                    nodeType: 'VariableDeclaration',
                                    scope: 86,
                                    src: '476:24:1',
                                    stateVariable: false,
                                    storageLocation: 'default',
                                    typeDescriptions: {
                                        typeIdentifier: 't_address',
                                        typeString: 'address'
                                    },
                                    typeName: {
                                        id: 81,
                                        name: 'address',
                                        nodeType: 'ElementaryTypeName',
                                        src: '476:7:1',
                                        typeDescriptions: {
                                            typeIdentifier: 't_address',
                                            typeString: 'address'
                                        }
                                    },
                                    value: null,
                                    visibility: 'internal'
                                },
                                {
                                    constant: false,
                                    id: 84,
                                    indexed: true,
                                    name: '_insured',
                                    nodeType: 'VariableDeclaration',
                                    scope: 86,
                                    src: '510:24:1',
                                    stateVariable: false,
                                    storageLocation: 'default',
                                    typeDescriptions: {
                                        typeIdentifier: 't_address',
                                        typeString: 'address'
                                    },
                                    typeName: {
                                        id: 83,
                                        name: 'address',
                                        nodeType: 'ElementaryTypeName',
                                        src: '510:7:1',
                                        typeDescriptions: {
                                            typeIdentifier: 't_address',
                                            typeString: 'address'
                                        }
                                    },
                                    value: null,
                                    visibility: 'internal'
                                }
                            ],
                            src: '430:110:1'
                        },
                        src: '404:137:1'
                    },
                    {
                        anonymous: false,
                        documentation: null,
                        id: 92,
                        name: 'LogError',
                        nodeType: 'EventDefinition',
                        parameters: {
                            id: 91,
                            nodeType: 'ParameterList',
                            parameters: [
                                {
                                    constant: false,
                                    id: 88,
                                    indexed: true,
                                    name: '_errorId',
                                    nodeType: 'VariableDeclaration',
                                    scope: 92,
                                    src: '571:22:1',
                                    stateVariable: false,
                                    storageLocation: 'default',
                                    typeDescriptions: {
                                        typeIdentifier: 't_uint8',
                                        typeString: 'uint8'
                                    },
                                    typeName: {
                                        id: 87,
                                        name: 'uint8',
                                        nodeType: 'ElementaryTypeName',
                                        src: '571:5:1',
                                        typeDescriptions: {
                                            typeIdentifier: 't_uint8',
                                            typeString: 'uint8'
                                        }
                                    },
                                    value: null,
                                    visibility: 'internal'
                                },
                                {
                                    constant: false,
                                    id: 90,
                                    indexed: true,
                                    name: '_orderHash',
                                    nodeType: 'VariableDeclaration',
                                    scope: 92,
                                    src: '603:26:1',
                                    stateVariable: false,
                                    storageLocation: 'default',
                                    typeDescriptions: {
                                        typeIdentifier: 't_bytes32',
                                        typeString: 'bytes32'
                                    },
                                    typeName: {
                                        id: 89,
                                        name: 'bytes32',
                                        nodeType: 'ElementaryTypeName',
                                        src: '603:7:1',
                                        typeDescriptions: {
                                            typeIdentifier: 't_bytes32',
                                            typeString: 'bytes32'
                                        }
                                    },
                                    value: null,
                                    visibility: 'internal'
                                }
                            ],
                            src: '561:74:1'
                        },
                        src: '547:89:1'
                    },
                    {
                        canonicalName: 'PolicyRegistry.Entry',
                        id: 105,
                        members: [
                            {
                                constant: false,
                                id: 94,
                                name: 'carrier',
                                nodeType: 'VariableDeclaration',
                                scope: 105,
                                src: '665:15:1',
                                stateVariable: false,
                                storageLocation: 'default',
                                typeDescriptions: {
                                    typeIdentifier: 't_address',
                                    typeString: 'address'
                                },
                                typeName: {
                                    id: 93,
                                    name: 'address',
                                    nodeType: 'ElementaryTypeName',
                                    src: '665:7:1',
                                    typeDescriptions: {
                                        typeIdentifier: 't_address',
                                        typeString: 'address'
                                    }
                                },
                                value: null,
                                visibility: 'internal'
                            },
                            {
                                constant: false,
                                id: 96,
                                name: 'insured',
                                nodeType: 'VariableDeclaration',
                                scope: 105,
                                src: '690:15:1',
                                stateVariable: false,
                                storageLocation: 'default',
                                typeDescriptions: {
                                    typeIdentifier: 't_address',
                                    typeString: 'address'
                                },
                                typeName: {
                                    id: 95,
                                    name: 'address',
                                    nodeType: 'ElementaryTypeName',
                                    src: '690:7:1',
                                    typeDescriptions: {
                                        typeIdentifier: 't_address',
                                        typeString: 'address'
                                    }
                                },
                                value: null,
                                visibility: 'internal'
                            },
                            {
                                constant: false,
                                id: 98,
                                name: 'orderHash',
                                nodeType: 'VariableDeclaration',
                                scope: 105,
                                src: '715:17:1',
                                stateVariable: false,
                                storageLocation: 'default',
                                typeDescriptions: {
                                    typeIdentifier: 't_bytes32',
                                    typeString: 'bytes32'
                                },
                                typeName: {
                                    id: 97,
                                    name: 'bytes32',
                                    nodeType: 'ElementaryTypeName',
                                    src: '715:7:1',
                                    typeDescriptions: {
                                        typeIdentifier: 't_bytes32',
                                        typeString: 'bytes32'
                                    }
                                },
                                value: null,
                                visibility: 'internal'
                            },
                            {
                                constant: false,
                                id: 100,
                                name: 'coverage',
                                nodeType: 'VariableDeclaration',
                                scope: 105,
                                src: '742:13:1',
                                stateVariable: false,
                                storageLocation: 'default',
                                typeDescriptions: {
                                    typeIdentifier: 't_uint256',
                                    typeString: 'uint256'
                                },
                                typeName: {
                                    id: 99,
                                    name: 'uint',
                                    nodeType: 'ElementaryTypeName',
                                    src: '742:4:1',
                                    typeDescriptions: {
                                        typeIdentifier: 't_uint256',
                                        typeString: 'uint256'
                                    }
                                },
                                value: null,
                                visibility: 'internal'
                            },
                            {
                                constant: false,
                                id: 102,
                                name: 'premium',
                                nodeType: 'VariableDeclaration',
                                scope: 105,
                                src: '765:12:1',
                                stateVariable: false,
                                storageLocation: 'default',
                                typeDescriptions: {
                                    typeIdentifier: 't_uint256',
                                    typeString: 'uint256'
                                },
                                typeName: {
                                    id: 101,
                                    name: 'uint',
                                    nodeType: 'ElementaryTypeName',
                                    src: '765:4:1',
                                    typeDescriptions: {
                                        typeIdentifier: 't_uint256',
                                        typeString: 'uint256'
                                    }
                                },
                                value: null,
                                visibility: 'internal'
                            },
                            {
                                constant: false,
                                id: 104,
                                name: 'issuanceBlockTimestamp',
                                nodeType: 'VariableDeclaration',
                                scope: 105,
                                src: '787:27:1',
                                stateVariable: false,
                                storageLocation: 'default',
                                typeDescriptions: {
                                    typeIdentifier: 't_uint256',
                                    typeString: 'uint256'
                                },
                                typeName: {
                                    id: 103,
                                    name: 'uint',
                                    nodeType: 'ElementaryTypeName',
                                    src: '787:4:1',
                                    typeDescriptions: {
                                        typeIdentifier: 't_uint256',
                                        typeString: 'uint256'
                                    }
                                },
                                value: null,
                                visibility: 'internal'
                            }
                        ],
                        name: 'Entry',
                        nodeType: 'StructDefinition',
                        scope: 314,
                        src: '642:179:1',
                        visibility: 'public'
                    },
                    {
                        body: {
                            id: 178,
                            nodeType: 'Block',
                            src: '1259:1038:1',
                            statements: [
                                {
                                    condition: {
                                        argumentTypes: null,
                                        commonType: {
                                            typeIdentifier: 't_bool',
                                            typeString: 'bool'
                                        },
                                        id: 142,
                                        isConstant: false,
                                        isLValue: false,
                                        isPure: false,
                                        lValueRequested: false,
                                        leftExpression: {
                                            argumentTypes: null,
                                            id: 132,
                                            isConstant: false,
                                            isLValue: false,
                                            isPure: false,
                                            lValueRequested: false,
                                            nodeType: 'UnaryOperation',
                                            operator: '!',
                                            prefix: true,
                                            src: '1402:87:1',
                                            subExpression: {
                                                argumentTypes: null,
                                                arguments: [
                                                    {
                                                        argumentTypes: null,
                                                        id: 129,
                                                        name: '_expirationTimestampInSec',
                                                        nodeType: 'Identifier',
                                                        overloadedDeclarations: [],
                                                        referencedDeclaration: 117,
                                                        src: '1439:25:1',
                                                        typeDescriptions: {
                                                            typeIdentifier: 't_uint256',
                                                            typeString: 'uint256'
                                                        }
                                                    },
                                                    {
                                                        argumentTypes: null,
                                                        id: 130,
                                                        name: '_orderHash',
                                                        nodeType: 'Identifier',
                                                        overloadedDeclarations: [],
                                                        referencedDeclaration: 109,
                                                        src: '1478:10:1',
                                                        typeDescriptions: {
                                                            typeIdentifier: 't_bytes32',
                                                            typeString: 'bytes32'
                                                        }
                                                    }
                                                ],
                                                expression: {
                                                    argumentTypes: [
                                                        {
                                                            typeIdentifier: 't_uint256',
                                                            typeString: 'uint256'
                                                        },
                                                        {
                                                            typeIdentifier: 't_bytes32',
                                                            typeString: 'bytes32'
                                                        }
                                                    ],
                                                    id: 128,
                                                    name: 'assertPolicyOrderValid',
                                                    nodeType: 'Identifier',
                                                    overloadedDeclarations: [],
                                                    referencedDeclaration: 285,
                                                    src: '1403:22:1',
                                                    typeDescriptions: {
                                                        typeIdentifier:
                                                            't_function_internal_nonpayable$_t_uint256_$_t_bytes32_$returns$_t_bool_$',
                                                        typeString:
                                                            'function (uint256,bytes32) returns (bool)'
                                                    }
                                                },
                                                id: 131,
                                                isConstant: false,
                                                isLValue: false,
                                                isPure: false,
                                                kind: 'functionCall',
                                                lValueRequested: false,
                                                names: [],
                                                nodeType: 'FunctionCall',
                                                src: '1403:86:1',
                                                typeDescriptions: {
                                                    typeIdentifier: 't_bool',
                                                    typeString: 'bool'
                                                }
                                            },
                                            typeDescriptions: {
                                                typeIdentifier: 't_bool',
                                                typeString: 'bool'
                                            }
                                        },
                                        nodeType: 'BinaryOperation',
                                        operator: '||',
                                        rightExpression: {
                                            argumentTypes: null,
                                            id: 141,
                                            isConstant: false,
                                            isLValue: false,
                                            isPure: false,
                                            lValueRequested: false,
                                            nodeType: 'UnaryOperation',
                                            operator: '!',
                                            prefix: true,
                                            src: '1505:219:1',
                                            subExpression: {
                                                argumentTypes: null,
                                                arguments: [
                                                    {
                                                        argumentTypes: null,
                                                        id: 134,
                                                        name: '_orderHash',
                                                        nodeType: 'Identifier',
                                                        overloadedDeclarations: [],
                                                        referencedDeclaration: 109,
                                                        src: '1551:10:1',
                                                        typeDescriptions: {
                                                            typeIdentifier: 't_bytes32',
                                                            typeString: 'bytes32'
                                                        }
                                                    },
                                                    {
                                                        argumentTypes: null,
                                                        id: 135,
                                                        name: '_quoteHash',
                                                        nodeType: 'Identifier',
                                                        overloadedDeclarations: [],
                                                        referencedDeclaration: 111,
                                                        src: '1579:10:1',
                                                        typeDescriptions: {
                                                            typeIdentifier: 't_bytes32',
                                                            typeString: 'bytes32'
                                                        }
                                                    },
                                                    {
                                                        argumentTypes: null,
                                                        id: 136,
                                                        name: '_carrier',
                                                        nodeType: 'Identifier',
                                                        overloadedDeclarations: [],
                                                        referencedDeclaration: 107,
                                                        src: '1607:8:1',
                                                        typeDescriptions: {
                                                            typeIdentifier: 't_address',
                                                            typeString: 'address'
                                                        }
                                                    },
                                                    {
                                                        argumentTypes: null,
                                                        id: 137,
                                                        name: '_carrierSignatureV',
                                                        nodeType: 'Identifier',
                                                        overloadedDeclarations: [],
                                                        referencedDeclaration: 119,
                                                        src: '1633:18:1',
                                                        typeDescriptions: {
                                                            typeIdentifier: 't_uint8',
                                                            typeString: 'uint8'
                                                        }
                                                    },
                                                    {
                                                        argumentTypes: null,
                                                        id: 138,
                                                        name: '_carrierSignatureR',
                                                        nodeType: 'Identifier',
                                                        overloadedDeclarations: [],
                                                        referencedDeclaration: 121,
                                                        src: '1669:18:1',
                                                        typeDescriptions: {
                                                            typeIdentifier: 't_bytes32',
                                                            typeString: 'bytes32'
                                                        }
                                                    },
                                                    {
                                                        argumentTypes: null,
                                                        id: 139,
                                                        name: '_carrierSignatureS',
                                                        nodeType: 'Identifier',
                                                        overloadedDeclarations: [],
                                                        referencedDeclaration: 123,
                                                        src: '1705:18:1',
                                                        typeDescriptions: {
                                                            typeIdentifier: 't_bytes32',
                                                            typeString: 'bytes32'
                                                        }
                                                    }
                                                ],
                                                expression: {
                                                    argumentTypes: [
                                                        {
                                                            typeIdentifier: 't_bytes32',
                                                            typeString: 'bytes32'
                                                        },
                                                        {
                                                            typeIdentifier: 't_bytes32',
                                                            typeString: 'bytes32'
                                                        },
                                                        {
                                                            typeIdentifier: 't_address',
                                                            typeString: 'address'
                                                        },
                                                        {
                                                            typeIdentifier: 't_uint8',
                                                            typeString: 'uint8'
                                                        },
                                                        {
                                                            typeIdentifier: 't_bytes32',
                                                            typeString: 'bytes32'
                                                        },
                                                        {
                                                            typeIdentifier: 't_bytes32',
                                                            typeString: 'bytes32'
                                                        }
                                                    ],
                                                    id: 133,
                                                    name: 'assertPolicyOrderConsensual',
                                                    nodeType: 'Identifier',
                                                    overloadedDeclarations: [],
                                                    referencedDeclaration: 257,
                                                    src: '1506:27:1',
                                                    typeDescriptions: {
                                                        typeIdentifier:
                                                            't_function_internal_nonpayable$_t_bytes32_$_t_bytes32_$_t_address_$_t_uint8_$_t_bytes32_$_t_bytes32_$returns$_t_bool_$',
                                                        typeString:
                                                            'function (bytes32,bytes32,address,uint8,bytes32,bytes32) returns (bool)'
                                                    }
                                                },
                                                id: 140,
                                                isConstant: false,
                                                isLValue: false,
                                                isPure: false,
                                                kind: 'functionCall',
                                                lValueRequested: false,
                                                names: [],
                                                nodeType: 'FunctionCall',
                                                src: '1506:218:1',
                                                typeDescriptions: {
                                                    typeIdentifier: 't_bool',
                                                    typeString: 'bool'
                                                }
                                            },
                                            typeDescriptions: {
                                                typeIdentifier: 't_bool',
                                                typeString: 'bool'
                                            }
                                        },
                                        src: '1402:322:1',
                                        typeDescriptions: {
                                            typeIdentifier: 't_bool',
                                            typeString: 'bool'
                                        }
                                    },
                                    falseBody: null,
                                    id: 146,
                                    nodeType: 'IfStatement',
                                    src: '1398:378:1',
                                    trueBody: {
                                        id: 145,
                                        nodeType: 'Block',
                                        src: '1726:50:1',
                                        statements: [
                                            {
                                                expression: {
                                                    argumentTypes: null,
                                                    id: 143,
                                                    name: 'NULL_ISSUANCE_HASH',
                                                    nodeType: 'Identifier',
                                                    overloadedDeclarations: [],
                                                    referencedDeclaration: 71,
                                                    src: '1747:18:1',
                                                    typeDescriptions: {
                                                        typeIdentifier: 't_bytes32',
                                                        typeString: 'bytes32'
                                                    }
                                                },
                                                functionReturnParameters: 127,
                                                id: 144,
                                                nodeType: 'Return',
                                                src: '1740:25:1'
                                            }
                                        ]
                                    }
                                },
                                {
                                    assignments: [148],
                                    declarations: [
                                        {
                                            constant: false,
                                            id: 148,
                                            name: 'entry',
                                            nodeType: 'VariableDeclaration',
                                            scope: 179,
                                            src: '1786:18:1',
                                            stateVariable: false,
                                            storageLocation: 'memory',
                                            typeDescriptions: {
                                                typeIdentifier: 't_struct$_Entry_$105_memory_ptr',
                                                typeString: 'struct PolicyRegistry.Entry'
                                            },
                                            typeName: {
                                                contractScope: null,
                                                id: 147,
                                                name: 'Entry',
                                                nodeType: 'UserDefinedTypeName',
                                                referencedDeclaration: 105,
                                                src: '1786:5:1',
                                                typeDescriptions: {
                                                    typeIdentifier:
                                                        't_struct$_Entry_$105_storage_ptr',
                                                    typeString: 'struct PolicyRegistry.Entry'
                                                }
                                            },
                                            value: null,
                                            visibility: 'internal'
                                        }
                                    ],
                                    id: 159,
                                    initialValue: {
                                        argumentTypes: null,
                                        arguments: [
                                            {
                                                argumentTypes: null,
                                                id: 150,
                                                name: '_carrier',
                                                nodeType: 'Identifier',
                                                overloadedDeclarations: [],
                                                referencedDeclaration: 107,
                                                src: '1826:8:1',
                                                typeDescriptions: {
                                                    typeIdentifier: 't_address',
                                                    typeString: 'address'
                                                }
                                            },
                                            {
                                                argumentTypes: null,
                                                expression: {
                                                    argumentTypes: null,
                                                    id: 151,
                                                    name: 'msg',
                                                    nodeType: 'Identifier',
                                                    overloadedDeclarations: [],
                                                    referencedDeclaration: 423,
                                                    src: '1848:3:1',
                                                    typeDescriptions: {
                                                        typeIdentifier: 't_magic_message',
                                                        typeString: 'msg'
                                                    }
                                                },
                                                id: 152,
                                                isConstant: false,
                                                isLValue: false,
                                                isPure: false,
                                                lValueRequested: false,
                                                memberName: 'sender',
                                                nodeType: 'MemberAccess',
                                                referencedDeclaration: null,
                                                src: '1848:10:1',
                                                typeDescriptions: {
                                                    typeIdentifier: 't_address',
                                                    typeString: 'address'
                                                }
                                            },
                                            {
                                                argumentTypes: null,
                                                id: 153,
                                                name: '_orderHash',
                                                nodeType: 'Identifier',
                                                overloadedDeclarations: [],
                                                referencedDeclaration: 109,
                                                src: '1872:10:1',
                                                typeDescriptions: {
                                                    typeIdentifier: 't_bytes32',
                                                    typeString: 'bytes32'
                                                }
                                            },
                                            {
                                                argumentTypes: null,
                                                id: 154,
                                                name: '_coverage',
                                                nodeType: 'Identifier',
                                                overloadedDeclarations: [],
                                                referencedDeclaration: 113,
                                                src: '1896:9:1',
                                                typeDescriptions: {
                                                    typeIdentifier: 't_uint256',
                                                    typeString: 'uint256'
                                                }
                                            },
                                            {
                                                argumentTypes: null,
                                                id: 155,
                                                name: '_premium',
                                                nodeType: 'Identifier',
                                                overloadedDeclarations: [],
                                                referencedDeclaration: 115,
                                                src: '1919:8:1',
                                                typeDescriptions: {
                                                    typeIdentifier: 't_uint256',
                                                    typeString: 'uint256'
                                                }
                                            },
                                            {
                                                argumentTypes: null,
                                                expression: {
                                                    argumentTypes: null,
                                                    id: 156,
                                                    name: 'block',
                                                    nodeType: 'Identifier',
                                                    overloadedDeclarations: [],
                                                    referencedDeclaration: 413,
                                                    src: '1941:5:1',
                                                    typeDescriptions: {
                                                        typeIdentifier: 't_magic_block',
                                                        typeString: 'block'
                                                    }
                                                },
                                                id: 157,
                                                isConstant: false,
                                                isLValue: false,
                                                isPure: false,
                                                lValueRequested: false,
                                                memberName: 'timestamp',
                                                nodeType: 'MemberAccess',
                                                referencedDeclaration: null,
                                                src: '1941:15:1',
                                                typeDescriptions: {
                                                    typeIdentifier: 't_uint256',
                                                    typeString: 'uint256'
                                                }
                                            }
                                        ],
                                        expression: {
                                            argumentTypes: [
                                                {
                                                    typeIdentifier: 't_address',
                                                    typeString: 'address'
                                                },
                                                {
                                                    typeIdentifier: 't_address',
                                                    typeString: 'address'
                                                },
                                                {
                                                    typeIdentifier: 't_bytes32',
                                                    typeString: 'bytes32'
                                                },
                                                {
                                                    typeIdentifier: 't_uint256',
                                                    typeString: 'uint256'
                                                },
                                                {
                                                    typeIdentifier: 't_uint256',
                                                    typeString: 'uint256'
                                                },
                                                {
                                                    typeIdentifier: 't_uint256',
                                                    typeString: 'uint256'
                                                }
                                            ],
                                            id: 149,
                                            name: 'Entry',
                                            nodeType: 'Identifier',
                                            overloadedDeclarations: [],
                                            referencedDeclaration: 105,
                                            src: '1807:5:1',
                                            typeDescriptions: {
                                                typeIdentifier:
                                                    't_type$_t_struct$_Entry_$105_storage_ptr_$',
                                                typeString:
                                                    'type(struct PolicyRegistry.Entry storage pointer)'
                                            }
                                        },
                                        id: 158,
                                        isConstant: false,
                                        isLValue: false,
                                        isPure: false,
                                        kind: 'structConstructorCall',
                                        lValueRequested: false,
                                        names: [],
                                        nodeType: 'FunctionCall',
                                        src: '1807:159:1',
                                        typeDescriptions: {
                                            typeIdentifier: 't_struct$_Entry_$105_memory',
                                            typeString: 'struct PolicyRegistry.Entry memory'
                                        }
                                    },
                                    nodeType: 'VariableDeclarationStatement',
                                    src: '1786:180:1'
                                },
                                {
                                    expression: {
                                        argumentTypes: null,
                                        id: 164,
                                        isConstant: false,
                                        isLValue: false,
                                        isPure: false,
                                        lValueRequested: false,
                                        leftHandSide: {
                                            argumentTypes: null,
                                            baseExpression: {
                                                argumentTypes: null,
                                                id: 160,
                                                name: 'registry',
                                                nodeType: 'Identifier',
                                                overloadedDeclarations: [],
                                                referencedDeclaration: 78,
                                                src: '2134:8:1',
                                                typeDescriptions: {
                                                    typeIdentifier:
                                                        't_mapping$_t_bytes32_$_t_struct$_Entry_$105_storage_$',
                                                    typeString:
                                                        'mapping(bytes32 => struct PolicyRegistry.Entry storage ref)'
                                                }
                                            },
                                            id: 162,
                                            indexExpression: {
                                                argumentTypes: null,
                                                id: 161,
                                                name: '_orderHash',
                                                nodeType: 'Identifier',
                                                overloadedDeclarations: [],
                                                referencedDeclaration: 109,
                                                src: '2143:10:1',
                                                typeDescriptions: {
                                                    typeIdentifier: 't_bytes32',
                                                    typeString: 'bytes32'
                                                }
                                            },
                                            isConstant: false,
                                            isLValue: true,
                                            isPure: false,
                                            lValueRequested: true,
                                            nodeType: 'IndexAccess',
                                            src: '2134:20:1',
                                            typeDescriptions: {
                                                typeIdentifier: 't_struct$_Entry_$105_storage',
                                                typeString:
                                                    'struct PolicyRegistry.Entry storage ref'
                                            }
                                        },
                                        nodeType: 'Assignment',
                                        operator: '=',
                                        rightHandSide: {
                                            argumentTypes: null,
                                            id: 163,
                                            name: 'entry',
                                            nodeType: 'Identifier',
                                            overloadedDeclarations: [],
                                            referencedDeclaration: 148,
                                            src: '2157:5:1',
                                            typeDescriptions: {
                                                typeIdentifier: 't_struct$_Entry_$105_memory_ptr',
                                                typeString: 'struct PolicyRegistry.Entry memory'
                                            }
                                        },
                                        src: '2134:28:1',
                                        typeDescriptions: {
                                            typeIdentifier: 't_struct$_Entry_$105_storage',
                                            typeString: 'struct PolicyRegistry.Entry storage ref'
                                        }
                                    },
                                    id: 165,
                                    nodeType: 'ExpressionStatement',
                                    src: '2134:28:1'
                                },
                                {
                                    expression: {
                                        argumentTypes: null,
                                        id: 167,
                                        isConstant: false,
                                        isLValue: false,
                                        isPure: false,
                                        lValueRequested: false,
                                        nodeType: 'UnaryOperation',
                                        operator: '++',
                                        prefix: false,
                                        src: '2172:13:1',
                                        subExpression: {
                                            argumentTypes: null,
                                            id: 166,
                                            name: 'policyCount',
                                            nodeType: 'Identifier',
                                            overloadedDeclarations: [],
                                            referencedDeclaration: 74,
                                            src: '2172:11:1',
                                            typeDescriptions: {
                                                typeIdentifier: 't_uint256',
                                                typeString: 'uint256'
                                            }
                                        },
                                        typeDescriptions: {
                                            typeIdentifier: 't_uint256',
                                            typeString: 'uint256'
                                        }
                                    },
                                    id: 168,
                                    nodeType: 'ExpressionStatement',
                                    src: '2172:13:1'
                                },
                                {
                                    eventCall: {
                                        argumentTypes: null,
                                        arguments: [
                                            {
                                                argumentTypes: null,
                                                id: 170,
                                                name: '_orderHash',
                                                nodeType: 'Identifier',
                                                overloadedDeclarations: [],
                                                referencedDeclaration: 109,
                                                src: '2221:10:1',
                                                typeDescriptions: {
                                                    typeIdentifier: 't_bytes32',
                                                    typeString: 'bytes32'
                                                }
                                            },
                                            {
                                                argumentTypes: null,
                                                id: 171,
                                                name: '_carrier',
                                                nodeType: 'Identifier',
                                                overloadedDeclarations: [],
                                                referencedDeclaration: 107,
                                                src: '2233:8:1',
                                                typeDescriptions: {
                                                    typeIdentifier: 't_address',
                                                    typeString: 'address'
                                                }
                                            },
                                            {
                                                argumentTypes: null,
                                                expression: {
                                                    argumentTypes: null,
                                                    id: 172,
                                                    name: 'msg',
                                                    nodeType: 'Identifier',
                                                    overloadedDeclarations: [],
                                                    referencedDeclaration: 423,
                                                    src: '2243:3:1',
                                                    typeDescriptions: {
                                                        typeIdentifier: 't_magic_message',
                                                        typeString: 'msg'
                                                    }
                                                },
                                                id: 173,
                                                isConstant: false,
                                                isLValue: false,
                                                isPure: false,
                                                lValueRequested: false,
                                                memberName: 'sender',
                                                nodeType: 'MemberAccess',
                                                referencedDeclaration: null,
                                                src: '2243:10:1',
                                                typeDescriptions: {
                                                    typeIdentifier: 't_address',
                                                    typeString: 'address'
                                                }
                                            }
                                        ],
                                        expression: {
                                            argumentTypes: [
                                                {
                                                    typeIdentifier: 't_bytes32',
                                                    typeString: 'bytes32'
                                                },
                                                {
                                                    typeIdentifier: 't_address',
                                                    typeString: 'address'
                                                },
                                                {
                                                    typeIdentifier: 't_address',
                                                    typeString: 'address'
                                                }
                                            ],
                                            id: 169,
                                            name: 'LogPolicyOrderFilled',
                                            nodeType: 'Identifier',
                                            overloadedDeclarations: [],
                                            referencedDeclaration: 86,
                                            src: '2200:20:1',
                                            typeDescriptions: {
                                                typeIdentifier:
                                                    't_function_event_nonpayable$_t_bytes32_$_t_address_$_t_address_$returns$__$',
                                                typeString: 'function (bytes32,address,address)'
                                            }
                                        },
                                        id: 174,
                                        isConstant: false,
                                        isLValue: false,
                                        isPure: false,
                                        kind: 'functionCall',
                                        lValueRequested: false,
                                        names: [],
                                        nodeType: 'FunctionCall',
                                        src: '2200:54:1',
                                        typeDescriptions: {
                                            typeIdentifier: 't_tuple$__$',
                                            typeString: 'tuple()'
                                        }
                                    },
                                    id: 175,
                                    nodeType: 'EmitStatement',
                                    src: '2195:59:1'
                                },
                                {
                                    expression: {
                                        argumentTypes: null,
                                        id: 176,
                                        name: '_orderHash',
                                        nodeType: 'Identifier',
                                        overloadedDeclarations: [],
                                        referencedDeclaration: 109,
                                        src: '2280:10:1',
                                        typeDescriptions: {
                                            typeIdentifier: 't_bytes32',
                                            typeString: 'bytes32'
                                        }
                                    },
                                    functionReturnParameters: 127,
                                    id: 177,
                                    nodeType: 'Return',
                                    src: '2273:17:1'
                                }
                            ]
                        },
                        documentation: 'Fills a given policy order if it is valid and consensual.',
                        id: 179,
                        implemented: true,
                        isConstructor: false,
                        isDeclaredConst: false,
                        modifiers: [],
                        name: 'fillPolicyOrder',
                        nodeType: 'FunctionDefinition',
                        parameters: {
                            id: 124,
                            nodeType: 'ParameterList',
                            parameters: [
                                {
                                    constant: false,
                                    id: 107,
                                    name: '_carrier',
                                    nodeType: 'VariableDeclaration',
                                    scope: 179,
                                    src: '942:16:1',
                                    stateVariable: false,
                                    storageLocation: 'default',
                                    typeDescriptions: {
                                        typeIdentifier: 't_address',
                                        typeString: 'address'
                                    },
                                    typeName: {
                                        id: 106,
                                        name: 'address',
                                        nodeType: 'ElementaryTypeName',
                                        src: '942:7:1',
                                        typeDescriptions: {
                                            typeIdentifier: 't_address',
                                            typeString: 'address'
                                        }
                                    },
                                    value: null,
                                    visibility: 'internal'
                                },
                                {
                                    constant: false,
                                    id: 109,
                                    name: '_orderHash',
                                    nodeType: 'VariableDeclaration',
                                    scope: 179,
                                    src: '968:18:1',
                                    stateVariable: false,
                                    storageLocation: 'default',
                                    typeDescriptions: {
                                        typeIdentifier: 't_bytes32',
                                        typeString: 'bytes32'
                                    },
                                    typeName: {
                                        id: 108,
                                        name: 'bytes32',
                                        nodeType: 'ElementaryTypeName',
                                        src: '968:7:1',
                                        typeDescriptions: {
                                            typeIdentifier: 't_bytes32',
                                            typeString: 'bytes32'
                                        }
                                    },
                                    value: null,
                                    visibility: 'internal'
                                },
                                {
                                    constant: false,
                                    id: 111,
                                    name: '_quoteHash',
                                    nodeType: 'VariableDeclaration',
                                    scope: 179,
                                    src: '996:18:1',
                                    stateVariable: false,
                                    storageLocation: 'default',
                                    typeDescriptions: {
                                        typeIdentifier: 't_bytes32',
                                        typeString: 'bytes32'
                                    },
                                    typeName: {
                                        id: 110,
                                        name: 'bytes32',
                                        nodeType: 'ElementaryTypeName',
                                        src: '996:7:1',
                                        typeDescriptions: {
                                            typeIdentifier: 't_bytes32',
                                            typeString: 'bytes32'
                                        }
                                    },
                                    value: null,
                                    visibility: 'internal'
                                },
                                {
                                    constant: false,
                                    id: 113,
                                    name: '_coverage',
                                    nodeType: 'VariableDeclaration',
                                    scope: 179,
                                    src: '1024:14:1',
                                    stateVariable: false,
                                    storageLocation: 'default',
                                    typeDescriptions: {
                                        typeIdentifier: 't_uint256',
                                        typeString: 'uint256'
                                    },
                                    typeName: {
                                        id: 112,
                                        name: 'uint',
                                        nodeType: 'ElementaryTypeName',
                                        src: '1024:4:1',
                                        typeDescriptions: {
                                            typeIdentifier: 't_uint256',
                                            typeString: 'uint256'
                                        }
                                    },
                                    value: null,
                                    visibility: 'internal'
                                },
                                {
                                    constant: false,
                                    id: 115,
                                    name: '_premium',
                                    nodeType: 'VariableDeclaration',
                                    scope: 179,
                                    src: '1048:13:1',
                                    stateVariable: false,
                                    storageLocation: 'default',
                                    typeDescriptions: {
                                        typeIdentifier: 't_uint256',
                                        typeString: 'uint256'
                                    },
                                    typeName: {
                                        id: 114,
                                        name: 'uint',
                                        nodeType: 'ElementaryTypeName',
                                        src: '1048:4:1',
                                        typeDescriptions: {
                                            typeIdentifier: 't_uint256',
                                            typeString: 'uint256'
                                        }
                                    },
                                    value: null,
                                    visibility: 'internal'
                                },
                                {
                                    constant: false,
                                    id: 117,
                                    name: '_expirationTimestampInSec',
                                    nodeType: 'VariableDeclaration',
                                    scope: 179,
                                    src: '1071:30:1',
                                    stateVariable: false,
                                    storageLocation: 'default',
                                    typeDescriptions: {
                                        typeIdentifier: 't_uint256',
                                        typeString: 'uint256'
                                    },
                                    typeName: {
                                        id: 116,
                                        name: 'uint',
                                        nodeType: 'ElementaryTypeName',
                                        src: '1071:4:1',
                                        typeDescriptions: {
                                            typeIdentifier: 't_uint256',
                                            typeString: 'uint256'
                                        }
                                    },
                                    value: null,
                                    visibility: 'internal'
                                },
                                {
                                    constant: false,
                                    id: 119,
                                    name: '_carrierSignatureV',
                                    nodeType: 'VariableDeclaration',
                                    scope: 179,
                                    src: '1111:24:1',
                                    stateVariable: false,
                                    storageLocation: 'default',
                                    typeDescriptions: {
                                        typeIdentifier: 't_uint8',
                                        typeString: 'uint8'
                                    },
                                    typeName: {
                                        id: 118,
                                        name: 'uint8',
                                        nodeType: 'ElementaryTypeName',
                                        src: '1111:5:1',
                                        typeDescriptions: {
                                            typeIdentifier: 't_uint8',
                                            typeString: 'uint8'
                                        }
                                    },
                                    value: null,
                                    visibility: 'internal'
                                },
                                {
                                    constant: false,
                                    id: 121,
                                    name: '_carrierSignatureR',
                                    nodeType: 'VariableDeclaration',
                                    scope: 179,
                                    src: '1145:26:1',
                                    stateVariable: false,
                                    storageLocation: 'default',
                                    typeDescriptions: {
                                        typeIdentifier: 't_bytes32',
                                        typeString: 'bytes32'
                                    },
                                    typeName: {
                                        id: 120,
                                        name: 'bytes32',
                                        nodeType: 'ElementaryTypeName',
                                        src: '1145:7:1',
                                        typeDescriptions: {
                                            typeIdentifier: 't_bytes32',
                                            typeString: 'bytes32'
                                        }
                                    },
                                    value: null,
                                    visibility: 'internal'
                                },
                                {
                                    constant: false,
                                    id: 123,
                                    name: '_carrierSignatureS',
                                    nodeType: 'VariableDeclaration',
                                    scope: 179,
                                    src: '1181:26:1',
                                    stateVariable: false,
                                    storageLocation: 'default',
                                    typeDescriptions: {
                                        typeIdentifier: 't_bytes32',
                                        typeString: 'bytes32'
                                    },
                                    typeName: {
                                        id: 122,
                                        name: 'bytes32',
                                        nodeType: 'ElementaryTypeName',
                                        src: '1181:7:1',
                                        typeDescriptions: {
                                            typeIdentifier: 't_bytes32',
                                            typeString: 'bytes32'
                                        }
                                    },
                                    value: null,
                                    visibility: 'internal'
                                }
                            ],
                            src: '932:281:1'
                        },
                        payable: false,
                        returnParameters: {
                            id: 127,
                            nodeType: 'ParameterList',
                            parameters: [
                                {
                                    constant: false,
                                    id: 126,
                                    name: '',
                                    nodeType: 'VariableDeclaration',
                                    scope: 179,
                                    src: '1246:7:1',
                                    stateVariable: false,
                                    storageLocation: 'default',
                                    typeDescriptions: {
                                        typeIdentifier: 't_bytes32',
                                        typeString: 'bytes32'
                                    },
                                    typeName: {
                                        id: 125,
                                        name: 'bytes32',
                                        nodeType: 'ElementaryTypeName',
                                        src: '1246:7:1',
                                        typeDescriptions: {
                                            typeIdentifier: 't_bytes32',
                                            typeString: 'bytes32'
                                        }
                                    },
                                    value: null,
                                    visibility: 'internal'
                                }
                            ],
                            src: '1245:9:1'
                        },
                        scope: 314,
                        src: '908:1389:1',
                        stateMutability: 'nonpayable',
                        superFunction: null,
                        visibility: 'public'
                    },
                    {
                        body: {
                            id: 216,
                            nodeType: 'Block',
                            src: '2524:300:1',
                            statements: [
                                {
                                    assignments: [197],
                                    declarations: [
                                        {
                                            constant: false,
                                            id: 197,
                                            name: 'policyEntry',
                                            nodeType: 'VariableDeclaration',
                                            scope: 217,
                                            src: '2534:17:1',
                                            stateVariable: false,
                                            storageLocation: 'default',
                                            typeDescriptions: {
                                                typeIdentifier: 't_struct$_Entry_$105_storage_ptr',
                                                typeString: 'struct PolicyRegistry.Entry'
                                            },
                                            typeName: {
                                                contractScope: null,
                                                id: 196,
                                                name: 'Entry',
                                                nodeType: 'UserDefinedTypeName',
                                                referencedDeclaration: 105,
                                                src: '2534:5:1',
                                                typeDescriptions: {
                                                    typeIdentifier:
                                                        't_struct$_Entry_$105_storage_ptr',
                                                    typeString: 'struct PolicyRegistry.Entry'
                                                }
                                            },
                                            value: null,
                                            visibility: 'internal'
                                        }
                                    ],
                                    id: 201,
                                    initialValue: {
                                        argumentTypes: null,
                                        baseExpression: {
                                            argumentTypes: null,
                                            id: 198,
                                            name: 'registry',
                                            nodeType: 'Identifier',
                                            overloadedDeclarations: [],
                                            referencedDeclaration: 78,
                                            src: '2554:8:1',
                                            typeDescriptions: {
                                                typeIdentifier:
                                                    't_mapping$_t_bytes32_$_t_struct$_Entry_$105_storage_$',
                                                typeString:
                                                    'mapping(bytes32 => struct PolicyRegistry.Entry storage ref)'
                                            }
                                        },
                                        id: 200,
                                        indexExpression: {
                                            argumentTypes: null,
                                            id: 199,
                                            name: '_orderHash',
                                            nodeType: 'Identifier',
                                            overloadedDeclarations: [],
                                            referencedDeclaration: 181,
                                            src: '2563:10:1',
                                            typeDescriptions: {
                                                typeIdentifier: 't_bytes32',
                                                typeString: 'bytes32'
                                            }
                                        },
                                        isConstant: false,
                                        isLValue: true,
                                        isPure: false,
                                        lValueRequested: false,
                                        nodeType: 'IndexAccess',
                                        src: '2554:20:1',
                                        typeDescriptions: {
                                            typeIdentifier: 't_struct$_Entry_$105_storage',
                                            typeString: 'struct PolicyRegistry.Entry storage ref'
                                        }
                                    },
                                    nodeType: 'VariableDeclarationStatement',
                                    src: '2534:40:1'
                                },
                                {
                                    expression: {
                                        argumentTypes: null,
                                        components: [
                                            {
                                                argumentTypes: null,
                                                expression: {
                                                    argumentTypes: null,
                                                    id: 202,
                                                    name: 'policyEntry',
                                                    nodeType: 'Identifier',
                                                    overloadedDeclarations: [],
                                                    referencedDeclaration: 197,
                                                    src: '2605:11:1',
                                                    typeDescriptions: {
                                                        typeIdentifier:
                                                            't_struct$_Entry_$105_storage_ptr',
                                                        typeString:
                                                            'struct PolicyRegistry.Entry storage pointer'
                                                    }
                                                },
                                                id: 203,
                                                isConstant: false,
                                                isLValue: true,
                                                isPure: false,
                                                lValueRequested: false,
                                                memberName: 'carrier',
                                                nodeType: 'MemberAccess',
                                                referencedDeclaration: 94,
                                                src: '2605:19:1',
                                                typeDescriptions: {
                                                    typeIdentifier: 't_address',
                                                    typeString: 'address'
                                                }
                                            },
                                            {
                                                argumentTypes: null,
                                                expression: {
                                                    argumentTypes: null,
                                                    id: 204,
                                                    name: 'policyEntry',
                                                    nodeType: 'Identifier',
                                                    overloadedDeclarations: [],
                                                    referencedDeclaration: 197,
                                                    src: '2638:11:1',
                                                    typeDescriptions: {
                                                        typeIdentifier:
                                                            't_struct$_Entry_$105_storage_ptr',
                                                        typeString:
                                                            'struct PolicyRegistry.Entry storage pointer'
                                                    }
                                                },
                                                id: 205,
                                                isConstant: false,
                                                isLValue: true,
                                                isPure: false,
                                                lValueRequested: false,
                                                memberName: 'insured',
                                                nodeType: 'MemberAccess',
                                                referencedDeclaration: 96,
                                                src: '2638:19:1',
                                                typeDescriptions: {
                                                    typeIdentifier: 't_address',
                                                    typeString: 'address'
                                                }
                                            },
                                            {
                                                argumentTypes: null,
                                                expression: {
                                                    argumentTypes: null,
                                                    id: 206,
                                                    name: 'policyEntry',
                                                    nodeType: 'Identifier',
                                                    overloadedDeclarations: [],
                                                    referencedDeclaration: 197,
                                                    src: '2671:11:1',
                                                    typeDescriptions: {
                                                        typeIdentifier:
                                                            't_struct$_Entry_$105_storage_ptr',
                                                        typeString:
                                                            'struct PolicyRegistry.Entry storage pointer'
                                                    }
                                                },
                                                id: 207,
                                                isConstant: false,
                                                isLValue: true,
                                                isPure: false,
                                                lValueRequested: false,
                                                memberName: 'orderHash',
                                                nodeType: 'MemberAccess',
                                                referencedDeclaration: 98,
                                                src: '2671:21:1',
                                                typeDescriptions: {
                                                    typeIdentifier: 't_bytes32',
                                                    typeString: 'bytes32'
                                                }
                                            },
                                            {
                                                argumentTypes: null,
                                                expression: {
                                                    argumentTypes: null,
                                                    id: 208,
                                                    name: 'policyEntry',
                                                    nodeType: 'Identifier',
                                                    overloadedDeclarations: [],
                                                    referencedDeclaration: 197,
                                                    src: '2706:11:1',
                                                    typeDescriptions: {
                                                        typeIdentifier:
                                                            't_struct$_Entry_$105_storage_ptr',
                                                        typeString:
                                                            'struct PolicyRegistry.Entry storage pointer'
                                                    }
                                                },
                                                id: 209,
                                                isConstant: false,
                                                isLValue: true,
                                                isPure: false,
                                                lValueRequested: false,
                                                memberName: 'coverage',
                                                nodeType: 'MemberAccess',
                                                referencedDeclaration: 100,
                                                src: '2706:20:1',
                                                typeDescriptions: {
                                                    typeIdentifier: 't_uint256',
                                                    typeString: 'uint256'
                                                }
                                            },
                                            {
                                                argumentTypes: null,
                                                expression: {
                                                    argumentTypes: null,
                                                    id: 210,
                                                    name: 'policyEntry',
                                                    nodeType: 'Identifier',
                                                    overloadedDeclarations: [],
                                                    referencedDeclaration: 197,
                                                    src: '2740:11:1',
                                                    typeDescriptions: {
                                                        typeIdentifier:
                                                            't_struct$_Entry_$105_storage_ptr',
                                                        typeString:
                                                            'struct PolicyRegistry.Entry storage pointer'
                                                    }
                                                },
                                                id: 211,
                                                isConstant: false,
                                                isLValue: true,
                                                isPure: false,
                                                lValueRequested: false,
                                                memberName: 'premium',
                                                nodeType: 'MemberAccess',
                                                referencedDeclaration: 102,
                                                src: '2740:19:1',
                                                typeDescriptions: {
                                                    typeIdentifier: 't_uint256',
                                                    typeString: 'uint256'
                                                }
                                            },
                                            {
                                                argumentTypes: null,
                                                expression: {
                                                    argumentTypes: null,
                                                    id: 212,
                                                    name: 'policyEntry',
                                                    nodeType: 'Identifier',
                                                    overloadedDeclarations: [],
                                                    referencedDeclaration: 197,
                                                    src: '2773:11:1',
                                                    typeDescriptions: {
                                                        typeIdentifier:
                                                            't_struct$_Entry_$105_storage_ptr',
                                                        typeString:
                                                            'struct PolicyRegistry.Entry storage pointer'
                                                    }
                                                },
                                                id: 213,
                                                isConstant: false,
                                                isLValue: true,
                                                isPure: false,
                                                lValueRequested: false,
                                                memberName: 'issuanceBlockTimestamp',
                                                nodeType: 'MemberAccess',
                                                referencedDeclaration: 104,
                                                src: '2773:34:1',
                                                typeDescriptions: {
                                                    typeIdentifier: 't_uint256',
                                                    typeString: 'uint256'
                                                }
                                            }
                                        ],
                                        id: 214,
                                        isConstant: false,
                                        isInlineArray: false,
                                        isLValue: false,
                                        isPure: false,
                                        lValueRequested: false,
                                        nodeType: 'TupleExpression',
                                        src: '2591:226:1',
                                        typeDescriptions: {
                                            typeIdentifier:
                                                't_tuple$_t_address_$_t_address_$_t_bytes32_$_t_uint256_$_t_uint256_$_t_uint256_$',
                                            typeString:
                                                'tuple(address,address,bytes32,uint256,uint256,uint256)'
                                        }
                                    },
                                    functionReturnParameters: 195,
                                    id: 215,
                                    nodeType: 'Return',
                                    src: '2584:233:1'
                                }
                            ]
                        },
                        documentation: null,
                        id: 217,
                        implemented: true,
                        isConstructor: false,
                        isDeclaredConst: false,
                        modifiers: [],
                        name: 'getPolicyEntry',
                        nodeType: 'FunctionDefinition',
                        parameters: {
                            id: 182,
                            nodeType: 'ParameterList',
                            parameters: [
                                {
                                    constant: false,
                                    id: 181,
                                    name: '_orderHash',
                                    nodeType: 'VariableDeclaration',
                                    scope: 217,
                                    src: '2336:18:1',
                                    stateVariable: false,
                                    storageLocation: 'default',
                                    typeDescriptions: {
                                        typeIdentifier: 't_bytes32',
                                        typeString: 'bytes32'
                                    },
                                    typeName: {
                                        id: 180,
                                        name: 'bytes32',
                                        nodeType: 'ElementaryTypeName',
                                        src: '2336:7:1',
                                        typeDescriptions: {
                                            typeIdentifier: 't_bytes32',
                                            typeString: 'bytes32'
                                        }
                                    },
                                    value: null,
                                    visibility: 'internal'
                                }
                            ],
                            src: '2326:34:1'
                        },
                        payable: false,
                        returnParameters: {
                            id: 195,
                            nodeType: 'ParameterList',
                            parameters: [
                                {
                                    constant: false,
                                    id: 184,
                                    name: '',
                                    nodeType: 'VariableDeclaration',
                                    scope: 217,
                                    src: '2406:7:1',
                                    stateVariable: false,
                                    storageLocation: 'default',
                                    typeDescriptions: {
                                        typeIdentifier: 't_address',
                                        typeString: 'address'
                                    },
                                    typeName: {
                                        id: 183,
                                        name: 'address',
                                        nodeType: 'ElementaryTypeName',
                                        src: '2406:7:1',
                                        typeDescriptions: {
                                            typeIdentifier: 't_address',
                                            typeString: 'address'
                                        }
                                    },
                                    value: null,
                                    visibility: 'internal'
                                },
                                {
                                    constant: false,
                                    id: 186,
                                    name: '',
                                    nodeType: 'VariableDeclaration',
                                    scope: 217,
                                    src: '2427:7:1',
                                    stateVariable: false,
                                    storageLocation: 'default',
                                    typeDescriptions: {
                                        typeIdentifier: 't_address',
                                        typeString: 'address'
                                    },
                                    typeName: {
                                        id: 185,
                                        name: 'address',
                                        nodeType: 'ElementaryTypeName',
                                        src: '2427:7:1',
                                        typeDescriptions: {
                                            typeIdentifier: 't_address',
                                            typeString: 'address'
                                        }
                                    },
                                    value: null,
                                    visibility: 'internal'
                                },
                                {
                                    constant: false,
                                    id: 188,
                                    name: '',
                                    nodeType: 'VariableDeclaration',
                                    scope: 217,
                                    src: '2448:7:1',
                                    stateVariable: false,
                                    storageLocation: 'default',
                                    typeDescriptions: {
                                        typeIdentifier: 't_bytes32',
                                        typeString: 'bytes32'
                                    },
                                    typeName: {
                                        id: 187,
                                        name: 'bytes32',
                                        nodeType: 'ElementaryTypeName',
                                        src: '2448:7:1',
                                        typeDescriptions: {
                                            typeIdentifier: 't_bytes32',
                                            typeString: 'bytes32'
                                        }
                                    },
                                    value: null,
                                    visibility: 'internal'
                                },
                                {
                                    constant: false,
                                    id: 190,
                                    name: '',
                                    nodeType: 'VariableDeclaration',
                                    scope: 217,
                                    src: '2469:4:1',
                                    stateVariable: false,
                                    storageLocation: 'default',
                                    typeDescriptions: {
                                        typeIdentifier: 't_uint256',
                                        typeString: 'uint256'
                                    },
                                    typeName: {
                                        id: 189,
                                        name: 'uint',
                                        nodeType: 'ElementaryTypeName',
                                        src: '2469:4:1',
                                        typeDescriptions: {
                                            typeIdentifier: 't_uint256',
                                            typeString: 'uint256'
                                        }
                                    },
                                    value: null,
                                    visibility: 'internal'
                                },
                                {
                                    constant: false,
                                    id: 192,
                                    name: '',
                                    nodeType: 'VariableDeclaration',
                                    scope: 217,
                                    src: '2487:4:1',
                                    stateVariable: false,
                                    storageLocation: 'default',
                                    typeDescriptions: {
                                        typeIdentifier: 't_uint256',
                                        typeString: 'uint256'
                                    },
                                    typeName: {
                                        id: 191,
                                        name: 'uint',
                                        nodeType: 'ElementaryTypeName',
                                        src: '2487:4:1',
                                        typeDescriptions: {
                                            typeIdentifier: 't_uint256',
                                            typeString: 'uint256'
                                        }
                                    },
                                    value: null,
                                    visibility: 'internal'
                                },
                                {
                                    constant: false,
                                    id: 194,
                                    name: '',
                                    nodeType: 'VariableDeclaration',
                                    scope: 217,
                                    src: '2505:4:1',
                                    stateVariable: false,
                                    storageLocation: 'default',
                                    typeDescriptions: {
                                        typeIdentifier: 't_uint256',
                                        typeString: 'uint256'
                                    },
                                    typeName: {
                                        id: 193,
                                        name: 'uint',
                                        nodeType: 'ElementaryTypeName',
                                        src: '2505:4:1',
                                        typeDescriptions: {
                                            typeIdentifier: 't_uint256',
                                            typeString: 'uint256'
                                        }
                                    },
                                    value: null,
                                    visibility: 'internal'
                                }
                            ],
                            src: '2392:127:1'
                        },
                        scope: 314,
                        src: '2303:521:1',
                        stateMutability: 'nonpayable',
                        superFunction: null,
                        visibility: 'public'
                    },
                    {
                        body: {
                            id: 256,
                            nodeType: 'Block',
                            src: '3130:328:1',
                            statements: [
                                {
                                    condition: {
                                        argumentTypes: null,
                                        id: 241,
                                        isConstant: false,
                                        isLValue: false,
                                        isPure: false,
                                        lValueRequested: false,
                                        nodeType: 'UnaryOperation',
                                        operator: '!',
                                        prefix: true,
                                        src: '3145:164:1',
                                        subExpression: {
                                            argumentTypes: null,
                                            arguments: [
                                                {
                                                    argumentTypes: null,
                                                    id: 235,
                                                    name: 'carrier',
                                                    nodeType: 'Identifier',
                                                    overloadedDeclarations: [],
                                                    referencedDeclaration: 223,
                                                    src: '3176:7:1',
                                                    typeDescriptions: {
                                                        typeIdentifier: 't_address',
                                                        typeString: 'address'
                                                    }
                                                },
                                                {
                                                    argumentTypes: null,
                                                    id: 236,
                                                    name: 'quoteHash',
                                                    nodeType: 'Identifier',
                                                    overloadedDeclarations: [],
                                                    referencedDeclaration: 221,
                                                    src: '3197:9:1',
                                                    typeDescriptions: {
                                                        typeIdentifier: 't_bytes32',
                                                        typeString: 'bytes32'
                                                    }
                                                },
                                                {
                                                    argumentTypes: null,
                                                    id: 237,
                                                    name: 'carrierSignatureV',
                                                    nodeType: 'Identifier',
                                                    overloadedDeclarations: [],
                                                    referencedDeclaration: 225,
                                                    src: '3220:17:1',
                                                    typeDescriptions: {
                                                        typeIdentifier: 't_uint8',
                                                        typeString: 'uint8'
                                                    }
                                                },
                                                {
                                                    argumentTypes: null,
                                                    id: 238,
                                                    name: 'carrierSignatureR',
                                                    nodeType: 'Identifier',
                                                    overloadedDeclarations: [],
                                                    referencedDeclaration: 227,
                                                    src: '3251:17:1',
                                                    typeDescriptions: {
                                                        typeIdentifier: 't_bytes32',
                                                        typeString: 'bytes32'
                                                    }
                                                },
                                                {
                                                    argumentTypes: null,
                                                    id: 239,
                                                    name: 'carrierSignatureS',
                                                    nodeType: 'Identifier',
                                                    overloadedDeclarations: [],
                                                    referencedDeclaration: 229,
                                                    src: '3282:17:1',
                                                    typeDescriptions: {
                                                        typeIdentifier: 't_bytes32',
                                                        typeString: 'bytes32'
                                                    }
                                                }
                                            ],
                                            expression: {
                                                argumentTypes: [
                                                    {
                                                        typeIdentifier: 't_address',
                                                        typeString: 'address'
                                                    },
                                                    {
                                                        typeIdentifier: 't_bytes32',
                                                        typeString: 'bytes32'
                                                    },
                                                    {
                                                        typeIdentifier: 't_uint8',
                                                        typeString: 'uint8'
                                                    },
                                                    {
                                                        typeIdentifier: 't_bytes32',
                                                        typeString: 'bytes32'
                                                    },
                                                    {
                                                        typeIdentifier: 't_bytes32',
                                                        typeString: 'bytes32'
                                                    }
                                                ],
                                                id: 234,
                                                name: 'isValidSignature',
                                                nodeType: 'Identifier',
                                                overloadedDeclarations: [],
                                                referencedDeclaration: 313,
                                                src: '3146:16:1',
                                                typeDescriptions: {
                                                    typeIdentifier:
                                                        't_function_internal_pure$_t_address_$_t_bytes32_$_t_uint8_$_t_bytes32_$_t_bytes32_$returns$_t_bool_$',
                                                    typeString:
                                                        'function (address,bytes32,uint8,bytes32,bytes32) pure returns (bool)'
                                                }
                                            },
                                            id: 240,
                                            isConstant: false,
                                            isLValue: false,
                                            isPure: false,
                                            kind: 'functionCall',
                                            lValueRequested: false,
                                            names: [],
                                            nodeType: 'FunctionCall',
                                            src: '3146:163:1',
                                            typeDescriptions: {
                                                typeIdentifier: 't_bool',
                                                typeString: 'bool'
                                            }
                                        },
                                        typeDescriptions: {
                                            typeIdentifier: 't_bool',
                                            typeString: 'bool'
                                        }
                                    },
                                    falseBody: null,
                                    id: 253,
                                    nodeType: 'IfStatement',
                                    src: '3141:289:1',
                                    trueBody: {
                                        id: 252,
                                        nodeType: 'Block',
                                        src: '3311:119:1',
                                        statements: [
                                            {
                                                eventCall: {
                                                    argumentTypes: null,
                                                    arguments: [
                                                        {
                                                            argumentTypes: null,
                                                            arguments: [
                                                                {
                                                                    argumentTypes: null,
                                                                    expression: {
                                                                        argumentTypes: null,
                                                                        id: 244,
                                                                        name: 'Errors',
                                                                        nodeType: 'Identifier',
                                                                        overloadedDeclarations: [],
                                                                        referencedDeclaration: 66,
                                                                        src: '3345:6:1',
                                                                        typeDescriptions: {
                                                                            typeIdentifier:
                                                                                't_type$_t_enum$_Errors_$66_$',
                                                                            typeString:
                                                                                'type(enum PolicyRegistry.Errors)'
                                                                        }
                                                                    },
                                                                    id: 245,
                                                                    isConstant: false,
                                                                    isLValue: false,
                                                                    isPure: true,
                                                                    lValueRequested: false,
                                                                    memberName:
                                                                        'ORDER_INVALID_NON_CONSENSUAL',
                                                                    nodeType: 'MemberAccess',
                                                                    referencedDeclaration: null,
                                                                    src: '3345:35:1',
                                                                    typeDescriptions: {
                                                                        typeIdentifier:
                                                                            't_enum$_Errors_$66',
                                                                        typeString:
                                                                            'enum PolicyRegistry.Errors'
                                                                    }
                                                                }
                                                            ],
                                                            expression: {
                                                                argumentTypes: [
                                                                    {
                                                                        typeIdentifier:
                                                                            't_enum$_Errors_$66',
                                                                        typeString:
                                                                            'enum PolicyRegistry.Errors'
                                                                    }
                                                                ],
                                                                id: 243,
                                                                isConstant: false,
                                                                isLValue: false,
                                                                isPure: true,
                                                                lValueRequested: false,
                                                                nodeType:
                                                                    'ElementaryTypeNameExpression',
                                                                src: '3339:5:1',
                                                                typeDescriptions: {
                                                                    typeIdentifier:
                                                                        't_type$_t_uint8_$',
                                                                    typeString: 'type(uint8)'
                                                                },
                                                                typeName: 'uint8'
                                                            },
                                                            id: 246,
                                                            isConstant: false,
                                                            isLValue: false,
                                                            isPure: true,
                                                            kind: 'typeConversion',
                                                            lValueRequested: false,
                                                            names: [],
                                                            nodeType: 'FunctionCall',
                                                            src: '3339:42:1',
                                                            typeDescriptions: {
                                                                typeIdentifier: 't_uint8',
                                                                typeString: 'uint8'
                                                            }
                                                        },
                                                        {
                                                            argumentTypes: null,
                                                            id: 247,
                                                            name: 'orderHash',
                                                            nodeType: 'Identifier',
                                                            overloadedDeclarations: [],
                                                            referencedDeclaration: 219,
                                                            src: '3383:9:1',
                                                            typeDescriptions: {
                                                                typeIdentifier: 't_bytes32',
                                                                typeString: 'bytes32'
                                                            }
                                                        }
                                                    ],
                                                    expression: {
                                                        argumentTypes: [
                                                            {
                                                                typeIdentifier: 't_uint8',
                                                                typeString: 'uint8'
                                                            },
                                                            {
                                                                typeIdentifier: 't_bytes32',
                                                                typeString: 'bytes32'
                                                            }
                                                        ],
                                                        id: 242,
                                                        name: 'LogError',
                                                        nodeType: 'Identifier',
                                                        overloadedDeclarations: [],
                                                        referencedDeclaration: 92,
                                                        src: '3330:8:1',
                                                        typeDescriptions: {
                                                            typeIdentifier:
                                                                't_function_event_nonpayable$_t_uint8_$_t_bytes32_$returns$__$',
                                                            typeString: 'function (uint8,bytes32)'
                                                        }
                                                    },
                                                    id: 248,
                                                    isConstant: false,
                                                    isLValue: false,
                                                    isPure: false,
                                                    kind: 'functionCall',
                                                    lValueRequested: false,
                                                    names: [],
                                                    nodeType: 'FunctionCall',
                                                    src: '3330:63:1',
                                                    typeDescriptions: {
                                                        typeIdentifier: 't_tuple$__$',
                                                        typeString: 'tuple()'
                                                    }
                                                },
                                                id: 249,
                                                nodeType: 'EmitStatement',
                                                src: '3325:68:1'
                                            },
                                            {
                                                expression: {
                                                    argumentTypes: null,
                                                    hexValue: '66616c7365',
                                                    id: 250,
                                                    isConstant: false,
                                                    isLValue: false,
                                                    isPure: true,
                                                    kind: 'bool',
                                                    lValueRequested: false,
                                                    nodeType: 'Literal',
                                                    src: '3414:5:1',
                                                    subdenomination: null,
                                                    typeDescriptions: {
                                                        typeIdentifier: 't_bool',
                                                        typeString: 'bool'
                                                    },
                                                    value: 'false'
                                                },
                                                functionReturnParameters: 233,
                                                id: 251,
                                                nodeType: 'Return',
                                                src: '3407:12:1'
                                            }
                                        ]
                                    }
                                },
                                {
                                    expression: {
                                        argumentTypes: null,
                                        hexValue: '74727565',
                                        id: 254,
                                        isConstant: false,
                                        isLValue: false,
                                        isPure: true,
                                        kind: 'bool',
                                        lValueRequested: false,
                                        nodeType: 'Literal',
                                        src: '3447:4:1',
                                        subdenomination: null,
                                        typeDescriptions: {
                                            typeIdentifier: 't_bool',
                                            typeString: 'bool'
                                        },
                                        value: 'true'
                                    },
                                    functionReturnParameters: 233,
                                    id: 255,
                                    nodeType: 'Return',
                                    src: '3440:11:1'
                                }
                            ]
                        },
                        documentation: 'Internal functions ',
                        id: 257,
                        implemented: true,
                        isConstructor: false,
                        isDeclaredConst: false,
                        modifiers: [],
                        name: 'assertPolicyOrderConsensual',
                        nodeType: 'FunctionDefinition',
                        parameters: {
                            id: 230,
                            nodeType: 'ParameterList',
                            parameters: [
                                {
                                    constant: false,
                                    id: 219,
                                    name: 'orderHash',
                                    nodeType: 'VariableDeclaration',
                                    scope: 257,
                                    src: '2907:17:1',
                                    stateVariable: false,
                                    storageLocation: 'default',
                                    typeDescriptions: {
                                        typeIdentifier: 't_bytes32',
                                        typeString: 'bytes32'
                                    },
                                    typeName: {
                                        id: 218,
                                        name: 'bytes32',
                                        nodeType: 'ElementaryTypeName',
                                        src: '2907:7:1',
                                        typeDescriptions: {
                                            typeIdentifier: 't_bytes32',
                                            typeString: 'bytes32'
                                        }
                                    },
                                    value: null,
                                    visibility: 'internal'
                                },
                                {
                                    constant: false,
                                    id: 221,
                                    name: 'quoteHash',
                                    nodeType: 'VariableDeclaration',
                                    scope: 257,
                                    src: '2934:17:1',
                                    stateVariable: false,
                                    storageLocation: 'default',
                                    typeDescriptions: {
                                        typeIdentifier: 't_bytes32',
                                        typeString: 'bytes32'
                                    },
                                    typeName: {
                                        id: 220,
                                        name: 'bytes32',
                                        nodeType: 'ElementaryTypeName',
                                        src: '2934:7:1',
                                        typeDescriptions: {
                                            typeIdentifier: 't_bytes32',
                                            typeString: 'bytes32'
                                        }
                                    },
                                    value: null,
                                    visibility: 'internal'
                                },
                                {
                                    constant: false,
                                    id: 223,
                                    name: 'carrier',
                                    nodeType: 'VariableDeclaration',
                                    scope: 257,
                                    src: '2961:15:1',
                                    stateVariable: false,
                                    storageLocation: 'default',
                                    typeDescriptions: {
                                        typeIdentifier: 't_address',
                                        typeString: 'address'
                                    },
                                    typeName: {
                                        id: 222,
                                        name: 'address',
                                        nodeType: 'ElementaryTypeName',
                                        src: '2961:7:1',
                                        typeDescriptions: {
                                            typeIdentifier: 't_address',
                                            typeString: 'address'
                                        }
                                    },
                                    value: null,
                                    visibility: 'internal'
                                },
                                {
                                    constant: false,
                                    id: 225,
                                    name: 'carrierSignatureV',
                                    nodeType: 'VariableDeclaration',
                                    scope: 257,
                                    src: '2986:23:1',
                                    stateVariable: false,
                                    storageLocation: 'default',
                                    typeDescriptions: {
                                        typeIdentifier: 't_uint8',
                                        typeString: 'uint8'
                                    },
                                    typeName: {
                                        id: 224,
                                        name: 'uint8',
                                        nodeType: 'ElementaryTypeName',
                                        src: '2986:5:1',
                                        typeDescriptions: {
                                            typeIdentifier: 't_uint8',
                                            typeString: 'uint8'
                                        }
                                    },
                                    value: null,
                                    visibility: 'internal'
                                },
                                {
                                    constant: false,
                                    id: 227,
                                    name: 'carrierSignatureR',
                                    nodeType: 'VariableDeclaration',
                                    scope: 257,
                                    src: '3019:25:1',
                                    stateVariable: false,
                                    storageLocation: 'default',
                                    typeDescriptions: {
                                        typeIdentifier: 't_bytes32',
                                        typeString: 'bytes32'
                                    },
                                    typeName: {
                                        id: 226,
                                        name: 'bytes32',
                                        nodeType: 'ElementaryTypeName',
                                        src: '3019:7:1',
                                        typeDescriptions: {
                                            typeIdentifier: 't_bytes32',
                                            typeString: 'bytes32'
                                        }
                                    },
                                    value: null,
                                    visibility: 'internal'
                                },
                                {
                                    constant: false,
                                    id: 229,
                                    name: 'carrierSignatureS',
                                    nodeType: 'VariableDeclaration',
                                    scope: 257,
                                    src: '3054:25:1',
                                    stateVariable: false,
                                    storageLocation: 'default',
                                    typeDescriptions: {
                                        typeIdentifier: 't_bytes32',
                                        typeString: 'bytes32'
                                    },
                                    typeName: {
                                        id: 228,
                                        name: 'bytes32',
                                        nodeType: 'ElementaryTypeName',
                                        src: '3054:7:1',
                                        typeDescriptions: {
                                            typeIdentifier: 't_bytes32',
                                            typeString: 'bytes32'
                                        }
                                    },
                                    value: null,
                                    visibility: 'internal'
                                }
                            ],
                            src: '2897:188:1'
                        },
                        payable: false,
                        returnParameters: {
                            id: 233,
                            nodeType: 'ParameterList',
                            parameters: [
                                {
                                    constant: false,
                                    id: 232,
                                    name: '',
                                    nodeType: 'VariableDeclaration',
                                    scope: 257,
                                    src: '3120:4:1',
                                    stateVariable: false,
                                    storageLocation: 'default',
                                    typeDescriptions: {
                                        typeIdentifier: 't_bool',
                                        typeString: 'bool'
                                    },
                                    typeName: {
                                        id: 231,
                                        name: 'bool',
                                        nodeType: 'ElementaryTypeName',
                                        src: '3120:4:1',
                                        typeDescriptions: {
                                            typeIdentifier: 't_bool',
                                            typeString: 'bool'
                                        }
                                    },
                                    value: null,
                                    visibility: 'internal'
                                }
                            ],
                            src: '3119:6:1'
                        },
                        scope: 314,
                        src: '2861:597:1',
                        stateMutability: 'nonpayable',
                        superFunction: null,
                        visibility: 'internal'
                    },
                    {
                        body: {
                            id: 284,
                            nodeType: 'Block',
                            src: '3612:189:1',
                            statements: [
                                {
                                    condition: {
                                        argumentTypes: null,
                                        commonType: {
                                            typeIdentifier: 't_uint256',
                                            typeString: 'uint256'
                                        },
                                        id: 269,
                                        isConstant: false,
                                        isLValue: false,
                                        isPure: false,
                                        lValueRequested: false,
                                        leftExpression: {
                                            argumentTypes: null,
                                            id: 266,
                                            name: 'expirationTimestampInSec',
                                            nodeType: 'Identifier',
                                            overloadedDeclarations: [],
                                            referencedDeclaration: 259,
                                            src: '3626:24:1',
                                            typeDescriptions: {
                                                typeIdentifier: 't_uint256',
                                                typeString: 'uint256'
                                            }
                                        },
                                        nodeType: 'BinaryOperation',
                                        operator: '<',
                                        rightExpression: {
                                            argumentTypes: null,
                                            expression: {
                                                argumentTypes: null,
                                                id: 267,
                                                name: 'block',
                                                nodeType: 'Identifier',
                                                overloadedDeclarations: [],
                                                referencedDeclaration: 413,
                                                src: '3653:5:1',
                                                typeDescriptions: {
                                                    typeIdentifier: 't_magic_block',
                                                    typeString: 'block'
                                                }
                                            },
                                            id: 268,
                                            isConstant: false,
                                            isLValue: false,
                                            isPure: false,
                                            lValueRequested: false,
                                            memberName: 'timestamp',
                                            nodeType: 'MemberAccess',
                                            referencedDeclaration: null,
                                            src: '3653:15:1',
                                            typeDescriptions: {
                                                typeIdentifier: 't_uint256',
                                                typeString: 'uint256'
                                            }
                                        },
                                        src: '3626:42:1',
                                        typeDescriptions: {
                                            typeIdentifier: 't_bool',
                                            typeString: 'bool'
                                        }
                                    },
                                    falseBody: null,
                                    id: 281,
                                    nodeType: 'IfStatement',
                                    src: '3622:152:1',
                                    trueBody: {
                                        id: 280,
                                        nodeType: 'Block',
                                        src: '3670:104:1',
                                        statements: [
                                            {
                                                eventCall: {
                                                    argumentTypes: null,
                                                    arguments: [
                                                        {
                                                            argumentTypes: null,
                                                            arguments: [
                                                                {
                                                                    argumentTypes: null,
                                                                    expression: {
                                                                        argumentTypes: null,
                                                                        id: 272,
                                                                        name: 'Errors',
                                                                        nodeType: 'Identifier',
                                                                        overloadedDeclarations: [],
                                                                        referencedDeclaration: 66,
                                                                        src: '3704:6:1',
                                                                        typeDescriptions: {
                                                                            typeIdentifier:
                                                                                't_type$_t_enum$_Errors_$66_$',
                                                                            typeString:
                                                                                'type(enum PolicyRegistry.Errors)'
                                                                        }
                                                                    },
                                                                    id: 273,
                                                                    isConstant: false,
                                                                    isLValue: false,
                                                                    isPure: true,
                                                                    lValueRequested: false,
                                                                    memberName: 'ORDER_EXPIRED',
                                                                    nodeType: 'MemberAccess',
                                                                    referencedDeclaration: null,
                                                                    src: '3704:20:1',
                                                                    typeDescriptions: {
                                                                        typeIdentifier:
                                                                            't_enum$_Errors_$66',
                                                                        typeString:
                                                                            'enum PolicyRegistry.Errors'
                                                                    }
                                                                }
                                                            ],
                                                            expression: {
                                                                argumentTypes: [
                                                                    {
                                                                        typeIdentifier:
                                                                            't_enum$_Errors_$66',
                                                                        typeString:
                                                                            'enum PolicyRegistry.Errors'
                                                                    }
                                                                ],
                                                                id: 271,
                                                                isConstant: false,
                                                                isLValue: false,
                                                                isPure: true,
                                                                lValueRequested: false,
                                                                nodeType:
                                                                    'ElementaryTypeNameExpression',
                                                                src: '3698:5:1',
                                                                typeDescriptions: {
                                                                    typeIdentifier:
                                                                        't_type$_t_uint8_$',
                                                                    typeString: 'type(uint8)'
                                                                },
                                                                typeName: 'uint8'
                                                            },
                                                            id: 274,
                                                            isConstant: false,
                                                            isLValue: false,
                                                            isPure: true,
                                                            kind: 'typeConversion',
                                                            lValueRequested: false,
                                                            names: [],
                                                            nodeType: 'FunctionCall',
                                                            src: '3698:27:1',
                                                            typeDescriptions: {
                                                                typeIdentifier: 't_uint8',
                                                                typeString: 'uint8'
                                                            }
                                                        },
                                                        {
                                                            argumentTypes: null,
                                                            id: 275,
                                                            name: 'orderHash',
                                                            nodeType: 'Identifier',
                                                            overloadedDeclarations: [],
                                                            referencedDeclaration: 261,
                                                            src: '3727:9:1',
                                                            typeDescriptions: {
                                                                typeIdentifier: 't_bytes32',
                                                                typeString: 'bytes32'
                                                            }
                                                        }
                                                    ],
                                                    expression: {
                                                        argumentTypes: [
                                                            {
                                                                typeIdentifier: 't_uint8',
                                                                typeString: 'uint8'
                                                            },
                                                            {
                                                                typeIdentifier: 't_bytes32',
                                                                typeString: 'bytes32'
                                                            }
                                                        ],
                                                        id: 270,
                                                        name: 'LogError',
                                                        nodeType: 'Identifier',
                                                        overloadedDeclarations: [],
                                                        referencedDeclaration: 92,
                                                        src: '3689:8:1',
                                                        typeDescriptions: {
                                                            typeIdentifier:
                                                                't_function_event_nonpayable$_t_uint8_$_t_bytes32_$returns$__$',
                                                            typeString: 'function (uint8,bytes32)'
                                                        }
                                                    },
                                                    id: 276,
                                                    isConstant: false,
                                                    isLValue: false,
                                                    isPure: false,
                                                    kind: 'functionCall',
                                                    lValueRequested: false,
                                                    names: [],
                                                    nodeType: 'FunctionCall',
                                                    src: '3689:48:1',
                                                    typeDescriptions: {
                                                        typeIdentifier: 't_tuple$__$',
                                                        typeString: 'tuple()'
                                                    }
                                                },
                                                id: 277,
                                                nodeType: 'EmitStatement',
                                                src: '3684:53:1'
                                            },
                                            {
                                                expression: {
                                                    argumentTypes: null,
                                                    hexValue: '66616c7365',
                                                    id: 278,
                                                    isConstant: false,
                                                    isLValue: false,
                                                    isPure: true,
                                                    kind: 'bool',
                                                    lValueRequested: false,
                                                    nodeType: 'Literal',
                                                    src: '3758:5:1',
                                                    subdenomination: null,
                                                    typeDescriptions: {
                                                        typeIdentifier: 't_bool',
                                                        typeString: 'bool'
                                                    },
                                                    value: 'false'
                                                },
                                                functionReturnParameters: 265,
                                                id: 279,
                                                nodeType: 'Return',
                                                src: '3751:12:1'
                                            }
                                        ]
                                    }
                                },
                                {
                                    expression: {
                                        argumentTypes: null,
                                        hexValue: '74727565',
                                        id: 282,
                                        isConstant: false,
                                        isLValue: false,
                                        isPure: true,
                                        kind: 'bool',
                                        lValueRequested: false,
                                        nodeType: 'Literal',
                                        src: '3790:4:1',
                                        subdenomination: null,
                                        typeDescriptions: {
                                            typeIdentifier: 't_bool',
                                            typeString: 'bool'
                                        },
                                        value: 'true'
                                    },
                                    functionReturnParameters: 265,
                                    id: 283,
                                    nodeType: 'Return',
                                    src: '3783:11:1'
                                }
                            ]
                        },
                        documentation: null,
                        id: 285,
                        implemented: true,
                        isConstructor: false,
                        isDeclaredConst: false,
                        modifiers: [],
                        name: 'assertPolicyOrderValid',
                        nodeType: 'FunctionDefinition',
                        parameters: {
                            id: 262,
                            nodeType: 'ParameterList',
                            parameters: [
                                {
                                    constant: false,
                                    id: 259,
                                    name: 'expirationTimestampInSec',
                                    nodeType: 'VariableDeclaration',
                                    scope: 285,
                                    src: '3505:29:1',
                                    stateVariable: false,
                                    storageLocation: 'default',
                                    typeDescriptions: {
                                        typeIdentifier: 't_uint256',
                                        typeString: 'uint256'
                                    },
                                    typeName: {
                                        id: 258,
                                        name: 'uint',
                                        nodeType: 'ElementaryTypeName',
                                        src: '3505:4:1',
                                        typeDescriptions: {
                                            typeIdentifier: 't_uint256',
                                            typeString: 'uint256'
                                        }
                                    },
                                    value: null,
                                    visibility: 'internal'
                                },
                                {
                                    constant: false,
                                    id: 261,
                                    name: 'orderHash',
                                    nodeType: 'VariableDeclaration',
                                    scope: 285,
                                    src: '3544:17:1',
                                    stateVariable: false,
                                    storageLocation: 'default',
                                    typeDescriptions: {
                                        typeIdentifier: 't_bytes32',
                                        typeString: 'bytes32'
                                    },
                                    typeName: {
                                        id: 260,
                                        name: 'bytes32',
                                        nodeType: 'ElementaryTypeName',
                                        src: '3544:7:1',
                                        typeDescriptions: {
                                            typeIdentifier: 't_bytes32',
                                            typeString: 'bytes32'
                                        }
                                    },
                                    value: null,
                                    visibility: 'internal'
                                }
                            ],
                            src: '3495:72:1'
                        },
                        payable: false,
                        returnParameters: {
                            id: 265,
                            nodeType: 'ParameterList',
                            parameters: [
                                {
                                    constant: false,
                                    id: 264,
                                    name: '',
                                    nodeType: 'VariableDeclaration',
                                    scope: 285,
                                    src: '3602:4:1',
                                    stateVariable: false,
                                    storageLocation: 'default',
                                    typeDescriptions: {
                                        typeIdentifier: 't_bool',
                                        typeString: 'bool'
                                    },
                                    typeName: {
                                        id: 263,
                                        name: 'bool',
                                        nodeType: 'ElementaryTypeName',
                                        src: '3602:4:1',
                                        typeDescriptions: {
                                            typeIdentifier: 't_bool',
                                            typeString: 'bool'
                                        }
                                    },
                                    value: null,
                                    visibility: 'internal'
                                }
                            ],
                            src: '3601:6:1'
                        },
                        scope: 314,
                        src: '3464:337:1',
                        stateMutability: 'nonpayable',
                        superFunction: null,
                        visibility: 'internal'
                    },
                    {
                        body: {
                            id: 312,
                            nodeType: 'Block',
                            src: '4004:172:1',
                            statements: [
                                {
                                    expression: {
                                        argumentTypes: null,
                                        commonType: {
                                            typeIdentifier: 't_address',
                                            typeString: 'address'
                                        },
                                        id: 310,
                                        isConstant: false,
                                        isLValue: false,
                                        isPure: false,
                                        lValueRequested: false,
                                        leftExpression: {
                                            argumentTypes: null,
                                            id: 300,
                                            name: 'signer',
                                            nodeType: 'Identifier',
                                            overloadedDeclarations: [],
                                            referencedDeclaration: 287,
                                            src: '4030:6:1',
                                            typeDescriptions: {
                                                typeIdentifier: 't_address',
                                                typeString: 'address'
                                            }
                                        },
                                        nodeType: 'BinaryOperation',
                                        operator: '==',
                                        rightExpression: {
                                            argumentTypes: null,
                                            arguments: [
                                                {
                                                    argumentTypes: null,
                                                    arguments: [
                                                        {
                                                            argumentTypes: null,
                                                            hexValue:
                                                                '19457468657265756d205369676e6564204d6573736167653a0a3332',
                                                            id: 303,
                                                            isConstant: false,
                                                            isLValue: false,
                                                            isPure: true,
                                                            kind: 'string',
                                                            lValueRequested: false,
                                                            nodeType: 'Literal',
                                                            src: '4073:34:1',
                                                            subdenomination: null,
                                                            typeDescriptions: {
                                                                typeIdentifier:
                                                                    't_stringliteral_178a2411ab6fbc1ba11064408972259c558d0e82fd48b0aba3ad81d14f065e73',
                                                                typeString:
                                                                    'literal_string "\u0019Ethereum Signed Message:\n32"'
                                                            },
                                                            value:
                                                                '\u0019Ethereum Signed Message:\n32'
                                                        },
                                                        {
                                                            argumentTypes: null,
                                                            id: 304,
                                                            name: 'hash',
                                                            nodeType: 'Identifier',
                                                            overloadedDeclarations: [],
                                                            referencedDeclaration: 289,
                                                            src: '4109:4:1',
                                                            typeDescriptions: {
                                                                typeIdentifier: 't_bytes32',
                                                                typeString: 'bytes32'
                                                            }
                                                        }
                                                    ],
                                                    expression: {
                                                        argumentTypes: [
                                                            {
                                                                typeIdentifier:
                                                                    't_stringliteral_178a2411ab6fbc1ba11064408972259c558d0e82fd48b0aba3ad81d14f065e73',
                                                                typeString:
                                                                    'literal_string "\u0019Ethereum Signed Message:\n32"'
                                                            },
                                                            {
                                                                typeIdentifier: 't_bytes32',
                                                                typeString: 'bytes32'
                                                            }
                                                        ],
                                                        id: 302,
                                                        name: 'keccak256',
                                                        nodeType: 'Identifier',
                                                        overloadedDeclarations: [],
                                                        referencedDeclaration: 417,
                                                        src: '4063:9:1',
                                                        typeDescriptions: {
                                                            typeIdentifier:
                                                                't_function_sha3_pure$__$returns$_t_bytes32_$',
                                                            typeString:
                                                                'function () pure returns (bytes32)'
                                                        }
                                                    },
                                                    id: 305,
                                                    isConstant: false,
                                                    isLValue: false,
                                                    isPure: false,
                                                    kind: 'functionCall',
                                                    lValueRequested: false,
                                                    names: [],
                                                    nodeType: 'FunctionCall',
                                                    src: '4063:51:1',
                                                    typeDescriptions: {
                                                        typeIdentifier: 't_bytes32',
                                                        typeString: 'bytes32'
                                                    }
                                                },
                                                {
                                                    argumentTypes: null,
                                                    id: 306,
                                                    name: 'v',
                                                    nodeType: 'Identifier',
                                                    overloadedDeclarations: [],
                                                    referencedDeclaration: 291,
                                                    src: '4128:1:1',
                                                    typeDescriptions: {
                                                        typeIdentifier: 't_uint8',
                                                        typeString: 'uint8'
                                                    }
                                                },
                                                {
                                                    argumentTypes: null,
                                                    id: 307,
                                                    name: 'r',
                                                    nodeType: 'Identifier',
                                                    overloadedDeclarations: [],
                                                    referencedDeclaration: 293,
                                                    src: '4143:1:1',
                                                    typeDescriptions: {
                                                        typeIdentifier: 't_bytes32',
                                                        typeString: 'bytes32'
                                                    }
                                                },
                                                {
                                                    argumentTypes: null,
                                                    id: 308,
                                                    name: 's',
                                                    nodeType: 'Identifier',
                                                    overloadedDeclarations: [],
                                                    referencedDeclaration: 295,
                                                    src: '4158:1:1',
                                                    typeDescriptions: {
                                                        typeIdentifier: 't_bytes32',
                                                        typeString: 'bytes32'
                                                    }
                                                }
                                            ],
                                            expression: {
                                                argumentTypes: [
                                                    {
                                                        typeIdentifier: 't_bytes32',
                                                        typeString: 'bytes32'
                                                    },
                                                    {
                                                        typeIdentifier: 't_uint8',
                                                        typeString: 'uint8'
                                                    },
                                                    {
                                                        typeIdentifier: 't_bytes32',
                                                        typeString: 'bytes32'
                                                    },
                                                    {
                                                        typeIdentifier: 't_bytes32',
                                                        typeString: 'bytes32'
                                                    }
                                                ],
                                                id: 301,
                                                name: 'ecrecover',
                                                nodeType: 'Identifier',
                                                overloadedDeclarations: [],
                                                referencedDeclaration: 415,
                                                src: '4040:9:1',
                                                typeDescriptions: {
                                                    typeIdentifier:
                                                        't_function_ecrecover_pure$_t_bytes32_$_t_uint8_$_t_bytes32_$_t_bytes32_$returns$_t_address_$',
                                                    typeString:
                                                        'function (bytes32,uint8,bytes32,bytes32) pure returns (address)'
                                                }
                                            },
                                            id: 309,
                                            isConstant: false,
                                            isLValue: false,
                                            isPure: false,
                                            kind: 'functionCall',
                                            lValueRequested: false,
                                            names: [],
                                            nodeType: 'FunctionCall',
                                            src: '4040:129:1',
                                            typeDescriptions: {
                                                typeIdentifier: 't_address',
                                                typeString: 'address'
                                            }
                                        },
                                        src: '4030:139:1',
                                        typeDescriptions: {
                                            typeIdentifier: 't_bool',
                                            typeString: 'bool'
                                        }
                                    },
                                    functionReturnParameters: 299,
                                    id: 311,
                                    nodeType: 'Return',
                                    src: '4023:146:1'
                                }
                            ]
                        },
                        documentation: null,
                        id: 313,
                        implemented: true,
                        isConstructor: false,
                        isDeclaredConst: true,
                        modifiers: [],
                        name: 'isValidSignature',
                        nodeType: 'FunctionDefinition',
                        parameters: {
                            id: 296,
                            nodeType: 'ParameterList',
                            parameters: [
                                {
                                    constant: false,
                                    id: 287,
                                    name: 'signer',
                                    nodeType: 'VariableDeclaration',
                                    scope: 313,
                                    src: '3842:14:1',
                                    stateVariable: false,
                                    storageLocation: 'default',
                                    typeDescriptions: {
                                        typeIdentifier: 't_address',
                                        typeString: 'address'
                                    },
                                    typeName: {
                                        id: 286,
                                        name: 'address',
                                        nodeType: 'ElementaryTypeName',
                                        src: '3842:7:1',
                                        typeDescriptions: {
                                            typeIdentifier: 't_address',
                                            typeString: 'address'
                                        }
                                    },
                                    value: null,
                                    visibility: 'internal'
                                },
                                {
                                    constant: false,
                                    id: 289,
                                    name: 'hash',
                                    nodeType: 'VariableDeclaration',
                                    scope: 313,
                                    src: '3866:12:1',
                                    stateVariable: false,
                                    storageLocation: 'default',
                                    typeDescriptions: {
                                        typeIdentifier: 't_bytes32',
                                        typeString: 'bytes32'
                                    },
                                    typeName: {
                                        id: 288,
                                        name: 'bytes32',
                                        nodeType: 'ElementaryTypeName',
                                        src: '3866:7:1',
                                        typeDescriptions: {
                                            typeIdentifier: 't_bytes32',
                                            typeString: 'bytes32'
                                        }
                                    },
                                    value: null,
                                    visibility: 'internal'
                                },
                                {
                                    constant: false,
                                    id: 291,
                                    name: 'v',
                                    nodeType: 'VariableDeclaration',
                                    scope: 313,
                                    src: '3888:7:1',
                                    stateVariable: false,
                                    storageLocation: 'default',
                                    typeDescriptions: {
                                        typeIdentifier: 't_uint8',
                                        typeString: 'uint8'
                                    },
                                    typeName: {
                                        id: 290,
                                        name: 'uint8',
                                        nodeType: 'ElementaryTypeName',
                                        src: '3888:5:1',
                                        typeDescriptions: {
                                            typeIdentifier: 't_uint8',
                                            typeString: 'uint8'
                                        }
                                    },
                                    value: null,
                                    visibility: 'internal'
                                },
                                {
                                    constant: false,
                                    id: 293,
                                    name: 'r',
                                    nodeType: 'VariableDeclaration',
                                    scope: 313,
                                    src: '3905:9:1',
                                    stateVariable: false,
                                    storageLocation: 'default',
                                    typeDescriptions: {
                                        typeIdentifier: 't_bytes32',
                                        typeString: 'bytes32'
                                    },
                                    typeName: {
                                        id: 292,
                                        name: 'bytes32',
                                        nodeType: 'ElementaryTypeName',
                                        src: '3905:7:1',
                                        typeDescriptions: {
                                            typeIdentifier: 't_bytes32',
                                            typeString: 'bytes32'
                                        }
                                    },
                                    value: null,
                                    visibility: 'internal'
                                },
                                {
                                    constant: false,
                                    id: 295,
                                    name: 's',
                                    nodeType: 'VariableDeclaration',
                                    scope: 313,
                                    src: '3924:9:1',
                                    stateVariable: false,
                                    storageLocation: 'default',
                                    typeDescriptions: {
                                        typeIdentifier: 't_bytes32',
                                        typeString: 'bytes32'
                                    },
                                    typeName: {
                                        id: 294,
                                        name: 'bytes32',
                                        nodeType: 'ElementaryTypeName',
                                        src: '3924:7:1',
                                        typeDescriptions: {
                                            typeIdentifier: 't_bytes32',
                                            typeString: 'bytes32'
                                        }
                                    },
                                    value: null,
                                    visibility: 'internal'
                                }
                            ],
                            src: '3832:107:1'
                        },
                        payable: false,
                        returnParameters: {
                            id: 299,
                            nodeType: 'ParameterList',
                            parameters: [
                                {
                                    constant: false,
                                    id: 298,
                                    name: '_valid',
                                    nodeType: 'VariableDeclaration',
                                    scope: 313,
                                    src: '3987:11:1',
                                    stateVariable: false,
                                    storageLocation: 'default',
                                    typeDescriptions: {
                                        typeIdentifier: 't_bool',
                                        typeString: 'bool'
                                    },
                                    typeName: {
                                        id: 297,
                                        name: 'bool',
                                        nodeType: 'ElementaryTypeName',
                                        src: '3987:4:1',
                                        typeDescriptions: {
                                            typeIdentifier: 't_bool',
                                            typeString: 'bool'
                                        }
                                    },
                                    value: null,
                                    visibility: 'internal'
                                }
                            ],
                            src: '3986:13:1'
                        },
                        scope: 314,
                        src: '3807:369:1',
                        stateMutability: 'pure',
                        superFunction: null,
                        visibility: 'internal'
                    }
                ],
                scope: 315,
                src: '88:4090:1'
            }
        ],
        src: '0:4178:1'
    },
    compiler: {
        name: 'solc',
        version: '0.4.24+commit.e67f0147.Emscripten.clang'
    },
    networks: {
        '4': {
            events: {},
            links: {},
            address: "0xecf0e9f852163bc127a1b087ff51dad65241c55a",
            transactionHash: "0x4d68a868b0f36272c02b402dfe08022ab0f724924824f7d3c2bad50e61888850"
        },
        '66677': {
            events: {},
            links: {},
            address: '0xd0e3039605ee0cf31dcd715b215c78def9809fe2',
            transactionHash: '0x390bcf459b105a1c372f7f33bc3256df50d89ee60e0ae33ed64ca482c6f4e044'
        },
        '1534437572650': {
            events: {},
            links: {},
            address: '0x64cbe099ea0b85867b95200e8da5e73a9a89da79',
            transactionHash: '0xe8d2bcb135c6c64629219f816e844d5ad74890026d72622a9ea0fdd7551ee113'
        }
    },
    schemaVersion: '2.0.0',
    updatedAt: '2018-07-09T17:13:55.017Z'
};
